<template>
    <div>
      <!-- 服务商 -->
      <div class="detail-wrap">
          <el-form ref="editForm" :model="tenant">
          <div class="d-header">
            <div class="fl">
              <i class="el-icon-info" />
              <!-- {{ dataId ? '查看' : '新增' }}工单 -->
              {{$t('common.WorkOrderNumber')}}：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.orderNo }}</span>
              <!-- 服务类型 -->
              <span class="information">{{ formData.serverTypeName }}</span>
              <!-- 工单状态 -->
              <span class="information" v-if="formData.stat == 1">{{$t('common.SignIn')}}</span>
              <span class="information" v-else-if="formData.stat == 2">{{$t('common.publish')}}</span>
              <span class="information" v-else-if="formData.stat == 3">{{$t('common.FreezePendingDispatch')}}</span>
              <span class="information" v-else-if="formData.stat == 5">{{$t('common.DispatchedNetwork')}}</span>
              <span class="information" v-else-if="formData.stat == 6">{{$t('common.TheNetworkReceivedOrders')}}</span>
              <span class="information" v-else-if="formData.stat == 9">{{$t('common.DispatchedMaster')}}</span>
              <span class="information" v-else-if="formData.stat == 10">{{$t('common.MasterHasAcceptedOrder')}}</span>
              <span class="information" v-else-if="formData.stat == 11">{{$t('common.HaveAlreadyReserved')}}</span>
              <span class="information" v-else-if="formData.stat == 13">{{$t('common.HaveSetOut')}}</span>
              <span class="information" v-else-if="formData.stat == 17">{{$t('common.HaveBeenDoor')}}</span>
              <span class="information" v-else-if="formData.stat == 20">{{$t('common.CompletedTemporaryHold')}}</span>
              <span class="information" v-else-if="formData.stat == 30">{{$t('common.ShippingRepairConfirmed')}}</span>
              <span class="information" v-else-if="formData.stat == 31">{{$t('common.ToBeSent')}}</span>
              <span class="information" v-else-if="formData.stat == 32">{{$t('common.HasBeenSignature')}}</span>
              <span class="information" v-else-if="formData.stat == 36">{{$t('common.ToBeRepaired')}}</span>
              <span class="information" v-else-if="formData.stat == 37">{{$t('common.RepairedToShip')}}</span>
              <span class="information" v-else-if="formData.stat == 38">{{$t('common.CustomerToBeSigned')}}</span>
              <span class="information" v-else-if="formData.stat == 40">{{$t('common.ReturnTBeConfirmed')}}</span>
              <span class="information" v-else-if="formData.stat == 41">{{$t('common.OldMachineReturned')}}</span>
              <span class="information" v-else-if="formData.stat == 42">{{$t('common.OldMachineSigned')}}</span>
              <span class="information" v-else-if="formData.stat == 43">{{$t('common.TheOldMachineSigned')}}</span>
              <span class="information" v-else-if="formData.stat == 44">{{$t('common.NewMachinesShipped')}}</span>
              <span class="information" v-else-if="formData.stat == 45">{{$t('common.NewMachinesSent')}}</span>
              <span class="information" v-else-if="formData.stat == 47">{{$t('common.NewMachineTSigned')}}</span>
              <span class="information" v-else-if="formData.stat == 48">{{$t('common.TheMachineSignedFor')}}</span>
              <span class="information" v-else-if="formData.stat == 49">{{$t('common.TheExchangeRejected')}}</span>
              <span class="information" v-else-if="formData.stat == 61">{{$t('common.completed')}}</span>
              <span class="information" v-else-if="formData.stat == 62">{{$t('common.NetworkConfirmationCompletion')}}</span>
              <span class="information" v-else-if="formData.stat == 63">{{$t('common.CenterCompletionAudit')}}</span>
              <span class="information" v-else-if="formData.stat == 64">{{$t('common.HeadquartersCompletionAudit')}}</span>
              <span class="information" v-else-if="formData.stat == 91">{{$t('common.ToBeSettled')}}</span>
              <span class="information" v-else-if="formData.stat == 92">{{$t('common.RejectionSettlement')}}</span>
              <span class="information" v-else-if="formData.stat == 93">{{$t('common.SettlementSuspension')}}</span>
              <span class="information" v-else-if="formData.stat == 94">{{$t('common.HaveAlreadySettled')}}</span>
              <!-- 申请关闭 -->
              <span class="information" v-else-if="formData.stat == 96">{{$t('common.ApplyForHangUp')}}</span>
              <span class="information" v-else-if="formData.stat == 97">{{$t('common.ApplyForClosure')}}</span>
              <span class="information" v-else-if="formData.stat == 98">{{$t('common.HangUp')}}</span>
              <span class="information" v-else-if="formData.stat == 99">{{$t('common.cancel')}}</span>
              <span class="information" v-else-if="formData.stat == 100">{{$t('common.finish')}}</span>
              <span class="information" v-else></span>
              <span class="information" style="color: red;background: rgba(255, 115, 28, 0.12)" v-if="formData.stat <60">工单时长:{{ orderDuration.days }}天 {{ orderDuration.hours }}小时</span>

  <!--            &lt;!&ndash; 紧急度 &ndash;&gt;-->
  <!--            <span class="information" v-if="formData.urger == 0">{{$t('common.normal')}}</span>-->
  <!--            <span class="information" v-else-if="formData.urger == 1">{{$t('common.exigency')}}</span>-->
  <!--            <span class="information" v-else-if="formData.urger == 2">{{$t('common.ExtraUrgent')}}</span>-->
  <!--            <span class="information" v-else>{{$t('common.unknown')}}</span>-->

              <span class="btn_f"
                v-if="formData.soOrderSpecialExtendDTO != null && formData.soOrderSpecialExtendDTO.riskTitleName && formData.soOrderSpecialExtendDTO.riskTitleName != '0'">{{
                  formData.soOrderSpecialExtendDTO.riskTitleName }}</span>
            </div>
            <slot name="right-button">
            </slot>
          </div>

          <div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane :label="$t('center.WorkOrderDetails')" name="first">
                <!-- 基本信息 -->
                <dix style="display: flex;  overflow: unset!important;overflow-y: scroll!important;height: 100vh!important; ">
                  <div class="d-cont edit-mce-box"  :style=" orderBlock ? 'width:80%': 'width:99%'">
                    <div class="d-item" style="padding-top: 10px;">
                      <!-- <div class="title first"><b>受理信息</b></div> -->
                      <table class="table-detail">
                        <tbody>

                          <tr>
                            <th>{{$t('common.userName')}}</th>
                            <td>{{ formData.userName }}</td>
                            <th>{{$t('common.contactNumber')}}</th>
                            <td>{{ formData.userMobile }}
                              <a href="javascript:void(0);" class="a-link" @click="showFamilyMobile()">
                                <span style="color: #2a6494;">更多</span>
                              </a>
                            </td>

                            <th>{{$t('common.UserType')}}</th>
                            <td v-if="formData.userType == 0">{{$t('common.OrdinaryUser')}}</td>
                            <td v-if="formData.userType == 1">{{$t('common.PreSaleMachine')}}</td>
                            <td v-if="formData.userType == 2">{{$t('common.Engineer')}}</td>
                            <td v-if="formData.userType == 3">{{$t('common.VipUser')}}</td>
                            <td v-if="formData.userType == 4">{{$t('common.dealer')}}</td>

                            <th>{{$t('common.UserFileNumber')}}</th>
                            <td>{{ formData.profileNo }}</td>

                          </tr>
                          <tr>
                            <!-- <th>用户单位</th>
                          <td>{{ formData.outOrderNo }}</td>
                          <th>合同号</th>
                          <td>{{ formData.outOrderNo }}</td> -->

                          </tr>
                          <tr>
                            <th>{{$t('common.DetailedAddress')}}</th>
                            <!-- <td style="width: 55vw!important;white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;position: absolute;"> -->
      <td colspan="5">
                              {{ formData.userProvice }}{{ formData.userCity }}{{
                                formData.userCounty
                              }}{{ formData.userTown }}{{ formData.userAddress }}
                            </td>
                            <th>产品大类</th>
                            <td>{{formData.categoryNames}}</td>
                          </tr>
                          <tr>
                            <th>报单原地址</th>
                            <td>{{ formData.userProvice }}{{ formData.userCity }}{{
                                formData.userCounty
                              }}{{ formData.userTown }}{{formData.userAddressOriginal}}</td>
                            <th>评分汇总</th>
                            <td>{{formData.totalScores}}</td>
                            <th>{{$t('common.overseer')}}</th>
                            <td>{{ formData.managerName }}</td>
                          </tr>
                          <tr>
                            <th>
                              {{$t('common.ServiceType')}}
                            </th>
                            <td>
                              {{ formData.serverTypeName }}
                            </td>
                            <th>{{$t('common.WarrantyType')}}</th>
                            <td v-if="formData.guaranteeType == 1"><span class="btn_t">{{$t('common.Paone')}}</span></td>
                            <td v-else-if="formData.guaranteeType == 2"><span class="btn_f">{{$t('common.outlaw')}}</span></td>
                            <td v-else-if="formData.guaranteeType == 3"><span class="btn_f">{{$t('common.unknown')}}</span></td>
                            <td v-else></td>


                            <th>{{$t('common.SourceWorkOrder')}}</th>
                            <td>{{ formData.orderTypeName }}</td>
                            <!-- <th>客诉类型</th>
                          <td>{{ formData.complaintTypeName }}</td> -->
                            <th>{{$t('common.PurchaseChannel')}}</th>
                            <td>{{ formData.buyChannelName }}</td>
                          </tr>
                          <tr>
                            <th>{{$t('common.BookingFault')}}</th>
                            <td>{{ formData.issueFaultName }}</td>
                            <th>{{$t('common.ExternalOrderNumber')}}</th>
                            <td>{{ formData.outOrderNo }}</td>
                            <!-- <th>购买时间</th>
                          <td>{{ formData.buyDate }}</td>
                          <th>购买商场</th>
                          <td>{{ formData.buyShop }}</td> -->
                            <th>{{$t('common.WorkOrderLabel')}}</th>
                            <td>{{ formData.dispatchStat }}</td>

                            <th>赛道</th>
                            <td v-if="formData.battleChannel == 1">线上渠道</td>
                            <td v-else-if="formData.battleChannel == 2">新零售</td>
                            <td v-else-if="formData.battleChannel == 3">线下渠道</td>
                            <td v-else></td>
                          </tr>
                          <tr>
                            <th>报单人姓名</th>
                            <td>{{ formData.businessName }}</td>
                            <th>报单人号码</th>
                            <td>{{ formData.businessMobile }}</td>
                            <th>报单人身份</th>
                            <td v-if="formData.businessTypeName == 1">信息员</td>
                            <td v-else-if="formData.businessTypeName == 2">工程师</td>
                            <td v-else-if="formData.businessTypeName == 3">导购员</td>
                            <td v-else-if="formData.businessTypeName == 4">店铺客服</td>
                            <td v-else-if="formData.businessTypeName == 9">其他</td>
                            <td v-else></td>
                            <th>报单档案号</th>
                            <td>{{ formData.businessNo }}</td>
                          </tr>
                          <tr>

                            <th>{{$t('common.ReturnVisitStatus')}}</th>
                            <td v-if="formData.recallStat == 0"><span class="btn_f">{{$t('common.NoReturnVisit')}}</span></td>
                            <td v-if="formData.recallStat == 1"><span class="btn_t">{{$t('common.sampled')}}</span></td>
                            <td v-if="formData.recallStat == 2"><span class="btn_t">{{$t('common.AlreadyVisited')}}</span></td>
                            <td v-if="formData.recallStat == 5"><span class="btn_t">{{$t('common.UserRated')}}</span></td>

                            <th>{{$t('common.HasAppealStatus')}}</th>
                            <td v-if="!formData.sfCheckBillDTOList||formData.sfCheckBillDTOList.length==0"><span class="btn_t">否</span></td>
                            <td v-if="formData.sfCheckBillDTOList.length>0"><span class="btn_t">是</span></td>
  <!--                          <td v-if="formData.siteComplainStat == 5"><span class="btn_t">已申诉</span></td>-->
  <!--                          <td v-if="formData.siteComplainStat == 7"><span class="btn_t">中心已审核</span></td>-->
  <!--                          <td v-if="formData.siteComplainStat == 8"><span class="btn_f">中心驳回</span></td>-->
  <!--                          <td v-if="formData.siteComplainStat == 9"><span class="btn_t">总部已处理</span></td>-->
  <!--                          <td v-if="formData.siteComplainStat == 99"><span class="btn_f">取消</span></td>-->

                            <th>{{$t('common.QualityInspectionStatus')}}</th>
                            <td v-if="formData.qualityStat == 0"><span class="btn_t">无需质检</span></td>
                            <td v-else-if="formData.qualityStat == 1"><span class="btn_f">待质检</span></td>
                            <td v-else-if="formData.qualityStat == 2"><span class="btn_t">质检通过</span></td>
                            <td v-else-if="formData.qualityStat == 3"><span class="btn_f">质检不通过</span></td>
                            <td v-else></td>
                            <th>{{$t('common.PartStatus')}}</th>
                            <td v-if="formData.partsStat == 0"><span class="btn_t">无配件</span></td>
                            <td v-if="formData.partsStat == 1"><span class="btn_t">申请</span></td>
                            <td v-if="formData.partsStat == 2"><span class="btn_t">审核</span></td>
                            <td v-if="formData.partsStat == 3"><span class="btn_t">出库</span></td>
                            <td v-if="formData.partsStat == 4"><span class="btn_t">网点收货</span></td>
                            <td v-if="formData.partsStat == 8"><span class="btn_f">驳回</span></td>
                            <td v-if="formData.partsStat == 9"><span class="btn_f">取消</span></td>
                            <td v-if="formData.partsStat == 11"><span class="btn_t">更换</span></td>
                            <td v-if="formData.partsStat == 12"><span class="btn_t">网点返厂</span></td>
                            <td v-if="formData.partsStat == 13"><span class="btn_t">返厂确认</span></td>
                          </tr>


                          <tr style="height:25px;">


                            <th>{{$t('common.appeal')}}</th>
  <!--                          <td style="width: 55vw!important;white-space: nowrap;position: absolute;top: 6px;
      overflow: hidden;
      text-overflow: ellipsis;">{{ formData.appeals }}
                            </td>-->
                            <td colspan="7"><el-input  type="textarea"
                                       :autosize="{ minRows: 2, maxRows:4}"  style="white-space: nowrap;" readonly
                                       v-model="formData.appeals" clearable>
                              <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                            </el-input></td>
                          </tr>

                          <tr>

                          </tr>


                        </tbody>
                      </table>
                    </div>
                    <div class="d-item" style="padding-top: 10px;">
                      <!-- <div class="title first"><b>受理信息</b></div> -->
                      <table class="table-detail">
                        <tbody>

                          <tr>
                            <th>{{$t('common.OrganizationName')}}</th>
                            <td>{{ formData.orgName }}</td>
                            <th>{{$t('common.TierServiceProvider')}}</th>
                            <td>{{ formData.bigSiteName }}</td>
                            <th>{{$t('common.NetworkName')}}</th>
                            <td>{{ formData.siteName }}</td>
                            <th>{{$t('common.EngineerName')}}</th>
                            <td>{{ formData.engineerName }}</td>
                            <!-- <th>督办人</th>
                          <td>{{ formData.engineerName }}</td> -->
                          </tr>
                          <tr>

                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- 集合 -->

                    <div class="d-item" style="margin-top: 10px;margin-top: 10px;">
                      <table class="table-detail" style="width: 100%;display: inline-block;">
                        <tbody style="width: 100%;display: inline-block;">
                          <template>
                            <el-tabs v-model="activeName2" style="width: 100%;display: inline-block;" class="gather">
                              <el-tab-pane :label="$t('center.NodeDiagram')" name="first">
                                <div style="margin-top: 10px;">
                                  <el-steps :active="timeSeq" align-center finish-status="success"
                                    v-if="formData.timeSequences" style="margin-bottom: 10px;">
                                    <el-step :title="item.processName" :description="item.processDate" :key="item.index"
                                      v-for="item in formData.timeSequences"></el-step>
                                    <!--                                  <el-step title="发布工单" description="2022-10-12 12:00"></el-step>-->
                                    <!--                                  <el-step title="派工到人" description="2022-10-13 09:00"></el-step>-->
                                    <!--                                  <el-step title="首约" description="2022-10-14 10:00"></el-step>-->
                                    <!--                                  <el-step title="终约" description="2022-10-15 11:00"></el-step>-->
                                    <!--                                  &lt;!&ndash; <el-step title="上门签到" description="2022-10-12 12:00"></el-step> &ndash;&gt;-->
                                    <!--                                  <el-step title="申请配件" description="2022-10-16 12:00"></el-step>-->
                                    <!--                                  <el-step title="上门签到" description="2022-10-17 10:00"></el-step>-->
                                    <!--                                  <el-step title="完工" description="2022-10-18 11:00"></el-step>-->
                                    <!--                                  <el-step title="用户评价" description="2022-10-19 12:00"></el-step>-->
                                    <!--                                  <el-step title="结算申请" description="2022-10-20 12:00"></el-step>-->

                                  </el-steps>
                                  <tr style="margin-top: 10px;">
                                    <th>{{$t('center.CreationTime')}}</th>
                                    <td>{{ formData.createTime }}</td>

                                    <th>{{$t('center.DispatchCenterTime')}}</th>
                                    <td>{{ formData.soOrderProcessDTO.takeOrgTime }}</td>

                                    <th>{{$t('center.OrderDeliveryTime')}}</th>
                                    <td>{{ formData.takeTime }}</td>



                                    <th>{{$t('center.EngineerTime')}}</th>
                                    <td>{{ formData.takeEngineerTime }}</td>
                                  </tr>
                                  <tr>
                                    <th>{{$t('center.TheNetworkConfirmsRReceivingTime')}}</th>
                                    <td>{{ formData.soOrderProcessDTO.acceptOperateTime }}</td>
                                    <th>
                                      {{$t('center.TheEngineerConfirmsReceivingTime')}}
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.engineerAcceptOperateTime }}
                                    </td>
                                    <th>工程师</th>
                                    <td>{{ formData.engineerName }}</td>
                                    <th>工程师电话</th>
                                    <td>{{ formData.engineerMobile }}</td>
                                  </tr>
                                  <tr>
                                    <th>
                                      {{$t('center.ScheduleFirstOperationTime')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.firstBookOperateTime }}
                                    </td>
                                    <th>
                                      {{$t('center.FirstAppointmentTime')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.firstBookDate }}
                                    </td>
                                    <th>
                                      {{$t('center.ScheduledOperationTime')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.bookOperateTime }}
                                    </td>
                                    <th>
                                      预约时间

                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.bookDate!=null">
                                      {{ formData.soOrderProcessDTO.bookDate }}
                                      {{ formData.soOrderProcessDTO.bookDatePeriod }}
                                    </td>
                                    <td v-else>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>
                                      首次终约操作时间
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.firstBookTerminationOperateTime }}
                                    </td>
                                    <th>
                                      首次终约时间
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.firstBookTerminationDate }}
                                    </td>

                                    <th>
                                      {{$t('center.reschedule')}}
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.changeAppointmentDate!=null">
                                      {{ formData.soOrderProcessDTO.changeAppointmentDate }}
                                      {{ formData.soOrderProcessDTO.bookDatePeriod }}
                                    </td>
                                    <td v-else>
                                    </td>

                                    <th>
                                      {{$t('center.NumberAppointments')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.bookTimes }}
                                    </td>

                                  </tr>
                                  <tr>
                                    <th>
                                      {{$t('center.ReasonRescheduling')}}
                                    </th>
                                    <td colspan="5">
                                      <dict-value-show :id="formData.soOrderProcessDTO.changeBookReason" />
                                      <!--                                    {{ formData.soOrderProcessDTO.changeBookReasonName }}-->
                                    </td>
                                    <th>预约时段</th>
                                    <td v-if="formData.soOrderProcessDTO && formData.soOrderProcessDTO.bookSlot == 1">8:00-10:00</td>
                                    <td v-if="formData.soOrderProcessDTO && formData.soOrderProcessDTO.bookSlot == 2">10:00-12:00</td>
                                    <td v-if="formData.soOrderProcessDTO && formData.soOrderProcessDTO.bookSlot == 3">12:00-14:00</td>
                                    <td v-if="formData.soOrderProcessDTO && formData.soOrderProcessDTO.bookSlot == 4">14:00-16:00</td>
                                    <td v-if="formData.soOrderProcessDTO && formData.soOrderProcessDTO.bookSlot == 5">16:00-18:00</td>
                                    <td v-if="formData.soOrderProcessDTO && formData.soOrderProcessDTO.bookSlot == 6">18:00-20:00</td>
                                    <td v-if="formData.soOrderProcessDTO && formData.soOrderProcessDTO.bookSlot == 7">20:00-24:00</td>
                                  </tr>
                                  <tr>
                                    <th>
                                      {{$t('center.DepartureTime')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.startOffTime }}
                                    </td>
                                    <th>
                                      {{$t('center.WalkInTime')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.onDoorTime }}
                                    </td>
                                    <th>
                                      {{$t('center.CheckAddress')}}

                                    </th>
                                    <td colspan="3">
                                      {{ formData.soOrderProcessDTO.onDoorLocation }}
                                    </td>
                                  </tr>
                                  <tr>

                                    <th>
                                      {{$t('center.FirstCompletionTime')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.firstCompleteTime }}
                                    </td>
                                    <th>
                                      {{$t('center.TimeCompletion')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.completeTime }}
                                    </td>
                                    <th>
                                      {{$t('center.CompletionAddress')}}

                                    </th>
                                    <td colspan="3">
                                      {{ formData.soOrderProcessDTO.onTimeLocation }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>
                                      {{$t('center.TheNetworkConfirmsCompletionTime')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.siteComfirmTime }}
                                    </td>
                                    <th>
                                      {{$t('center.TheCenterConfirmsCompletionTime')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.orgComfirmTime }}
                                    </td>
                                    <th>
                                      {{$t('center.HeadquartersConfirmedCompletionTime')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.officeComfirmTime }}
                                    </td>
                                    <th>
                                      {{$t('center.ReturnTime')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.recallTime }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>
                                      {{$t('center.FollowUpTimes')}}

                                    </th>
                                    <td colspan="">
                                      {{ formData.soOrderProcessDTO.complaintProcessTimes }}
                                    </td>
                                    <th>
                                      {{$t('center.FollowUpPeople')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.complaintProcesser }}
                                    </td>
                                    <th>
                                      {{$t('center.FollowUpTime')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.complaintProcessDate }}
                                    </td>
                                    <th>
                                      {{$t('center.NetworkFollowTime')}}

                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.siteComplaintProcessDate }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>
                                      {{$t('center.CancellationRefundTime')}}
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.cancleDate }}
                                    </td>
                                    <th>
                                      {{$t('center.ReasonsCancellationRefund')}}
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.returnName }}
                                      <!--                            <el-input type="text" autocomplete="off" v-model="tenant.orgName" clearable/>-->
                                    </td>
                                    <th>
                                      {{$t('center.CompletionAuditRemarks')}}
                                    </th>
                                    <td colspan="3">
                                      {{ formData.soOrderProcessDTO.comfirmNote }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>
                                      挂起时间
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.hangupDate }}
                                      <!--                            <el-input type="text" autocomplete="off" v-model="tenant.orgName" clearable/>-->
                                    </td>
                                    <th>
                                      挂起原因
                                    </th>
                                    <td>
                                      {{ formData.soOrderExtendDTO.hangupReason }}
                                      <!--                            <el-input type="text" autocomplete="off" v-model="tenant.orgName" clearable/>-->
                                    </td>
                                    <th>
                                      总部挂起次数
                                    </th>
                                    <td colspan="3">
                                      {{ formData.soOrderProcessDTO.hangupTims }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>
                                      申请挂起时间
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.applyHangupDate }}
                                    </td>
                                    <th>
                                      申请取消时间
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.applyCancelDate }}
                                    </td>
                                    <th>
                                      取消类型
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.cancleFrom == 1">网点取消</td>
                                    <td v-else-if="formData.soOrderProcessDTO.cancleFrom == 2">总部取消</td>
                                    <td v-else></td>
                                    <th>
                                      下次联系时间
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.nextContactTime }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>
                                      完工驳回次数
                                    </th>
                                    <td>
                                      {{ formData.rejectFinishTimes }}
                                    </td>
                                    <th>
                                      派工到人状态
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.autoEngineerSuccess == 1">
                                      成功
                                    </td>
                                    <td v-if="formData.soOrderProcessDTO.autoEngineerSuccess == 2">
                                      失败
                                    </td>
                                    <th>
                                      失败原因
                                    </th>
                                    <td>
                                      {{formData.soOrderProcessDTO.autoEngineerFailReason}}
                                    </td>
                                  </tr>


                                  <tr>
                                    <th>
                                      服务完成确认
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.custComfirmStat == 0">未确认</td>
                                    <td v-else-if="formData.soOrderProcessDTO.custComfirmStat == 1">异常确认</td>
                                    <td v-else-if="formData.soOrderProcessDTO.custComfirmStat == 5">已确认</td>
                                    <td v-else></td>
                                    <th>
                                      是否已推送用户确认消息
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.custComfirmWxPush == 0">否</td>
                                    <td v-else-if="formData.soOrderProcessDTO.custComfirmWxPush == 1">是</td>
                                    <td v-else></td>
                                    <th>
                                      是否已推送用户确认短信
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.custComfirmDxPush == 0">否</td>
                                    <td v-else-if="formData.soOrderProcessDTO.custComfirmDxPush == 1">是</td>
                                    <td v-else></td>
                                    <th>
                                      用户确认方式
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.custComfirmType == 1">微信确认完工</td>
                                    <td v-else-if="formData.soOrderProcessDTO.custComfirmType == 2">总部视频确认</td>
                                    <td v-else-if="formData.soOrderProcessDTO.custComfirmType == 3">用户现场确认</td>
                                    <td v-else></td>
                                  </tr>

                                  <tr>
                                    <th>
                                      用户确认结果
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.custComfirmResult == 1">服务未完成</td>
                                    <td v-else-if="formData.soOrderProcessDTO.custComfirmResult == 2">服务确认完成</td>
                                    <td v-else></td>
                                    <th>
                                      异常确认处理
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.custComfirmException == 1">待处理</td>
                                    <td v-else-if="formData.soOrderProcessDTO.custComfirmException == 2">已处理</td>
                                    <td v-else></td>
                                    <th>
                                      异常确认处理备注
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.custComfirmExceptionDeal }}
                                    </td>
                                    <th>
                                      无法确认原因
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.custComfirmNotReasonName }}
                                    </td>
                                  </tr>

                                  <tr>
                                    <th>
                                      现场人电话
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.custComfirmMobile }}
                                    </td>
                                    <th>
                                      添加号码原因
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.custComfirmMobileReasonName }}
                                    </td>
                                    <th>
                                      完工人电话
                                    </th>
                                    <td>
                                      {{ formData.soOrderResultDTO.finishPhone }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>
                                      打卡状态
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.onDoorStat == 1">
                                      正常打卡
                                    </td>
                                    <td v-if="formData.soOrderProcessDTO.onDoorStat == 2">
                                      异常打卡
                                    </td>
                                    <td v-else>未打卡</td>
                                    <th>
                                      上门签到凭证
                                    </th>
                                    <td>
                                      <div v-if="formData.soOrderProcessDTO.onDoorAttachment">
                                        <span class="fuJian" v-if="true">
                                        <span @click="openVideo(formData.soOrderProcessDTO.onDoorAttachment)">
                                        签到凭证</span>
                                        <span @click="handleDownload(formData.orderNo +'签到凭证', formData.soOrderProcessDTO.onDoorAttachment)">
                                          <i class="el-icon-download"></i></span>
                                      </span>
                                      </div>
                                      <div v-else></div>
                                    </td>
                                  </tr>
                                </div>
                              </el-tab-pane>
                              <!-- <el-tab-pane label="用户安装环境" name="twelve"> -->
                              <el-tab-pane label="用户安装环境" name="twelve" style="max-height: 450px;position: relative;overflow-y: scroll;">
                                <div style="border: 1px solid rgb(242, 242, 242);margin-bottom: 15px;">
                                  <tr>
                                    <th>
                                      是否到货
                                    </th>
                                    <!-- <td v-if="formData.soOrderEnvironmentDTO.shifouDaohuo == null"></td> -->
                                    <td v-if="formData.soOrderEnvironmentDTO.shifouDaohuo == 1">否</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouDaohuo == 2">是</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouDaohuo == 3">不清楚</td>
                                    <td v-else></td>
                                    <th>
                                      到货时间
                                    </th>
                                    <td v-if="formData.soOrderEnvironmentDTO.daohuoShijian == 1">3天内</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.daohuoShijian == 2">3-7天</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.daohuoShijian == 2">7天以上</td>
                                    <td v-else></td>
                                    <th>
                                      环境类型
                                    </th>
                                    <!-- <td v-if="formData.soOrderEnvironmentDTOList.environmentType == null"></td> -->
                                    <td v-if="formData.soOrderEnvironmentDTO.environmentType == 1">新房安装</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.environmentType == 2">旧房改造</td>
                                    <td v-else></td>
                                    <th>
                                      是否已开孔
                                    </th>
                                    <!-- <td v-if="formData.soOrderEnvironmentDTOList.shifouYikaikong == null"></td> -->
                                    <td v-if="formData.soOrderEnvironmentDTO.shifouYikaikong == 1">否</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouYikaikong == 2">是</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouYikaikong == 3">不清楚</td>
                                    <td v-else></td>
                                  </tr>
                                  <tr>
                                    <th>
                                      是否需打扩孔
                                    </th>
                                    <!-- <td v-if="formData.soOrderEnvironmentDTOList.shifouDakuokong == null"></td> -->
                                    <td v-if="formData.soOrderEnvironmentDTO.shifouDakuokong == 1">否</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouDakuokong == 2">是</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouDakuokong == 3">不清楚</td>
                                    <td v-else></td>
                                    <th>
                                      是否接受收费
                                    </th>
                                    <!-- <td v-if="formData.soOrderEnvironmentDTOList.shifouJieshoushoufei == null"></td> -->
                                    <td v-if="formData.soOrderEnvironmentDTO.shifouJieshoushoufei == 1">否</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouJieshoushoufei == 2">是</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouJieshoushoufei == 3">联系确认</td>
                                    <td v-else></td>

                                    <th>
                                      是否做好橱柜
                                    </th>
                                    <!-- <td v-if="formData.soOrderEnvironmentDTOList.shifouZuohaochugui == null"></td> -->
                                    <td v-if="formData.soOrderEnvironmentDTO.shifouZuohaochugui == 1">否</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouZuohaochugui == 2">是</td>
                                    <td v-else></td>

                                    <th>
                                      是否带地线
                                    </th>
                                    <!-- <td v-if="formData.soOrderEnvironmentDTOList.shifouDaidixian == null"></td> -->
                                    <td v-if="formData.soOrderEnvironmentDTO.shifouDaidixian == 1">否</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouDaidixian == 2">是</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouDaidixian == 3">不清楚</td>
                                    <td v-else></td>
                                  </tr>
                                  <tr>
                                    <th>
                                      是否已通水路
                                    </th>
                                    <!-- <td v-if="formData.soOrderEnvironmentDTOList.shifouTongshuilu == null"></td> -->
                                    <td v-if="formData.soOrderEnvironmentDTO.shifouTongshuilu == 1">否</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouTongshuilu == 2">是</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouTongshuilu == 3">不清楚</td>
                                    <td v-else></td>
                                    <th>
                                      是否已通气
                                    </th>
                                    <!-- <td v-if="formData.soOrderEnvironmentDTOList.shifouTongqi == null"></td> -->
                                    <td v-if="formData.soOrderEnvironmentDTO.shifouTongqi == 1">否</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouTongqi == 2">是</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouTongqi == 3">不清楚</td>
                                    <td v-else></td>
                                    <th>
                                      是否已通电
                                    </th>
                                    <!-- <td v-if="formData.soOrderEnvironmentDTOList.shifouTongdian == null"></td> -->
                                    <td v-if="formData.soOrderEnvironmentDTO.shifouTongdian == 1">否</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouTongdian == 2">是</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouTongdian == 3">不清楚</td>
                                    <td v-else></td>
                                    <th>
                                      安装位置
                                    </th>
                                    <!-- <td v-if="formData.soOrderEnvironmentDTOList.anzhuangWeizhi == null"></td> -->
                                    <td v-if="formData.soOrderEnvironmentDTO.anzhuangWeizhi == 1">厨房</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.anzhuangWeizhi == 2">阳台</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.anzhuangWeizhi == 3">其他</td>
                                    <td v-else></td>
                                  </tr>
                                  <tr>
                                    <th>
                                      是否有排水口
                                    </th>
                                    <!-- <td v-if="formData.soOrderEnvironmentDTOList.shifouYoupaishuikou == null"></td> -->
                                    <td v-if="formData.soOrderEnvironmentDTO.shifouYoupaishuikou == 1">否</td>
                                    <td v-else-if="formData.soOrderEnvironmentDTO.shifouYoupaishuikou == 2">是</td>
                                    <td v-else></td>
                                  </tr>
                                  <tr style="height: 80px;">
                                    <th>附件列表</th>
                                    <td style="display: flex; height: 80px" colspan="7">
                                      <div style="display:flex; margin-right: 20px; height: 60px">
                                        <el-image v-if="formData.soOrderEnvironmentDTO.environmentFile1" :preview-src-list="showEnvironmentFile" fit="fit"
                                                  :src="formData.soOrderEnvironmentDTO.environmentFile1" :initial-index="0" style="margin-bottom: 10px;"></el-image>
                                        <el-image v-else>
                                          <div slot="error" class="image-slot">
                                            <i class="el-icon-picture-outline"
                                               style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                          </div>
                                        </el-image>
                                      </div>

                                      <div style="display:flex; margin-right: 20px; height: 60px">
                                        <el-image v-if="formData.soOrderEnvironmentDTO.environmentFile2" :preview-src-list="showEnvironmentFile" fit="fit"
                                                  :src="formData.soOrderEnvironmentDTO.environmentFile2" :initial-index="1"></el-image>
                                        <el-image v-else>
                                          <div slot="error" class="image-slot">
                                            <i class="el-icon-picture-outline"
                                               style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                          </div>
                                        </el-image>
                                      </div>

                                      <div style="display:flex; margin-right: 20px; height: 60px">
                                        <el-image v-if="formData.soOrderEnvironmentDTO.environmentFile3" :preview-src-list="showEnvironmentFile" fit="fit"
                                                  :src="formData.soOrderEnvironmentDTO.environmentFile3" :initial-index="2"></el-image>
                                        <el-image v-else>
                                          <div slot="error" class="image-slot">
                                            <i class="el-icon-picture-outline"
                                               style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                          </div>
                                        </el-image>
                                      </div>
                                    </td>
                                  </tr>
                                </div>
                              </el-tab-pane>
                              <el-tab-pane :label="$t('center.AssessmentSheet')" name="third-1" class="product">
                                <div class="product" style="width:px">
                                  <vxe-table ref="filterTable" :data="formData.sfCheckBillDTOList" class="table_item"
                                    style="margin: 12px auto; width: 95%;" :stripe="true"
                                    :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                    :row-config="{ height: 30, isHover: true, padding: 0, }"
                                    :row-style="{ fontSize: '12px', }" show-overflow height="250"
                                    :column-config="{ resizable: true }">
                                    <!--                        <vxe-column type="selection" width="55">-->
                                    <!--                        </vxe-column>-->
                                    <vxe-column field="billNo"  :title="$t('center.CheckNumber')" width="120" />
                                    <!--                                <vxe-column field="siteName" title="网点名称" width="70"/>-->
                                    <vxe-column field="stat"  :title="$t('common.status')" width="70" />
                                    <vxe-column field="orgName"  :title="$t('common.ServiceCenter')" width="110" />
                                    <vxe-column field="siteName"  :title="$t('common.ServiceProvider')" width="110" />
                                    <vxe-column field="checkSubjectName" :title="$t('center.AssessmentCategory')" width="140" />
                                    <vxe-column field="standardAmount" :title="$t('center.AssessmentAmount')" width="130" />
                                    <vxe-column field="adjustAmount" :title="$t('center.AdjustmentAmount')" width="130" />
                                    <vxe-column field="amount" :title="$t('center.TotalAmount')" width="110" />
                                    <vxe-column field="checkAmount" :title="$t('center.ApprovedAmount')" width="130" />
                                    <vxe-column field="isAbandon" :title="$t('center.WhetherOverdueBeenAppealed')" width="250" />
                                    <!-- <vxe-column field="createBy" title="创建人" width="70"/>
                                  <vxe-column field="createTime" title="创建时间" width="120"/> -->
                                  </vxe-table>
                                </div>
                              </el-tab-pane>
                              <el-tab-pane
                                v-if="formData.serverTypeName.includes('投诉') || formData.serverTypeName.includes('咨询') || formData.serverTypeName.includes('表扬')"
                                :label="$t('center.CustomerComplaintConsultation')" name="second">
                                <tr>
                                  <p class="title_p">{{$t('center.ComplaintInformation')}}</p>
                                </tr>
                                <tr>
                                  <th>{{$t('center.ObjectComplaint')}}</th>
                                  <td>{{ formData.soOrderExtendDTO.complaintObjectName }}</td>

                                  <th>{{$t('center.NatureComplaint')}}</th>
                                  <td>
                                    <dict-value-show :id="formData.soOrderExtendDTO.complaintProperty" />
                                  </td>
                                  <!--                              <td>{{ formData.soOrderExtendDTO.complaintPropertyName }}</td>-->

                                  <th>{{$t('center.WhetherTransferOrderInternally')}}</th>
                                  <td v-if="formData.soOrderExtendDTO.isIntransfer == 0"><span class="btn_f">否</span></td>
                                  <td v-else-if="formData.soOrderExtendDTO.isIntransfer == 1"><span class="btn_t">是</span>
                                  </td>
                                  <td v-else></td>

                                  <th>{{$t('center.ComplaintHandledSatisfactorily')}}</th>
                                  <td v-if="formData.soOrderExtendDTO.dealSatisfaction == 0"><span class="btn_f">否</span>
                                  </td>
                                  <td v-else-if="formData.soOrderExtendDTO.dealSatisfaction == 1"><span
                                      class="btn_t">是</span>
                                  </td>
                                  <td v-else></td>
                                </tr>
                                <tr>
                                  <th>{{$t('center.LiabilityJudgment')}}</th>
                                  <td>
                                    <dict-value-show :id="formData.soOrderExtendDTO.dutyJudge" />
                                  </td>
                                  <!--                              <td>{{ formData.soOrderExtendDTO.dutyJudgeName }}</td>-->
                                  <th>{{$t('center.SubdivisionResponsibility')}}</th>
                                  <td>
                                    <dict-value-show :id="formData.soOrderExtendDTO.dutyJudgeSub" />
                                  </td>
                                  <!--                              <td>{{ formData.soOrderExtendDTO.dutyJudgeSubName }}</td>-->
                                  <th>{{$t('center.ProcessingMode')}}</th>
                                  <td>
                                    <dict-value-show :id="formData.soOrderExtendDTO.handleModel" />
                                  </td>
                                  <!--                              <td>{{ formData.soOrderExtendDTO.handleModelName }}</td>-->

                                </tr>
                                <tr>
                                  <th>
                                    {{$t('center.TreatmentScheme')}}
                                  </th>
                                  <td colspan="7">
                                    {{ formData.soOrderExtendDTO.handlePlan }}
                                  </td>
                                </tr>
                                <tr>
                                  <p class="title_p">{{$t('center.AdvicePraise')}}</p>
                                </tr>

                                <tr>
                                  <th>
                                    待回复
                                  </th>
                                  <td v-if="formData.waitReply == 1">否</td>
                                  <td v-else-if="formData.waitReply == 2">是</td>
                                  <th>
                                    待回复日期
                                  </th>
                                  <td>
                                    {{ formData.waitReplyDate }}
                                  </td>
                                  <th>
                                    待回复时间
                                  </th>
                                  <td>
                                    {{ formData.waitReplyPeriod }}
                                  </td>
                                  <th>
                                    投诉对象类型
                                  </th>
                                  <td v-if="formData.soOrderExtendDTO.complaintObjectType == 1">服务商</td>
                                  <td v-else-if="formData.soOrderExtendDTO.complaintObjectType == 2">店铺</td>
                                  <td v-else-if="formData.soOrderExtendDTO.complaintObjectType == 3">员工</td>
                                </tr>

                                <tr>
                                  <th>{{$t('center.ObjectPraise')}}</th>
                                  <td>
                                    {{ formData.soOrderExtendDTO.praiseObjectName }}
                                  </td>
                                  <th>{{$t('center.TypePraise')}}</th>
                                  <td>
                                    <dict-value-show :id="formData.soOrderExtendDTO.praiseType" />
                                  </td>
                                  <th>{{$t('center.WhetherPraiseStands')}}</th>
                                  <td v-if="formData.soOrderExtendDTO.praiseJudge == 0"><span class="btn_f">否</span></td>
                                  <td v-else-if="formData.soOrderExtendDTO.praiseJudge == 1"><span class="btn_t">是</span>
                                  </td>
                                  <td v-else></td>
                                  <th>{{$t('center.WhetherRewardValid')}}</th>
                                  <td v-if="formData.soOrderExtendDTO.rewardJudge == 0"><span class="btn_f">否</span></td>
                                  <td v-else-if="formData.soOrderExtendDTO.rewardJudge == 1"><span class="btn_t">是</span>
                                  </td>
                                  <td v-else></td>
                                </tr>
                                <tr>
                                  <th>咨询对象</th>
                                  <td v-if="formData.soOrderExtendDTO.consultUser == 1"><span class="btn_f">服务商</span></td>
                                  <td v-else-if="formData.soOrderExtendDTO.consultUser == 2"><span class="btn_t">电商</span>
                                  <td v-else-if="formData.soOrderExtendDTO.consultUser == 3"><span class="btn_t">华帝股份</span>
                                  <td v-else></td>
                                  <th>{{$t('center.TypeConsultation')}}</th>
                                  <td>
                                      <dict-value-show :id="formData.soOrderExtendDTO.consultType" />
                                  </td>
                                  <!--                              <td>{{ formData.soOrderExtendDTO.consultTypeName }}</td>-->
                                  <th>{{$t('center.ConsultingSegmentation')}}</th>
                                  <td>
                                    <dict-value-show :id="formData.soOrderExtendDTO.consultTypeSub" />
                                  </td>
                                  <th>{{$t('center.ConsultingLabel')}}</th>
                                  <td>
                                    <dict-value-show :id="formData.soOrderExtendDTO.consultTypeSub2" />
                                  </td>
                              </tr>


                              </el-tab-pane>
                              <el-tab-pane :label="$t('center.ProductInformation')" name="third" class="product">
                                <div class="product" style="">
                                  <vxe-table ref="filterTable" :data="formData.soOrderLineDTOList" class="table_item"
                                    style="margin:12px auto; width: 95%;" :stripe="true"
                                    :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                    :row-config="{ height: 30, isHover: true, padding: 0, }"
                                    :row-style="{ fontSize: '12px', }" show-overflow height="250"
                                    :column-config="{ resizable: true }">
                                    <vxe-column type="seq" width="30">
                                    </vxe-column>
                                    <vxe-column field="brandName" :title="$t('common.brand')" />
                                    <vxe-column field="oldBrandName" title="旧机品牌" />
                                    <vxe-column field="isBuy" title="是否已购买" width="100px">
                                      <template #default="{row}">
                                        <span v-if="row.isBuy==0">否</span>
                                        <span v-else-if="row.isBuy==1">是</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="itemCode" :title="$t('common.ProductCode')">
                                    </vxe-column>
                                    <vxe-column field="itemName" :title="$t('common.ProductName')" />
                                    <vxe-column field="bigCategoryName" :title="$t('common.ProductCategory')" />
                                    <vxe-column field="smallCategoryName" :title="$t('common.ProductSubclass')" />
                                    <vxe-column field="buyShop" :title="$t('common.ShoppingMall')" />
                                    <vxe-column field="buyDate" :title="$t('common.PurchaseTime')" />
                                    <vxe-column field="barcode" :title="$t('common.BarCode')">
                                    </vxe-column>
                                    <vxe-column field="qty" :title="$t('common.quantity')" width="80">
                                    </vxe-column>
  <!--                                  <vxe-column field="sitePrice" :title="$t('common.ServiceChargeUnitPrice')" width="200" />-->
                                    <vxe-column field="sitePrice" :title="$t('common.ServiceChargeUnitPrice')" width="200">
                                      <template #default="{row}">
                                        <span v-if="isSite">*</span>
                                        <span v-else>{{ row.sitePrice }}</span>
                                      </template>
                                    </vxe-column>
  <!--                                  <vxe-column field="siteFee" :title="$t('common.ServiceCharge')" width="100" />-->

                                    <vxe-column field="siteFee" :title="$t('common.ServiceCharge')" width="100">
                                      <template #default="{row}">
                                        <span v-if="isSite">*</span>
                                        <span v-else>{{ row.siteFee }}</span>
                                      </template>
                                    </vxe-column>

                                    <!-- 附件 -->
                                    <vxe-column field="file1Name" title="条码图" width="100">
                                      <template #default="{row}">
                                        <span class="fuJian" v-if="row.fixPic1"><span @click="openVideo(row.fixPic1)">条码图</span> <span @click="handleDownload('条码图',row.fixPic1)"><i class="el-icon-download"></i></span></span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="file2Name" title="现场图" width="100">
                                      <template #default="{row}">
                                        <span class="fuJian" v-if="row.fixPic2"><span @click="openVideo(row.fixPic2)">现场图</span> <span @click="handleDownload('现场图',row.fixPic2)"><i class="el-icon-download"></i></span></span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="file3Name" title="整机图" width="100">
                                      <template #default="{row}">
                                        <span class="fuJian" v-if="row.fixPic3"><span @click="openVideo(row.fixPic3)">整机图</span> <span @click="handleDownload('整机图',row.fixPic3)"><i class="el-icon-download"></i></span></span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                  </vxe-table>
                                </div>
                              </el-tab-pane>
                              <el-tab-pane :label="$t('center.RelatedDocuments')" name="fourth">
                                <div class="product" style="">
                                  <vxe-table ref="filterTable" :data="formData.associateDocuments" class="table_item"
                                    style="margin: 12px auto; width: 95%;" :stripe="true"
                                    :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                    :row-config="{ height: 30, isHover: true, padding: 0, }"
                                    :row-style="{ fontSize: '12px', }" show-overflow height="250"
                                    :column-config="{ resizable: true }">
                                    <vxe-column field="type" :title="$t('common.DocumentType')" width="120" />
                                    <vxe-column field="documentNumber" :title="$t('common.DocumentNumber')" width="200">
                                      <template #default="{ row }">
                                        <span style="cursor: pointer; color: blue"
                                          @click="openDocumentNumber(row.type, row.id,row)">{{ row.documentNumber }}</span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="createTime" :title="$t('common.CreationTime')" width="100" />
                                    <vxe-column field="statName" :title="$t('common.status')" width="150" />
                                    <vxe-column field="createBy" :title="$t('common.founder')" width="150" />
                                  </vxe-table>
                                </div>
                                <!-- <tr>
                                  <th style="position: absolute;top: 34px;">上门签到</th>
                                  <div style="display: flex;position: absolute;left:8vw;top:10px;">
                                    <el-image v-if="formData.pic1" :preview-src-list="picList" :fit="fit"
                                      :src="formData.pic1" :initial-index="0"></el-image>
                                    <el-image v-else>
                                      <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"
                                          style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                      </div>
                                    </el-image>

                                  </div>

                                </tr> -->
                                <!-- <tr>
                                  <th style="position: absolute;top: 124px;">现场照片</th>
                                  <div style="display: flex;position: absolute;left:8vw;top:100px;">
                                    <el-image v-if="formData.pic1" :preview-src-list="picList" :fit="fit"
                                      :src="formData.pic1" :initial-index="0"></el-image>
                                    <el-image v-else>
                                      <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"
                                          style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                      </div>
                                    </el-image>

                                  </div>

                                </tr>
                                <tr>
                                  <th style="position: absolute;top: 214px;">修复照片</th>
                                  <div style="display: flex;position: absolute;left:8vw;top:190px;">
                                    <el-image v-if="formData.pic1" :preview-src-list="picList" :fit="fit"
                                      :src="formData.pic1" :initial-index="0"></el-image>
                                    <el-image v-else>
                                      <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"
                                          style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                      </div>
                                    </el-image>

                                  </div>

                                </tr> -->
                              </el-tab-pane>
                              <el-tab-pane :label="$t('center.BusinessInformation')" name="five">
                                <tr>
                                  <th>{{$t('center.MustVisit')}}</th>
                                  <td v-if="formData.isMustRecall == 0"><span class="btn_f">否</span></td>
                                  <td v-else-if="formData.isMustRecall == 1"><span class="btn_t">是</span></td>
                                  <td v-else></td>

                                  <th>{{$t('center.SamplabilityNot')}}</th>
                                  <td v-if="formData.isCallRecall == 0"><span class="btn_f">否</span></td>
                                  <td v-else-if="formData.isCallRecall == 1"><span class="btn_t">是</span></td>
                                  <td v-else></td>

                                  <th>{{$t('center.UrgentOrderNot')}}</th>
                                  <td v-if="formData.isUrgent == 0"><span class="btn_f">否</span></td>
                                  <td v-else-if="formData.isUrgent == 1"><span class="btn_t">是</span></td>
                                  <td v-else></td>

                                  <th>{{$t('center.WhetherFinishAgainNot')}}</th>
                                  <td v-if="formData.isReplaceFinish == 0"><span class="btn_f">否</span></td>
                                  <td v-else-if="formData.isReplaceFinish == 1"><span class="btn_t">是</span></td>
                                  <td v-else></td>


                                </tr>
                                <tr>
                                  <th>{{$t('center.NumberReminders')}}</th>
                                  <td>{{ formData.urgeTimes }}</td>

                                  <th>{{$t('center.NumberComplaints')}}</th>
                                  <td>{{ formData.complainTimes }}</td>

                                  <th>{{$t('center.FinalStatement')}}</th>
                                  <td>
                                    {{ formData.settleName }}
                                  </td>
                                  <th>
                                    sendPay {{$t('center.MarkingMark')}}
                                  </th>
                                  <td>
                                    {{ formData.sendPay }}
                                  </td>
                                </tr>
                                <tr>
                                  <th>{{$t('center.AcceptHearCase')}}  ID</th>
                                  <td>{{ formData.caseId }}</td>

                                  <th>{{$t('center.ParentWorkOrderNumber')}} </th>
                                  <td>{{ formData.parentOrderNo }}</td>

                                  <th>父工单品牌 </th>
                                  <td>{{ formData.parentOrderBrandName }}</td>
                                  <!-- <th>{{$t('center.CompletionMode')}} </th>
                                  <td v-if="formData.soOrderExtendDTO.finishMode == 1">结算密码</td>
                                  <td v-if="formData.soOrderExtendDTO.finishMode == 2">上传图片</td>
                                  <td v-if="formData.soOrderExtendDTO.finishMode == 3">图片+条码</td>
                                  <td v-if="formData.soOrderExtendDTO.finishMode == 9">无验证完工</td>
                                  <td v-if="formData.soOrderExtendDTO.finishMode == null"></td>-->


                                  <th>{{$t('center.MethodCompletion')}} </th>
                                  <td v-if="formData.soOrderExtendDTO.finishType == 1">总部代完工</td>
                                  <td v-if="formData.soOrderExtendDTO.finishType == 2">网点PC端完工</td>
                                  <td v-if="formData.soOrderExtendDTO.finishType == 3">网点APP完工</td>
                                  <td v-if="formData.soOrderExtendDTO.finishType == 4">师傅APP完工</td>
                                  <td v-if="formData.soOrderExtendDTO.finishType == 5">接口完工</td>
                                  <td v-if="formData.soOrderExtendDTO.finishType == 9">其他</td>
                                  <td v-if="formData.soOrderExtendDTO.finishType == null"></td>

                                </tr>
                                <tr>
                                  <th>{{$t('center.QualityInspector')}} </th>
                                  <td>{{ formData.soOrderExtendDTO.qualityMan }}</td>

                                  <th>{{$t('center.QualityInspectionTime')}} </th>
                                  <td>{{ formData.soOrderExtendDTO.qualityDate }}</td>

                                  <!-- <th>短信满意度</th>
                                <td v-if="formData.soOrderExtendDTO.commentLevel==1">非常满意</td>
                                <td v-if="formData.soOrderExtendDTO.commentLevel==2">满意</td>
                                <td v-if="formData.soOrderExtendDTO.commentLevel==3">一般</td>
                                <td v-if="formData.soOrderExtendDTO.commentLevel==4">不满意</td>
                                <td v-if="formData.soOrderExtendDTO.commentLevel==5">非常不满意</td>
                                <td
                                  v-if="formData.soOrderExtendDTO.commentLevel==0 || formData.soOrderExtendDTO.commentLevel==null">
                                </td> -->
                                  <th>{{$t('center.ServiceCardNumber')}} </th>
                                  <td>{{ formData.soOrderExtendDTO.serviceCardNo }}</td>
                                  <th>{{$t('center.WhetherCommentMessageBeenSent')}} </th>
                                  <td v-if="formData.soOrderExtendDTO.isSendCommentMessage == 0">
                                    <span class="btn_f">否</span>
                                  </td>
                                  <td v-if="formData.soOrderExtendDTO.isSendCommentMessage == 1">
                                    <span class="btn_t">是</span>
                                  </td>
                                  <td v-if="formData.soOrderExtendDTO.isSendCommentMessage == null"></td>

                                </tr>
                                <tr>
                                  <th>{{$t('center.ReasonWhyInspectionFails')}}</th>
                                  <td>{{ formData.soOrderExtendDTO.qualityRemark }}</td>

                                  <th>{{$t('center.SecondAppealNot')}}</th>
                                  <td v-if="formData.soOrderExtendDTO.secondSiteComplain == 0"><span class="btn_f">否</span>
                                  </td>
                                  <td v-if="formData.soOrderExtendDTO.secondSiteComplain == 1"><span class="btn_t">是</span>
                                  </td>
                                  <td v-if="formData.soOrderExtendDTO.secondSiteComplain == null"></td>

                                  <th>{{$t('center.WhetherLoadingSynchronized')}}</th>
                                  <td v-if="formData.soOrderExtendDTO.isInstallSynchro == 0"><span class="btn_f">否</span>
                                  </td>
                                  <td v-if="formData.soOrderExtendDTO.isInstallSynchro == 1"><span class="btn_t">是</span>
                                  </td>
                                  <td v-if="formData.soOrderExtendDTO.isInstallSynchro == null"></td>

                                  <th>{{$t('center.BlankMarketNot')}}</th>
                                  <td v-if="formData.soOrderExtendDTO.blankMarket == 0"><span class="btn_f">否</span></td>
                                  <td v-if="formData.soOrderExtendDTO.blankMarket == 1"><span class="btn_t">是</span></td>
                                  <td v-if="formData.soOrderExtendDTO.blankMarket == null"></td>
                                </tr>
                                <tr>
                                  <th>{{$t('center.ExpectedHomeInstallationTime')}}</th>
                                  <td>{{ formData.wishBookDate }} {{ formData.wishBookPeriod }}</td>

                                  <th>{{$t('center.ArrivalSignatureTime')}}</th>
                                  <td>{{ formData.soOrderExtendDTO.deliverTime }}</td>
                                  <th>{{$t('center.JdComEstimatedDeliveryDate')}}</th>
                                  <td>{{ formData.soOrderExtendDTO.jdEstimatedDeliveryDate }}</td>

                                  <th>{{$t('center.JingdongAppointmentDateInstallation')}}</th>
                                  <td>{{ formData.soOrderExtendDTO.jdAppointmentInstallDate }}</td>
                                </tr>
                                <tr>
                                  <th>{{$t('center.SuspensionType')}}</th>
                                  <td v-if="formData.soOrderExtendDTO.hangupType == 0">总部挂起</td>
                                  <td v-if="formData.soOrderExtendDTO.hangupType == 1">网点挂起</td>
                                  <td v-if="formData.soOrderExtendDTO.hangupType == null"></td>
                                  <th>{{$t('center.SuspensionReason')}}</th>
                                  <td>{{ formData.soOrderExtendDTO.hangupReason }}</td>
                                  <th>{{$t('center.FounderID')}}</th>
                                  <td>{{ formData.createrNumber }}</td>
                                  <th>{{$t('center.AddressCoding')}}</th>
                                  <td>{{ formData.addressNumber }}</td>
                                </tr>
                                <tr>
                                  <th>{{$t('center.ValueAddedServiceItem')}}</th>
                                  <td>
                                    <dict-value-show :id="formData.soOrderExtendDTO.proServiceSubject" />
                                  </td>

                                  <!-- 临时状态 -->
                                  <th>{{$t('center.TemporaryState')}}</th>
                                  <td v-if="formData.soOrderExtendDTO.tempStat == 1">登记</td>
                                  <td v-else-if="formData.soOrderExtendDTO.tempStat == 2">发布</td>
                                  <td v-else-if="formData.soOrderExtendDTO.tempStat == 5">已派网点</td>
                                  <td v-else-if="formData.soOrderExtendDTO.tempStat == 6">网点已接单</td>
                                  <td v-else-if="formData.soOrderExtendDTO.tempStat == 9">已派师傅</td>
                                  <td v-else-if="formData.soOrderExtendDTO.tempStat == 10">师傅已接单</td>
                                  <td v-else-if="formData.soOrderExtendDTO.tempStat == 11">已预约</td>
                                  <td v-else-if="formData.soOrderExtendDTO.tempStat == 13">已出发</td>
                                  <td v-else-if="formData.soOrderExtendDTO.tempStat == 17">已上门</td>
                                  <td v-else-if="formData.soOrderExtendDTO.tempStat == 20">完工暂存</td>
                                  <td v-else-if="formData.soOrderExtendDTO.tempStat == 97">申请关闭</td>
                                  <td v-else-if="formData.soOrderExtendDTO.tempStat == 98">挂起</td>
                                  <td v-else-if="formData.soOrderExtendDTO.tempStat == 99">取消</td>
                                  <td v-else></td>

                                  <th>{{$t('center.NumberReplacementParts')}}</th>
                                  <td>{{ formData.soOrderExtendDTO.partsQty }}</td>

                                  <th>{{$t('center.NumberDoubleSingular')}}</th>
                                  <td>{{ formData.soOrderExtendDTO.isSamePhone }}</td>
                                </tr>

                                <tr>
                                  <th>{{$t('center.NumberReturnVisits')}}</th>
                                  <td>{{ formData.soOrderExtendDTO.recallNumber }}</td>

                                  <th>{{$t('center.NumberFruitlessReturnVisits')}}</th>
                                  <td>{{ formData.soOrderExtendDTO.recallNoresutlNumber }}</td>

                                  <th>{{$t('center.ReturnVisitMethod')}}</th>
                                  <td v-if="formData.soOrderExtendDTO.recallType == 1">人工回访</td>
                                  <td v-else-if="formData.soOrderExtendDTO.recallType == 2">机器人回访</td>
                                  <td v-else-if="formData.soOrderExtendDTO.recallType == 3">微信点评</td>
                                  <td v-else-if="formData.soOrderExtendDTO.recallType == 4">短信评价</td>
                                  <td v-else-if="formData.soOrderExtendDTO.recallType == 5">批量导入</td>
                                  <td v-else></td>

                                  <th>{{$t('center.SecondVisitStatus')}}</th>
                                  <td v-if="formData.soOrderExtendDTO.secondRecallStat == 0">无申请</td>
                                  <td v-else-if="formData.soOrderExtendDTO.secondRecallStat == 1">待回访</td>
                                  <td v-else-if="formData.soOrderExtendDTO.secondRecallStat == 2">已回访</td>
                                  <td v-else></td>

                                </tr>
                                <tr>
                                <th>{{ $t('center.isPolicy') }}</th>
                                <td v-if="formData.soOrderSpecialExtendDTO.isPolicy == 1">是</td>
                                <td v-else-if="formData.soOrderSpecialExtendDTO.isPolicy == 0">否</td>
                                <td v-else>未知</td>

                                <th>{{ $t('center.isSafeEnvironment') }}</th>
                                <td v-if="formData.soOrderSpecialExtendDTO.isSafeEnvironment == 1">是</td>
                                <td v-else-if="formData.soOrderSpecialExtendDTO.isSafeEnvironment == 0">否</td>
                                <td v-else>未知</td>

                                  <th>瑕疵等级</th>
                                <td>{{formData.soOrderProcessDTO.defectLevelName}}</td>
                                  <th>回收单号</th>
                                  <td>{{formData.soOrderExtendDTO.recycleOrderNo}}</td>
                                </tr>

                                <tr>
                                  <th>{{ $t('center.manager') }}/{{ $t('center.managerMobile') }}</th>
                                  <td>{{formData.manager}}/{{formData.managerMobile}}</td>

                                  <th>{{ $t('center.techManager') }}/{{ $t('center.techManagerMobile') }}</th>
                                  <td>{{formData.techManager}}/{{formData.techManagerMobile}}</td>

                                  <th>{{ $t('center.channleManager') }}/{{ $t('center.channleManagerMobile') }}</th>
                                  <td>{{formData.channleManager}}/{{formData.channleManagerMobile}}</td>

                                  <th>{{$t('center.userPhoneUnreal')}}</th>
                                  <td>{{formData.userPhoneUnreal}}</td>
                                </tr>

                                <tr>
                                  <th>是否视频</th>
                                  <td v-if="formData.soOrderExtendDTO.isVideo == 1">是</td>
                                  <td v-else-if="formData.soOrderExtendDTO.isVideo == 0">否</td>
                                  <td v-else></td>
                                  <th>人脸匹配位置是否正常</th>
                                  <td v-if="formData.soOrderExtendDTO.faceLocationNormal == 1">否</td>
                                  <td v-else-if="formData.soOrderExtendDTO.faceLocationNormal == 2">是</td>
                                  <td v-else></td>
                                  <th>异常回访标签</th>
                                  <td v-if="formData.soOrderExtendDTO.recallTag == 1">当天同号码多单完工</td>
                                  <td v-else-if="formData.soOrderExtendDTO.recallTag == 2">事后单</td>
                                  <td v-else-if="formData.soOrderExtendDTO.recallTag == 3">多单来源不规范</td>
                                  <td v-else-if="formData.soOrderExtendDTO.recallTag == 4">七天内先调试再维修</td>
                                  <td v-else-if="formData.soOrderExtendDTO.recallTag == 5">指定服务商/工程师</td>
                                  <td v-else></td>
                                </tr>

                                <tr>
                                  <th>派单状态</th>
                                  <td v-if="formData.assignStat == 1">正常派单</td>
                                  <td v-else-if="formData.assignStat == 0">未接听派单</td>
                                  <td v-else></td>

                                  <th>预指派网点</th>
                                  <td>{{formData.reSiteName}}</td>
                                  <th>完工人姓名</th>
                                  <td>{{formData.soOrderExtendDTO.finishMan}}</td>
                                  <th>完工人电话</th>
                                  <td>{{formData.soOrderExtendDTO.finishMobile}}</td>
                                </tr>

                                <tr>
                                  <th>建单服务商</th>
                                  <th>{{formData.soOrderExtendDTO.selfBuiltOrderSiteName}}</th>

                                  <th>用户是否同意预约</th>
                                  <td v-if="formData.soOrderProcessDTO.isRescheduleConfirmed == 1">是</td>
                                  <td v-else-if="formData.soOrderProcessDTO.isRescheduleConfirmed == 0">否</td>
                                  <td v-else></td>

                                  <td></td>
                                  <th></th>
                                  <td></td>
                                </tr>

                                <tr>
                                  <th>{{$t('center.WorkOrderFollowRecord')}}</th>
                                  <td colspan="6"><el-input  type="textarea"
                                                             :autosize="{ minRows: 1, maxRows: 3}"   readonly
                                                             v-model="formData.soOrderExtendDTO.traceRecordText" clearable>
                                    <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                                  </el-input></td>
                                </tr>
                                <tr>
                                  <th>{{$t('center.OverdueVerificationText')}}</th>
                                  <td colspan="6"><el-input  type="textarea"
                                                             :autosize="{ minRows: 1, maxRows: 3}"   readonly
                                                             v-model="formData.soOrderExtendDTO.timeCheckText" clearable>
                                    <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                                  </el-input></td>
                                </tr>
  <!--                              <tr>
                                  <th>{{$t('center.WorkOrderRreminderRecord')}}</th>
                                  <td colspan="6"><el-input  type="textarea"
                                                             :autosize="{ minRows: 1, maxRows: 3}"  style="!important;white-space: nowrap;" readonly
                                                             v-model="formData.soOrderExtendDTO.urgeRecordText" clearable>
                                    &lt;!&ndash; <i slot="prefix" class="el-input__icon el-icon-search"></i> &ndash;&gt;
                                  </el-input></td>
                                </tr>-->
                              </el-tab-pane>
                              <el-tab-pane :label="$t('center.assist')" name="nine"></el-tab-pane>

                              <el-tab-pane :label="$t('center.ReviewsReturnVisits')" name="six"
                                style="max-height: 360px;position: relative;overflow-y: scroll;">

                                <div style="border: 1px solid rgb(242, 242, 242);margin-bottom: 15px;">
                                  <tr>
                                    <th>
                                      首次回访时间
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.firstRecallTime }}
                                    </td>
                                    <th>
                                      回访完成时间
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.recallTime }}
                                    </td>
                                    <th>
                                      回访人
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.recaller }}
                                    </td>
                                    <th>
                                      回访情况
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.huiFangQingKuang == 1">属实</td>
                                    <td v-else-if="formData.soOrderProcessDTO.huiFangQingKuang == 2">不属实</td>
                                    <td v-else-if="formData.soOrderProcessDTO.huiFangQingKuang == 3">无果</td>
                                    <td v-else></td>
                                  </tr>

                                  <tr>
                                    <th>
                                      总体满意情况
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.manYi == 1">非常满意</td>
                                    <td v-else-if="formData.soOrderProcessDTO.manYi == 2">满意</td>
                                    <td v-else-if="formData.soOrderProcessDTO.manYi == 3">一般</td>
                                    <td v-else-if="formData.soOrderProcessDTO.manYi == 4">不满意</td>
                                    <td v-else-if="formData.soOrderProcessDTO.manYi == 5">非常不满意</td>
                                    <td v-else-if="formData.soOrderProcessDTO.manYi == 6">未评价</td>
                                    <td v-else></td>

                                    <th>
                                      不属实原因
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.notTrueReasonName }}
                                    </td>

                                    <th>
                                      无果原因
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.noResultReasonName }}
                                    </td>

                                    <th>
                                      不满意原因
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.unSatisfiedReasonName }}
                                    </td>
                                  </tr>


                                  <tr>
                                    <th>
                                      权益回访情况
                                    </th>
                                    <td v-if="formData.soOrderProcessDTO.rightHuiFangQingKuang == 1">属实</td>
                                    <td v-else-if="formData.soOrderProcessDTO.rightHuiFangQingKuang == 2">不属实</td>
                                    <td v-else-if="formData.soOrderProcessDTO.rightHuiFangQingKuang == 3">无果</td>
                                    <td v-else></td>

                                    <th>
                                      不属实原因
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.rightNotTrueReasonName }}
                                    </td>

                                    <th>
                                      无果原因
                                    </th>
                                    <td>
                                      {{ formData.soOrderProcessDTO.rightNoResultReasonName }}
                                    </td>
                                  </tr>

                                  <tr>
                                    <th>
                                      不满意描述
                                    </th>
                                    <td colspan="7">
                                      {{ formData.soOrderProcessDTO.unSatisfiedRemark }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>
                                      配件回访结果
                                    </th>
                                    <td>
                                      <span v-if="isType == 1">属实</span>
                                      <span v-else-if="isType == 2">不属实</span>
                                      <span v-else-if="isType == 3">无果</span>
                                      <span v-else></span>

                                    </td>
                                  </tr>
                                </div>
                                <tr>
                                  <p class="title_p">{{$t('center.UserEvaluation')}}</p>
                                </tr>
                                <template v-if="formData.soOrderCommentDTOList.length > 0">
                                  <div style="border: 1px solid rgb(242, 242, 242);margin-bottom: 15px;"
                                    v-for="item in formData.soOrderCommentDTOList" :key="item.id">

                                    <tr>
                                      <th>
                                        {{$t('center.EvaluationSource')}}
                                      </th>
                                      <td v-if="item.sources == null"></td>
                                      <td v-else-if="item.sources == 1">电商接口</td>
                                      <td v-else-if="item.sources == 2">短信回复评价</td>
                                      <td v-else-if="item.sources == 3">用户微信评价</td>
                                      <td v-else-if="item.sources == 4">APP扫码评价</td>
                                      <td v-else-if="item.sources == 5">400回访</td>
                                      <td v-else></td>
                                      <th>
                                        {{$t('center.appraiser')}}
                                      </th>
                                      <td>
                                        {{ item.evaluateBy ? item.evaluateBy : '\xa0' }}
                                      </td>
                                      <th>
                                        {{$t('center.EvaluationTime')}}
                                      </th>
                                      <td>
                                        {{ item.evaluateTime }}
                                      </td>
                                      <th style="visibility: hidden">

                                      </th>
                                      <td>

                                      </td>
                                    </tr>
                                    <tr>
                                      <th>
                                        {{$t('center.OverallEvaluation')}}

                                      </th>

                                      <td v-if="item.topLevel == 1">非常满意</td>
                                      <td v-else-if="item.topLevel == 2">满意</td>
                                      <td v-else-if="item.topLevel == 3">一般</td>
                                      <td v-else-if="item.topLevel == 4">不满意</td>
                                      <td v-else-if="item.topLevel == 5">非常不满意</td>
                                      <td v-else></td>
                                      <td
                                        style="text-align: right;    text-decoration: underline;color: rgb(33, 150, 243);">
                                        <span @click="openRecordDialog2(item)">{{$t('center.MoreInformation')}}</span>
                                      </td>
                                    </tr>
                                  </div>
                                </template>
                                <div v-else style="border: 1px solid rgb(242, 242, 242);margin-bottom: 15px;">

                                  <tr>
                                    <th>
                                      {{$t('center.EvaluationSource')}}
                                    </th>
                                    <td></td>
                                    <th>
                                      {{$t('center.appraiser')}}
                                    </th>
                                    <td>

                                    </td>
                                    <th>
                                      {{$t('center.EvaluationTime')}}

                                    </th>
                                    <td>

                                    </td>
                                    <th style="visibility: hidden">

                                    </th>
                                    <td>

                                    </td>
                                  </tr>
                                  <tr>
                                    <th>
                                      {{$t('center.OverallEvaluation')}}
                                    </th>
                                    <td></td>
                                    <td style="text-align: right;    text-decoration: underline;color: rgb(33, 150, 243);">
                                      <span>{{$t('center.MoreInformation')}}</span>
                                    </td>
                                  </tr>
                                </div>
                                <tr>
                                  <p class="title_p">{{$t('center.ReturnVisitRecord')}}</p>
                                </tr>
                                <template v-if="formData.soRecallHistoryDTOList.length > 0">
                                  <div style="border: 1px solid rgb(242, 242, 242);margin-bottom: 15px;"
                                    v-for="item in formData.soRecallHistoryDTOList" :key="item.id">

                                    <tr>
                                      <th>
                                        {{$t('center.ReturnTime')}}
                                      </th>
                                      <td>
                                        {{ item.recallDate }}
                                      </td>
                                      <th>
                                        {{$t('center.ReturnVisitStatus')}}
                                      </th>
                                      <td v-if="item.finishRecall == null">
                                      </td>
                                      <td v-else-if="item.finishRecall == 0">未回访</td>
                                      <td v-else-if="item.finishRecall == 1">回访失败</td>
                                      <td v-else-if="item.finishRecall == 5">回访成功</td>
                                      <td v-else></td>
                                      <th>
                                        {{$t('center.ReturnVisitor')}}
                                      </th>
                                      <td>
                                        {{ item.recallMan }}
                                      </td>
                                      <th>
                                        {{$t('center.ReturnVisit')}}
                                      </th>
                                      <td v-if="item.huiFangQingKuang == null">
                                      </td>
                                      <td v-else-if="item.huiFangQingKuang == 1">属实</td>
                                      <td v-else-if="item.huiFangQingKuang == 2">不属实</td>
                                      <td v-else-if="item.huiFangQingKuang == 3">不确定</td>
                                      <td v-else></td>
                                    </tr>
                                    <tr>
                                      <th>
                                        {{$t('center.satisfaction')}}
                                      </th>
                                      <td v-if="item.manYi == null">
                                      </td>
                                      <td v-else-if="item.manYi == 1">非常满意</td>
                                      <td v-else-if="item.manYi == 2">满意</td>
                                      <td v-else-if="item.manYi == 3">一般</td>
                                      <td v-else-if="item.manYi == 4">不满意</td>
                                      <td v-else-if="item.manYi == 5">非常不满意</td>
                                      <td v-else-if="item.manYi == 6">未评价</td>
                                      <td v-else></td>
                                      <td
                                        style="text-align: right;    text-decoration: underline;color: rgb(33, 150, 243);">
                                        <span @click="showDetails(formData.orderNo, item)">{{$t('center.MoreInformation')}}</span>
                                      </td>
                                    </tr>
                                  </div>
                                </template>
                                <div v-else style="border: 1px solid rgb(242, 242, 242);margin-bottom: 15px;">

                                  <tr>
                                    <th>
                                      {{$t('center.ReturnTime')}}
                                    </th>
                                    <td>

                                    </td>
                                    <th>
                                      {{$t('center.ReturnVisitStatus')}}
                                    </th>
                                    <td>
                                    </td>

                                    <th>
                                      {{$t('center.ReturnVisitor')}}
                                    </th>
                                    <td>

                                    </td>
                                    <th>
                                      {{$t('center.ReturnVisit')}}
                                    </th>
                                    <td>
                                    </td>


                                  </tr>
                                  <tr>
                                    <th>
                                      {{$t('center.satisfaction')}}
                                    </th>
                                    <td>
                                    </td>

                                    <td style="text-align: right;    text-decoration: underline;color: rgb(33, 150, 243);">
                                      <span>{{$t('center.MoreInformation')}}</span>
                                    </td>
                                  </tr>
                                </div>
                              </el-tab-pane>
                              <el-tab-pane :label="$t('center.RecordPreliminaryHearing')" name="seven">
                                <div class="product" style="">
                                  <vxe-table ref="filterTable" height="200"
                                    :data="formData.soOrderPreconditionResultDTOList" class="table_item pic_item"
                                    style="margin:12px auto;width: 95%;" :stripe="true"
                                    :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                    :row-config="{ height: 30, isHover: true, padding: 0, }"
                                    :row-style="{ fontSize: '12px', }" show-overflow :column-config="{ resizable: true }">
                                    <!--                    <vxe-column type="seq" width="55" title="序号"/>-->
                                    <vxe-column field="preconditionName" :title="$t('center.PretrialConditions')"  width="40%" >
                                      <template #default="{ row }">
                                        <span  :style="row.isPast == 1? 'color:black': 'color:red'"> {{row.preconditionName}}</span>

                                      </template>

                                    </vxe-column>
                                    <vxe-column field="isPast" :title="$t('center.PassNot')"  width="15%">
                                      <template #default="{ row }">
                                        <span  v-if="row.isPast == 1">是</span>
                                        <span style="color:red" v-else>否</span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="afterFlow" :title="$t('center.FlowDirection')"  width="10%">
                                      <template #default="{ row }">
                                        <span :style="row.isPast == 1? 'color:black': 'color:red'"  v-if="row.afterFlow == 1">必访</span>
                                        <span :style="row.isPast == 1? 'color:black': 'color:red'" v-else-if="row.afterFlow == 2">申诉</span>
                                        <span :style="row.isPast == 1? 'color:black': 'color:red'" v-else-if="row.afterFlow == 3">挂起</span>
                                        <span :style="row.isPast == 1? 'color:black': 'color:red'" v-else-if="row.afterFlow == 4">重新完工</span>
                                        <span :style="row.isPast == 1? 'color:black': 'color:red'" v-else-if="row.afterFlow == 5">中止结算</span>
                                        <span :style="row.isPast == 1? 'color:black': 'color:red'" v-else-if="row.afterFlow == 9">关闭</span>
                                        <span :style="row.isPast == 1? 'color:black': 'color:red'" v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="remark" :title="$t('center.remark')"  width="40%" >
                                    <!-- <vxe-column field="remark" title="备注" width=""/> -->
                                    <template #default="{ row }">
                                        <span  :style="row.isPast == 1? 'color:black': 'color:red'"> {{row.remark}}</span>

                                      </template>
  </vxe-column>
                                  </vxe-table>

                                </div>
                              </el-tab-pane>
                              <el-tab-pane :label="$t('center.InterfaceInformation')" name="eight">
                                <tr>
                                  <th>
                                    {{$t('center.ExternalSystemFlyerIdentification')}}
                                  </th>
                                  <td v-if="formData.soOrderExtendDTO.sendFlag == null"></td>
                                  <td v-if="formData.soOrderExtendDTO.sendFlag == 0">未传</td>
                                  <td v-if="formData.soOrderExtendDTO.sendFlag == 1">失败</td>
                                  <td v-if="formData.soOrderExtendDTO.sendFlag == 2">已传</td>

                                  <th>
                                    {{$t('center.ExternalSystemFlyersReturnInformation')}}
                                  </th>
                                  <td>
                                    {{ formData.soOrderExtendDTO.sendMessage }}
                                  </td>
                                  <th>
                                    {{$t('center.ExternalSystemFlyerTime')}}
                                  </th>
                                  <td>
                                    {{ formData.soOrderExtendDTO.sendDate }}
                                  </td>

                                  <th>
                                    {{$t('center.TheInterfaceStatusNetworkDisplayed')}}
                                  </th>
                                  <td v-if="formData.soOrderExtendDTO.thirdSendFlag == null"></td>
                                  <td v-if="formData.soOrderExtendDTO.thirdSendFlag == 0">未传</td>
                                  <td v-if="formData.soOrderExtendDTO.thirdSendFlag == 1">失败</td>
                                  <td v-if="formData.soOrderExtendDTO.thirdSendFlag == 2">已传</td>

                                </tr>
                                <tr>
                                  <th>
                                    {{$t('center.TransferTimeNetworkInterface')}}
                                  </th>
                                  <td>
                                    {{ formData.soOrderExtendDTO.thirdSendDate }}
                                  </td>

                                  <th>
                                    {{$t('center.ThisSectionDescribesInterfaceRemarksNetwork')}}
                                  </th>
                                  <td>
                                    {{ formData.soOrderExtendDTO.thirdSendMessage }}
                                  </td>

                                  <th>
                                    {{$t('center.IDWorkOrderTmalServiceMarket')}}
                                  </th>
                                  <td>
                                    {{ formData.soOrderExtendDTO.tmfworderid }}
                                  </td>

                                  <th>
                                    {{$t('center.UserTmallServiceMarket')}}
                                  </th>
                                  <td>
                                    {{ formData.soOrderExtendDTO.tbcustomerid }}
                                  </td>
                                </tr>
                                <tr>
                                  <th>{{$t('center.WhetherCommercePraise')}}</th>
                                  <td v-if="formData.soOrderExtendDTO.commercePraise == null"></td>
                                  <td v-if="formData.soOrderExtendDTO.commercePraise == 1">是</td>
                                  <td v-if="formData.soOrderExtendDTO.commercePraise == 0">否</td>
                                </tr>
                              </el-tab-pane>
                              <el-tab-pane :label="$t('center.DialingRecords')" name="ten">
                                <div class="product" style="">
                                  <vxe-table ref="filterTable" height="250"
                                             :data="formData.soOrderCallOperateList" class="table_item pic_item"
                                             style="margin:12px auto;width: 95%;" :stripe="true"
                                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                             :row-config="{ height: 30, isHover: true, padding: 0, }"
                                             :row-style="{ fontSize: '12px', }" show-overflow :column-config="{ resizable: true }">
                                    <!--                    <vxe-column type="seq" width="55" title="序号"/>-->
                                    <vxe-column field="createTime" :title="$t('center.callTime')"  width="15%" />
                                    <vxe-column field="createBy" :title="$t('center.caller')"  width="15%" />
                                    <vxe-column field="scene" :title="$t('center.scene')"  width="15%" />
                                    <vxe-column field="callId" :title="$t('center.callId')" width="20%">
                                      <template #default="{ row }">
                                        <a v-if="row.callId" :href="row.callId" style="color: blue;">语音文件</a>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="terminal" :title="$t('center.terminal')"  width="20%" />
                                    <vxe-column field="alertion" :title="'响铃时长'"  width="15%" />
                                    <vxe-column field="duration" :title="'通话时长'"  width="15%" />
                                  </vxe-table>

                                </div>
                              </el-tab-pane>
                              <el-tab-pane label="地址修改记录" name="eleven">
                                <div class="product" style="">
                                  <vxe-table ref="filterTable" height="200"
                                             :data="formData.soOrderAreaHistoryDTOList" class="table_item pic_item"
                                             style="margin:12px auto;width: 95%;" :stripe="true"
                                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                             :row-config="{ height: 30, isHover: true, padding: 0, }"
                                             :row-style="{ fontSize: '12px', }" show-overflow :column-config="{ resizable: true }">
                                    <!--                    <vxe-column type="seq" width="55" title="序号"/>-->
                                    <vxe-column field="createTime" title="创建时间"  width="15%" />
                                    <vxe-column field="createBy" title="创建人"  width="15%" />
                                    <vxe-column field="userProvice" title="省"  width="15%" />
                                    <vxe-column field="userCity" title="市"  width="15%" />
                                    <vxe-column field="userCounty" title="区"  width="15%" />
                                    <vxe-column field="userTown" title="镇"  width="15%"/>
                                    <vxe-column field="userAddress" title="详细地址"  width="40%" />
                                  </vxe-table>
                                </div>
                              </el-tab-pane>
                              <el-tab-pane label="评分记录" name="thirteen">
                                <div class="product" style="">
                                  <vxe-table ref="filterTable" height="200"
                                             :data="formData.soOrderScoresDTOList" class="table_item pic_item"
                                             style="margin:12px auto;width: 95%;" :stripe="true"
                                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                             :row-config="{ height: 30, isHover: true, padding: 0, }"
                                             :row-style="{ fontSize: '12px', }" show-overflow :column-config="{ resizable: true }">
                                    <!--                    <vxe-column type="seq" width="55" title="序号"/>-->
                                    <vxe-column field="serverBusinessType" title="服务类型性质"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.serverBusinessType == 1">安装</span>
                                        <span v-else-if="row.serverBusinessType == 2">维修</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="orderNode" title="履约节点"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.orderNode == 1">报单</span>
                                        <span v-else-if="row.orderNode == 3">预约</span>
                                        <span v-else-if="row.orderNode == 5">上门</span>
                                        <span v-else-if="row.orderNode == 7">完结</span>
                                        <span v-else-if="row.orderNode == 9">用户评价</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="nodeProject" title="节点子项"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.nodeProject == 1">关联安装单</span>
                                        <span v-else-if="row.nodeProject == 2">虚拟号外呼记录</span>
                                        <span v-else-if="row.nodeProject == 3">APP打卡记录</span>
                                        <span v-else-if="row.nodeProject == 4">派单时间距离到达签到时间</span>
                                        <span v-else-if="row.nodeProject == 5">完工方式</span>
                                        <span v-else-if="row.nodeProject == 6">工单时长</span>
                                        <span v-else-if="row.nodeProject == 7">评价方式</span>
                                        <span v-else-if="row.nodeProject == 8">评价手机号和用户手机号</span>
                                        <span v-else-if="row.nodeProject == 9">收费信息</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="nodeDescribe" title="结果描述"  width="40%" />
                                    <vxe-column field="scores" title="得分"  width="40%" />
                                  </vxe-table>
                                </div>
                              </el-tab-pane>
                              <!-- <el-tab-pane label="用户安装环境" name="twelve">
                                <div class="product" style="">
                                  <vxe-table ref="filterTable" height="200"
                                             :data="formData.soOrderEnvironmentDTOList" class="table_item pic_item"
                                             style="margin:12px auto;width: 95%;" :stripe="true"
                                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                             :row-config="{ height: 30, isHover: true, padding: 0, }"
                                             :row-style="{ fontSize: '12px', }" show-overflow :column-config="{ resizable: true }">
                                    <vxe-column type="seq" width="55" title="序号"/>
                                    <vxe-column field="shifouDaohuo" title="是否到货"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.shifouDaohuo == 1">否</span>
                                        <span v-else-if="row.shifouDaohuo == 2">是</span>
                                        <span v-else-if="row.shifouDaohuo == 3">不清楚</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="daohuoShijian" title="到货时间"  width="15%" />
                                    <vxe-column field="environmentType" title="环境类型"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.environmentType == 1">新房安装</span>
                                        <span v-else-if="row.environmentType == 2">旧房改造</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="shifouYikaikong" title="是否已开孔"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.shifouYikaikong == 1">否</span>
                                        <span v-else-if="row.shifouYikaikong == 2">是</span>
                                        <span v-else-if="row.shifouYikaikong == 3">不清楚</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="shifouDakuokong" title="是否需打扩孔"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.shifouDakuokong == 1">否</span>
                                        <span v-else-if="row.shifouDakuokong == 2">是</span>
                                        <span v-else-if="row.shifouDakuokong == 3">不清楚</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="shifouJieshoushoufei" title="是否接受收费"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.shifouJieshoushoufei == 1">否</span>
                                        <span v-else-if="row.shifouJieshoushoufei == 2">是</span>
                                        <span v-else-if="row.shifouJieshoushoufei == 3">联系确认</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="shifouZuohaochugui" title="是否做好橱柜"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.shifouZuohaochugui == 1">否</span>
                                        <span v-else-if="row.shifouZuohaochugui == 2">是</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="shifouDaidixian" title="是否带地线"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.shifouDaidixian == 1">否</span>
                                        <span v-else-if="row.shifouDaidixian == 2">是</span>
                                        <span v-else-if="row.shifouDaidixian == 3">不清楚</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="shifouTongshuilu" title="是否已通水路"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.shifouTongshuilu == 1">否</span>
                                        <span v-else-if="row.shifouTongshuilu == 2">是</span>
                                        <span v-else-if="row.shifouTongshuilu == 3">不清楚</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="shifouTongqi" title="是否已通气"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.shifouTongqi == 1">否</span>
                                        <span v-else-if="row.shifouTongqi == 2">是</span>
                                        <span v-else-if="row.shifouTongqi == 3">不清楚</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="shifouTongdian" title="是否已通电"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.shifouTongdian == 1">否</span>
                                        <span v-else-if="row.shifouTongdian == 2">是</span>
                                        <span v-else-if="row.shifouTongdian == 3">不清楚</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="anzhuangWeizhi" title="安装位置"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.anzhuangWeizhi == 1">厨房</span>
                                        <span v-else-if="row.anzhuangWeizhi == 2">阳台</span>
                                        <span v-else-if="row.anzhuangWeizhi == 3">其他</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="shifouYoupaishuikou" title="是否有排水口"  width="10%">
                                      <template #default="{ row }">
                                        <span v-if="row.shifouYoupaishuikou == 1">否</span>
                                        <span v-else-if="row.shifouYoupaishuikou == 2">是</span>
                                        <span v-else></span>
                                      </template>
                                    </vxe-column>

                                  </vxe-table>
                                </div>
                              </el-tab-pane> -->

                              <el-tab-pane label="销售登记" name="therelve">
                                <tr>
                                  <th>
                                    销售登记
                                  </th>
                                  <td v-if="formData.registerStat ==null"> </td>
                                  <td v-if="formData.registerStat == 1"> 待登记</td>
                                  <td v-if="formData.registerStat == 2"> 已登记</td>
                                  <th>
                                    是否转换成功
                                  </th>
                                  <td v-if="formData.soOrderDesignSaleRegisterDto.saleSuccess == null"></td>
                                  <td v-if="formData.soOrderDesignSaleRegisterDto.saleSuccess == 0"> 否</td>
                                  <td v-if="formData.soOrderDesignSaleRegisterDto.saleSuccess == 1"> 是</td>
                                  <th>
                                    销售订单号
                                  </th>
                                  <td>{{formData.soOrderDesignSaleRegisterDto.saleNumber}}</td>
                                  <th>
                                    安装工单号
                                  </th>
                                  <td>{{formData.soOrderDesignSaleRegisterDto.installOrderNo}}</td>
                                </tr>
                                <tr>
                                  <th>销售转换大类</th>
                                  <td>{{formData.soOrderDesignSaleRegisterDto.saleBigCategoryName}}</td>
                                  <th>销售转换产品编码</th>
                                  <td>{{formData.soOrderDesignSaleRegisterDto.saleItemCode}}</td>
                                  <th>销售转换产品名称</th>
                                  <td>{{formData.soOrderDesignSaleRegisterDto.saleItemName}}</td>
                                  <th>实际销售金额</th>
                                  <td>{{formData.soOrderDesignSaleRegisterDto.factSaleAmount}}</td>
                                </tr>
                                <tr>
                                  <th>未转化责任方</th>
                                  <td v-if="formData.soOrderDesignSaleRegisterDto.failSucessObject == null"></td>
                                  <td v-if="formData.soOrderDesignSaleRegisterDto.failSucessObject == 1"> 用户原因</td>
                                  <td v-if="formData.soOrderDesignSaleRegisterDto.failSucessObject == 2"> 店铺原因</td>
                                  <td v-if="formData.soOrderDesignSaleRegisterDto.failSucessObject == 3"> 服务商原因</td>
                                  <th>未转换成功原因</th>
                                  <td>{{formData.soOrderDesignSaleRegisterDto.failSucessReasonName}}</td>
                                  <th>销售激励状态</th>
                                  <td v-if="formData.soOrderDesignSaleRegisterDto.saleRewardStat == null"></td>
                                  <td v-if="formData.soOrderDesignSaleRegisterDto.saleRewardStat == 1"> 待生成激励单</td>
                                  <td v-if="formData.soOrderDesignSaleRegisterDto.saleRewardStat == 2"> 已生成激励单</td>
                                </tr>
                              </el-tab-pane>

                              <el-tab-pane label="附件" name="fourteenlve">
                                <div class="product" style="">
                                  <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                                    <el-upload style="display:flex; float: right" class="upload-demo" ref="upload" v-if="addOrderFile"
                                               :action="api.uploadFileUrl"  :show-file-list="false" :on-progress="upVideo"
                                               :on-success="(res, file, fileList) => { handleFileSuccess(res, file, fileList) }" :headers="headers"
                                               :auto-upload="true">
                                      <el-button type="primary" class="button-sty btn_zdy">
                                        <i class="el-icon-plus"></i>
                                        附件
                                      </el-button>
                                    </el-upload>
                                  </div>
                                  <div>
                                    <vxe-table style="margin-top: 0px;" :stripe="true"
                                               :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                               :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                               show-overflow height="210" :column-config="{ resizable: true }"
                                               :data="formData.orderFileList">
                                      <vxe-column field="fileName" title="附件名称" width="400">
                                        <template #default="{ row }">
                                          <a :href="row.fileUrl" :download="row.name">{{ row.fileName }}</a>
                                        </template>
                                      </vxe-column>
                                      <vxe-column title="操作" width="100">
                                        <template #default="{ row }">
                                          <div >
                                            <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                                        popper-class="tooltip-skin" v-if="deleteOrderFile">
                                              <i @click="deleteFile(row)" class="el-icon-delete"
                                                 style="font-size: 18px; color: #00c4b3"></i>
                                            </el-tooltip>


                                            <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                                                        popper-class="tooltip-skin" v-if="downloadOrderFile">
                                              <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                                                 style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                                            </el-tooltip>

                                            <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
                                                        popper-class="tooltip-skin">
                                              <i @click="openVideo(row.fileUrl)" class="el-icon-view"
                                                 style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                                            </el-tooltip>
                                          </div>
                                        </template>
                                      </vxe-column>
                                    </vxe-table>
                                  </div>
                                </div>
                              </el-tab-pane>
                            </el-tabs>
                          </template>


                        </tbody>
                      </table>
                    </div>
                    <div style="height:160px"></div>
                  </div>
                  <div :style=" orderBlock ? 'width:20%': 'width:1%'" class="bread">
                    <div style="padding-bottom: 90px;    margin-top: 10px; margin-left: 5px;">
                <div style="display: flex;">

                      <div class="title_icon" @click="orderBlock=!orderBlock"><i class="el-icon-date"></i></div>
                      <span :style=" orderBlock ? 'display:block': 'display:none'">工单履历</span>
                      </div>
                      <el-timeline class="card_bread"  :style=" orderBlock ? 'display:block': 'display:none'">

                        <el-timeline-item v-for="item in formData.soOrderOperationDTOList" :key="item.id" placement="top">
                          <div class="title_time"><span class="span1">{{ item.title }} </span>
                            <span class="span2">{{ item.createTime }}</span>
                          </div>
                          <div style="font-size: 13px;margin-top: 7px;"><span style="color: #2a6494 !important;">操作人:{{
                            item.createBy }} </span></div>
                          <el-card class="card">
                            <p v-html=item.content></p>
                          </el-card>
                        </el-timeline-item>


                        <!--                  <el-timeline-item-->
                        <!--                    v-for="item in tenant.soOrderOperationDTOList.slice(3, tenant.soOrderOperationDTOList.length)"-->
                        <!--                    :timestamp="item.createTime" placement="top">-->
                        <!--                    <el-card class="card">-->
                        <!--                      <div>{{ item.title }}</div>-->
                        <!--                      <p>{{ item.content }}</p>-->
                        <!--                    </el-card>-->
                        <!--                  </el-timeline-item>-->


                      </el-timeline>

                    </div>
                  </div>
                </dix>
              </el-tab-pane>
              <el-tab-pane :label="$t('center.ServiceReport')" name="second">
                <div class="d-cont edit-mce-box"
                  style=" overflow: unset!important;overflow-y: scroll!important;height: 100vh!important; ">

                  <div class="d-item">
                    <div class="title first"><b>工单取消(关闭)</b></div>
                    <table class="table-detail" style="display: block;">
                      <tbody style="display: block;">
                      <tr>
                        <th>取消原因</th>
                        <td>{{formData.soOrderProcessDTO.returnName}}</td>
                        <th>重复单号</th>
                        <td>{{formData.soOrderExtendDTO.repeatOrderNo}}</td>
                        <th>取消时间</th>
                        <td>{{formData.soOrderProcessDTO.cancleDate}}</td>
                      </tr>
                      <tr>
                        <th>是否发送短信</th>
                        <td v-if="formData.soOrderExtendDTO.cancleSendMessFlag == 1"><span class="btn_f">是</span></td>
                        <td v-else-if="formData.soOrderExtendDTO.cancleSendMessFlag == 0"><span class="btn_t">否</span></td>
                        <td v-else></td>
                      </tr>
                      <tr>
                        <th>
                          取消备注
                        </th>
                        <td colspan="7">
                          {{ formData.soOrderExtendDTO.cancleRemark }}
                        </td>
                      </tr>
                      <tr>
                        <th>取消图片</th>
                        <td>
                        <div class="pic_item">
                          <el-image v-if="formData.soOrderExtendDTO.canclePic1"
                                    :src="formData.soOrderExtendDTO.canclePic1" :fit="fit"
                                    :preview-src-list="closeSrcList" :initial-index="0"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                        </div>
                        </td>
                        <td>
                        <div class="pic_item">
                          <el-image v-if="formData.soOrderExtendDTO.canclePic2"
                                    :src="formData.soOrderExtendDTO.canclePic2" :fit="fit"
                                    :preview-src-list="closeSrcList" :initial-index="1"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                        </div>
                        </td>
                        <td>
                        <div class="pic_item">
                          <el-image v-if="formData.soOrderExtendDTO.canclePic3"
                                    :src="formData.soOrderExtendDTO.canclePic3" :fit="fit"
                                    :preview-src-list="closeSrcList" :initial-index="2"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                        </div>
                        </td>
                        <td>
                        <div class="pic_item">
                          <el-image v-if="formData.soOrderExtendDTO.canclePic4"
                                    :src="formData.soOrderExtendDTO.canclePic4" :fit="fit"
                                    :preview-src-list="closeSrcList" :initial-index="3"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                        </div>
                        </td>
                      </tr>
                      <tr>
                        <th>总部审核</th>
                        <td v-if="formData.soOrderExtendDTO.cancleCheckResult == 1"><span class="btn_f">通过</span></td>
                        <td v-else-if="formData.soOrderExtendDTO.cancleCheckResult == 2"><span class="btn_t">驳回</span></td>
                        <td v-else></td>
                        <th>驳回原因</th>
                        <td>{{formData.soOrderExtendDTO.cancleRejectRemarkName}}</td>
                      </tr>
                      <tr>
                        <th>
                          审核意见
                        </th>
                        <td colspan="7">
                          {{ formData.soOrderExtendDTO.cancleCheckRemark }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>


                  <div class="d-item">
                    <div class="title first"><b>{{$t('center.ServiceContent')}}</b></div>
                    <table class="table-detail" style="display: block;">
                      <tbody style="display: block;">

                        <tr>
  <!--                        <th>故障现象</th>-->
  <!--                        <td>{{ formData.sysmtomName }}</td>-->

  <!--                        <th>故障原因</th>-->
  <!--                        <td>{{ formData.reasonName }}</td>-->

                          <th>{{$t('center.FinishedCondition')}}</th>
                          <td v-if="formData.soOrderProcessDTO.finishStatus == 1"><span class="btn_f">正常完工</span></td>
                          <td v-else-if="formData.soOrderProcessDTO.finishStatus == 2"><span class="btn_t">无法完工</span></td>
                          <td v-else-if="formData.soOrderProcessDTO.finishStatus == 3"><span class="btn_t">需重新完工</span></td>
                          <td v-else></td>
                          <th>{{$t('center.WarrantyType')}}</th>
                          <td v-if="formData.guaranteeType == 1"><span class="btn_f">保内</span></td>
                          <td v-else-if="formData.guaranteeType == 2"><span class="btn_t">保外</span></td>
                          <td v-else-if="formData.guaranteeType == 3"><span class="btn_t">类型不详</span></td>
                          <td v-else></td>
                          <th>{{$t('center.ApplyReinsuranceOutsideInside')}}</th>
                          <td v-if="formData.outTransIn == 0"><span class="btn_f">否</span></td>
                          <td v-else-if="formData.outTransIn == 1"><span class="btn_t">是</span></td>
                          <td v-else></td>
                          <th>{{$t('center.MaintenanceCondition')}}</th>
                          <td v-if="formData.soOrderProcessDTO.fixStatus == 1"><span class="btn_f">正常维修</span></td>
                          <td v-else-if="formData.soOrderProcessDTO.fixStatus == 2"><span class="btn_t">退机</span></td>
                          <td v-else-if="formData.soOrderProcessDTO.fixStatus == 3"><span class="btn_t">退换机</span></td>
                          <td v-else></td>
  <!--                        <th>-->
  <!--                          {{$t('center.CompletionNote')}}-->
  <!--                        </th>-->
  <!--                        <td colspan="5">-->
  <!--                          {{ formData.soOrderProcessDTO.finishNote }}-->
  <!--                        </td>-->
                        </tr>
                        <tr>
                          <th>
                            {{$t('center.CompletionNote')}}
                          </th>
                          <td colspan="7">
                            {{ formData.soOrderProcessDTO.finishNote }}
                          </td>
                        </tr>
                        <div class="product" style="">
                          <vxe-table ref="filterTable" :data="formData.soOrderFaultDTOList" class="table_item"
                            style="margin: 1px auto; width: 94%;" :stripe="true"
                            :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', fontWeight: '600', color: '#808080', width: '95%' }"
                            :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                            show-overflow height="100" :column-config="{ resizable: true }">
                            <vxe-column type="seq" width="55">
                            </vxe-column>

                            <vxe-column field="symptomName" :title="$t('center.FaultPhenomenon')"></vxe-column>
                            <vxe-column field="reasonName" :title="$t('center.FaultCause')" />
                            <vxe-column field="methodName" :title="$t('center.ServiceMeasure')" />
                            <vxe-column field="serverTypeName" :title="$t('center.ServiceType')" />
                            <vxe-column  field="fee" :title="$t('center.expense')">
                              <template #default="{row}">
                                <span v-if="isSite">*</span>
                                <span v-else>{{ row.fee }}</span>
                              </template>
                            </vxe-column>
                          </vxe-table>
                        </div>
                      </tbody>
                    </table>
                  </div>


                  <div class="d-item" v-if="formData.serviceType == 14">
                    <div class="title first"><b>安装与改造建议</b>
                    </div>
                    <div>
                      <div>
                        <table class="table-detail" style="display: block;">
                          <tbody style="display: block;">

                          <tr>
                            <th>宽</th>
                            <td><span class="btn_f">{{formData.soOrderResultDTO.installWidth}}mm</span></td>
                            <th>高</th>
                            <td><span class="btn_f">{{formData.soOrderResultDTO.installHign}}mm</span></td>
                            <th>深</th>
                            <td><span class="btn_f">{{formData.soOrderResultDTO.installDepth}}mm</span></td>
                          </tr>
                          <tr>
                            <th>安装建议</th>
                            <td v-if="formData.soOrderResultDTO.installSuggest == 1">无需改造即可安装</td>
                            <td v-else-if="formData.soOrderResultDTO.installSuggest == 2">改造后可安装</td>
                            <td v-else-if="formData.soOrderResultDTO.installSuggest == 3">无法改造无法安装</td>
                            <td v-else></td>
                            <th>用户改造意愿</th>
                            <td v-if="formData.soOrderResultDTO.transforIntention == 1">是</td>
                            <td v-else-if="formData.soOrderResultDTO.transforIntention == 2">否</td>
                            <td v-else-if="formData.soOrderResultDTO.transforIntention == 3">考虑中</td>
                            <td v-else></td>
                            <th>需要改造原因</th>
                            <td>{{formData.soOrderResultDTO.transforReasonNames}}</td>
                          </tr>
                          <tr>
                            <th>改造项目</th>
                            <td>{{formData.soOrderResultDTO.transforProjectNames}}</td>
                            <th>预计改造工期</th>
                            <td>{{formData.soOrderResultDTO.transforDays}}天</td>
                            <th>是否需要额外辅材</th>
                            <td v-if="formData.soOrderResultDTO.isNeedMaterial == 0">否</td>
                            <td v-else-if="formData.soOrderResultDTO.isNeedMaterial == 1">是</td>
                            <td v-else></td>
                          </tr>
                          <tr>
                            <th>
                              改造方案
                            </th>
                            <td colspan="7">
                                {{ formData.soOrderResultDTO.transforPlan }}
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="d-item" v-if="formData.serviceType == 14">
                    <div class="title first"><b>设计明细</b>
                    </div>
                    <div>
                      <div>
                        <vxe-table ref="filterTable" :data="formData.soOrderDesignResultDTOList" class="table_item"
                                   style="margin: 1px auto; width: 94%;" :stripe="true"
                                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                   show-overflow height="200" :column-config="{ resizable: true }">
                          <vxe-column type="seq"  :title="$t('common.SerialNumber')" width="60">
                          </vxe-column>
                          <vxe-column field="designName"  :title="'设计项目名称'" width="120"/>
                          <vxe-column field="fieldName"  :title="'设计项目明细名称'" width="120"/>
                          <vxe-column field="fieldValue"  :title="'设计项目明细值'" width="120"/>
                          <vxe-column field="fieldUnit"  :title="'单位'" width="120"/>
                        </vxe-table>
                      </div>
                    </div>
                  </div>

                  <div class="d-item" v-if="formData.serviceType == 14">
                    <div class="title first"><b>勘探明细</b>
                    </div>
                    <div>
                      <div>
                        <vxe-table ref="filterTable" :data="formData.soOrderDesignSurveyResultList" class="table_item"
                                   style="margin: 1px auto; width: 94%;" :stripe="true"
                                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                   show-overflow height="200" :column-config="{ resizable: true }">
                          <vxe-column type="seq"  :title="$t('common.SerialNumber')" width="60">
                          </vxe-column>
                          <vxe-column field="surveyName"  :title="'勘测项目名称'" width="120"/>

                          <vxe-column field="surveyResult"  :title="'勘测结果'" width="230">
                            <template #default="{ row }">
                              <span v-if="row.surveyResult == 1">符合</span>
                              <span v-if="row.surveyResult == 2">不符合</span>
                            </template>
                          </vxe-column>
                        </vxe-table>
                      </div>
                    </div>
                  </div>

                  <div class="d-item" v-if="formData.serviceType == 14">
                    <div class="title first"><b>费用明细</b>
                    </div>
                    <div>
                      <div>
                        <vxe-table ref="filterTable" :data="formData.soOrderDesignFeeResultList" class="table_item"
                                   style="margin: 1px auto; width: 94%;" :stripe="true"
                                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                   show-overflow height="200" :column-config="{ resizable: true }">
                          <vxe-column type="seq"  :title="$t('common.SerialNumber')" width="60">
                          </vxe-column>
                          <vxe-column field="feeName"  :title="'费用名称'" width="120"/>

                          <vxe-column field="manualFee"  :title="'人工费用'" width="150"/>
                          <vxe-column field="materialFee"  :title="'材料费用'" width="150"/>
                          <vxe-column field="remark"  :title="'备注'" width="250"/>
                        </vxe-table>
                      </div>
                    </div>
                  </div>

                  <div class="d-item">
                    <div class="title first"><b> {{$t('center.ReplacementParts')}}</b>
                      <!-- <el-button type="primary" class="button-sty btn_zdy" @click="AddListRow1_2()">
                        <i class="el-icon-plus"></i>
                        新增
                      </el-button> -->
                    </div>
                    <div>
                      <div>
                        <vxe-table ref="filterTable" :data="formData.soOrderPartsDTOList" class="table_item"
                          style="margin: 1px auto; width: 94%;" :stripe="true"
                          :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                          :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                          show-overflow height="100" :column-config="{ resizable: true }">
                          <vxe-column type="seq"  :title="$t('common.SerialNumber')" width="60">
                          </vxe-column>
                          <!-- <vxe-column field="oldPartsName" title="旧配件名称" /> -->
                          <vxe-column field="partsCode"  :title="$t('center.NewPartsCode')" width="120"/>
                          <vxe-column field="partsName"  :title="$t('center.NewPartName')" width="120"/>

                          <!-- <vxe-column field="oldPartsCode" title="旧配件编码" /> -->
                          <vxe-column field="barcode"  :title="$t('center.NewPartsBarcode')" width="150"/>
                          <vxe-column field="qty"  :title="$t('center.ReplacementQuantity')" width="150"/>

                          <!-- <vxe-column field="barcode2" title="旧配件条码" /> -->
                          <vxe-column field="sitePrice"   :title="$t('center.DotPrice')" width="150">
                            <template #default="{row}">
                              <span v-if="isSite">*</span>
                              <span v-else>{{row.sitePrice}}</span>
                            </template>
                          </vxe-column>
                          <vxe-column field="amount"   :title="$t('center.amount')" width="150">
                            <template #default="{row}">
                              <span v-if="isSite">*</span>
                              <span v-else>{{row.amount}}</span>
                            </template>
                          </vxe-column>
                          <!-- <vxe-column field="returnQty" title="网点返厂数量" /> -->
                          <!-- <vxe-column field="returnRevQty" title="返厂数量" /> -->
                          <vxe-column field="isNeedReturn"  :title="$t('center.WhetherReturnFactory')" width="230">
                            <template #default="{ row }">
                              <span v-if="row.isNeedReturn == 1">是</span>
                              <span v-if="row.isNeedReturn == 0">否</span>
                            </template>
                          </vxe-column>

                          <vxe-column field="packageNo"  title="袋码" width="150"/>
                          <vxe-column field="qrCodeFlag"  title="一物一码" width="230">
                            <template #default="{ row }">
                              <span v-if="row.qrCodeFlag == 1">是</span>
                              <span v-if="row.qrCodeFlag == 0">否</span>
                            </template>
                          </vxe-column>
                          <vxe-column field="barcode2"  title="旧件条码" width="150"/>
                          <vxe-column field="barcode"  title="新件条码" width="150"/>


                          <vxe-column field="isCheck"  :title="$t('center.WhetherTrueNot')" width="180">
                            <template #default="{ row }">
                              <span v-if="row.isCheck == 1">属实</span>
                              <span v-if="row.isCheck == 2">不属实</span>
                              <span v-if="row.isCheck == 3">无果</span>
                            </template>
                          </vxe-column>
                          <vxe-column  :title="$t('center.OtherInformation')" width="150">
                            <template #default="{ row }">
                              <span style="color: #2a6494;" @click="openChangeDialog(row)">更多信息</span>

                            </template>
                          </vxe-column>
                          <!-- 冲账 -->
                          <!-- <vxe-column field="offAccounting" title="是否冲帐" :formatter="formatter4" />
                          <vxe-column field="offAccountingNo" title="冲帐单号" /> -->
                        </vxe-table>
                      </div>
                    </div>
                  </div>

                  <div class="d-item">
                    <div class="title first"><b>{{$t('center.FeeSettlementSServiceProvider')}}</b>
                      <!-- <span v-if="isSite" class="expense">{{$t('center.CostThisOrder')}}:*</span> -->
                      <span v-if="isSite" class="expense">{{$t('center.CostThisOrder')}}:*</span>

                      <span v-else class="expense">{{$t('center.CostThisOrder')}}:{{formData.soOrderSettleDTO.siteFinalAmount }}</span>
                    </div>

                    <table  class="table-detail">
                      <tbody>
                        <div>
                          <tr>
                            <th>{{$t('center.StandardBase')}}</th>
                            <td v-if="isSite">*</td>
                            <td v-else>{{ formData.soOrderSettleDTO.standardBase }}</td>

                            <th>{{$t('center.ServiceCharge')}}</th>
                            <td v-if="isSite">
                              *
  <!--                            <el-checkbox v-model="{{*}}"></el-checkbox>-->
  <!--                            ({{$t('center.PassNot')}})-->
                            </td>
                            <td v-else>
                              {{ formData.soOrderSettleDTO.siteAmount }}
                              <el-checkbox v-model="formData.soOrderSettleDTO.siteAmountPass"></el-checkbox>
                              ({{$t('center.PassNot')}})
                            </td>
                          </tr>
                        </div>
                        <div>
                          <tr>
                            <th>
                              {{$t('center.RegionalCoefficient')}}
                            </th>
                            <td v-if="isSite">
                              *
                            </td>
                            <td v-else>
                              {{ formData.soOrderSettleDTO.areaCoefficient }}
                            </td>

                            <th>
                              {{$t('center.DotStarFactor')}}
                            </th>
                            <td v-if="isSite">
                              *
                            </td>
                            <td v-else>
                              {{ formData.soOrderSettleDTO.startCoefficient }}
                            </td>

                            <th>{{$t('center.SatisfactionCoefficient')}}</th>
                            <td v-if="isSite">
                              *
                            </td>
                            <td v-else>
                              {{ formData.soOrderSettleDTO.satisfactionCoefficient }}
                            </td>
                          </tr>
                        </div>
                        <div>
                          <tr>
                            <th>
                              {{$t('center.bonus')}}
                            </th>
                            <td v-if="isSite">
                              *
                            </td>
                            <td v-else>
                              {{ formData.soOrderSettleDTO.bonusFee }}
                              <el-checkbox v-model="formData.soOrderSettleDTO.bonusFeePass"></el-checkbox>

                            </td>

                            <th>
                              {{$t('center.RewardPunish')}}
                            </th>

                            <td v-if="isSite">
                              *
                            </td>
                            <td v-else>
                              {{ formData.soOrderSettleDTO.rewardAmount }}
                              <el-popover placement="top-start" width="205" trigger="hover">
                                <div>
                                  <p>奖罚原因: {{formData.soOrderSettleDTO.rewardReason}}</p>
                                </div>
                                <span slot="reference" class="Instructions">{{$t('center.CheckTheCause')}}</span>
                              </el-popover>
                            </td>

                            <th>{{$t('center.DistanceCharge')}}</th>
                            <td v-if="isSite">
                              *
                            </td>
                            <td v-else>
                              {{ formData.soOrderSettleDTO.longDistanceAmount
                              }}({{ formData.soOrderSettleDTO.mapLongDistance }}/{{ formData.soOrderSettleDTO.longDistance }})
                              <el-popover placement="top-start" width="205" trigger="hover">
                                <div>
                                  <p>(地图远程数 / 远程公里数)</p>
                                  <p>远程开始地址: {{formData.soOrderSettleDTO.mapBeginAddress}}</p>
                                  <p>远程结束地址: {{formData.soOrderSettleDTO.mapEndAddress}}</p>
                                </div>
                                <span slot="reference" class="Instructions">{{$t('center.FieldDescription')}}</span>
                              </el-popover>



                            </td>

                            <th>
                              {{$t('center.ADHocExpense')}}
                            </th>
                            <td v-if="isSite">
                              *
                            </td>
                            <td v-else>
                              {{ formData.soOrderSettleDTO.specailAmount }}<span class="Instructions"
                                @click="openRecordDialog(e)">{{$t('center.ViewCertificate')}}</span>
                              <!-- <i class="el-icon-tickets" style="margin-left:10px;color: #2a6494;"
                              @click="show3 = !show3">详细</i> -->
                            </td>

                          </tr>
                        </div>
                        <div>
                          <tr>
                            <th>
                            远程开始地址
                            </th>
                            <td>
                              {{formData.soOrderSettleDTO.mapBeginAddress}}/
                              {{formData.soOrderSettleDTO.mapBeginAddressLongitude}}/
                              {{formData.soOrderSettleDTO.mapBeginAddressLatitude}}
                            </td>


                            <th>
                              远程结束地址
                            </th>
                            <td>
                              {{formData.soOrderSettleDTO.mapEndAddress}}/
                              {{formData.soOrderSettleDTO.mapEndAddressLongitude}}/
                              {{formData.soOrderSettleDTO.mapEndAddressLatitude}}
                            </td>


                            <th>远程距离</th>
                            <td>
                              {{ formData.soOrderSettleDTO.longDistance }}

                            </td>

                            <th>远程结算月份</th>
                            <td>
                              {{ formData.soOrderSettleDTO.longDistanceMonth }}

                            </td>

                          </tr>
                          <tr>
                            <th>远程费结算备注</th>
                            <td colspan="7">
                              {{ formData.soOrderSettleDTO.settleRemark }}
                            </td>
                          </tr>
                        </div>

                        <div v-for="item in dataList" :key="item.id">
                          <tr>
                            <th v-if="item.length > 0">{{ item[0].key }}</th>
                            <td v-if="item.length > 0">{{ item[0].value }}</td>

                            <th v-if="item.length > 1">{{ item[1].key }}</th>
                            <td v-if="item.length > 1">{{ item[1].value }}</td>

                            <th v-if="item.length > 2">{{ item[2].key }}</th>
                            <td v-if="item.length > 2">{{ item[2].value }}</td>

                            <th v-if="item.length > 3">{{ item[3].key }}</th>
                            <td v-if="item.length > 3">{{ item[3].value }}</td>
                          </tr>
                        </div>

                        <!--                      <td>-->
                        <!--                        <el-input type="text" autocomplete="off" v-model="tenant.esiteOrderMan4" clearable/>-->
                        <!--                      </td>-->

                      </tbody>
                    </table>
                    <div>

                      <!--                    <vxe-table ref="filterTable" :data="formData.soOrderFeeAttribute"-->
                      <!--                      style="margin: 1px auto; width: 94%;" :stripe="true"-->
                      <!--                      :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"-->
                      <!--                      :row-config="{height: 30,isHover: true,padding: 0,}" :row-style="{ fontSize: '12px',  }"-->
                      <!--                      show-overflow height="100" :column-config="{ resizable: true }">-->

                      <!--                      <vxe-column type="seq" width="55"> </vxe-column>-->
                      <!--                      <vxe-column field="feeAttributeId" title="费用类型" width="150" />-->
                      <!--                      <vxe-column field="feeAttributeName" title="费用名称" width="150" />-->
                      <!--                      <vxe-column field="amount" title="金额" width="100" />-->


                      <!--                    </vxe-table>-->
                      <vxe-table ref="filterTable" :data="soOrderSpecailFeeListToCompany"
                        style="margin: 1px auto; width: 94%;margin-top: 10px;" :stripe="true"
                        :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                        :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                        show-overflow height="100" :column-config="{ resizable: true }">
                        <vxe-column type="seq" width="55">
                        </vxe-column>

                        <!-- <vxe-column field="itemCode" title="产品编码"/> -->
                        <!--                      <vxe-column field="feeType" title="类型"/>-->

                        <vxe-column field="subjectName" :title="$t('center.ADHocExpenseName')" />
                        <vxe-column field="qty" :title="$t('center.quantity')" />
                        <vxe-column field="price" :title="$t('center.UnitPrice')" />
                        <vxe-column field="amount" :title="$t('center.amount')" />
                        <vxe-column field="unit" :title="$t('center.UnitOfAccount')" />


                      </vxe-table>

                    </div>
                  </div>
                  <div class="d-item">
                    <div class="title first">
                      <b>{{$t('center.ChargeSettlementUUser')}}</b>
                      <span class="expense">{{$t('center.TheTotalCostThisOrder')}}:{{ formData.soOrderSettleDTO.userPayAmount }}</span>
                      <!-- <span @click="more = !more" class="more">查看更多</span> -->

                    </div>
                    <!-- <div v-show="more"> -->
                    <el-collapse>
                      <el-collapse-item name="1">
                        <table class="table-detail">
                          <tbody>
                            <tr>
                              <th>{{$t('center.DiscountAmount')}}</th>
                              <td>
                                {{ formData.soOrderSettleDTO.userPayDiscount }}
                              </td>
                              <th>{{$t('center.PaymentMethod')}}</th>
                              <td>
                                {{ formData.soOrderSettleDTO.userPayType }}
                              </td>

                              <th>{{$t('center.NameThePayer')}}</th>
                              <td>
                                {{ formData.soOrderSettleDTO.userPayName }}
                              </td>

                              <th>{{$t('center.PayerAccountNumber')}}</th>
                              <td>
                                {{ formData.soOrderSettleDTO.userPayAccount }}
                              </td>


                              <th>{{$t('center.PaymentStatement')}}</th>
                              <td>
                                {{ formData.soOrderSettleDTO.userPayNo }}
                              </td>

                            </tr>
                            <tr>
                              <th>{{$t('center.PaymentStatus')}}</th>
                              <td v-if="formData.soOrderSettleDTO == null || formData.soOrderSettleDTO.userPayStat == null">
                              </td>
                              <td v-else-if="formData.soOrderSettleDTO.userPayStat == 1">未支付</td>
                              <td v-else-if="formData.soOrderSettleDTO.userPayStat == 2">待支付</td>
                              <td v-else-if="formData.soOrderSettleDTO.userPayStat == 5">支付成功</td>
                              <td v-else-if="formData.soOrderSettleDTO.userPayStat == 8">支付失败</td>
                              <td v-else-if="formData.soOrderSettleDTO.userPayStat == 9">支付关闭</td>
                              <td v-else></td>
                              <th>{{$t('center.TimePayment')}}</th>
                              <td>
                                {{ formData.soOrderSettleDTO.userPayTime }}
                              </td>

                              <th>{{$t('center.PaymentNote')}}</th>
                              <td>
                                {{ formData.soOrderSettleDTO.userPayStatMsg }}
                              </td>
                              <th>{{$t('center.ReasonsWhyUsersPay')}}</th>
                              <td>
                                {{ formData.soOrderSettleDTO.userPayRemark }}
                              </td>
                            </tr>
                            <tr>
                              <th>{{$t('center.PaymentDocument')}} 1</th>
                              <td>
                                <el-image v-if="formData.soOrderResultDTO.userPayPic1"
                                  :src="formData.soOrderResultDTO.userPayPic1" :fit="fit" :preview-src-list="srcList"
                                  :initial-index="0"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </td>
                              <th>{{$t('center.PaymentDocument')}} 2</th>
                              <td>
                                <el-image v-if="formData.soOrderResultDTO.userPayPic2"
                                  :src="formData.soOrderResultDTO.userPayPic2" :fit="fit" :preview-src-list="srcList"
                                  :initial-index="0"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </td>
                              <th>{{$t('center.PaymentDocument')}} 3</th>
                              <td>
                                <el-image v-if="formData.soOrderResultDTO.userPayPic3"
                                  :src="formData.soOrderResultDTO.userPayPic3" :fit="fit" :preview-src-list="srcList"
                                  :initial-index="0"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div>
                          <vxe-table ref="filterTable" :data="soOrderSpecailFeeListToUser"
                            style="margin: 1px auto; width: 94%;margin-top: 10px;" :stripe="true"
                            :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                            :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                            show-overflow height="100" :column-config="{ resizable: true }">
                            <vxe-column type="seq" width="55">
                            </vxe-column>

                            <vxe-column field="subjectName" :title="$t('center.ADHocExpenseName')" />
                        <vxe-column field="qty" :title="$t('center.quantity')" />
                        <vxe-column field="price" :title="$t('center.UnitPrice')" />
                        <vxe-column field="amount" :title="$t('center.amount')" />
                        <vxe-column field="unit" :title="$t('center.UnitOfAccount')" />


                          </vxe-table>
                        </div>
                      </el-collapse-item></el-collapse>
                    <!-- </div> -->
                  </div>

                  <div class="d-item" v-if="showEngineerAmount">
                    <div class="title first">
                      <b>费用结算(工程师)</b>

                    </div>
                    <el-collapse>
                      <el-collapse-item name="2">
                        <table class="table-detail">
                          <tbody>
                          <tr>
                            <th>奖罚金额</th>
                            <td>{{ formData.soOrderSettleDTO.engineerReward }}</td>
                            <th>奖罚原因</th>
                            <td>
                              {{ formData.soOrderSettleDTO.engineerRewardReason }}
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </el-collapse-item>
                    </el-collapse>
                  </div>

                  <div class="d-item">
                    <div class="title first"><b>{{$t('center.FinishedData')}}</b></div>
                    <table class="table-detail">
                      <tbody>
                      <tbody>
                        <div v-for="item in formData.soOrderLineResultDTOList" :key="item.id">
                          <div>
                            <tr>
                              <div style="background-color: #eff6fc; border-radius: 10px; padding: 10px;">
                                {{$t('center.CorrespondingProduct')}}: {{ item.itemName }}
                              </div>
                              <div>
                                <th>{{$t('center.MachineBarCode')}} 1</th>
                                <td>
                                  {{ item.inCode }}
                                </td>

                                <th v-if="item.outCode!=null&&item.outCode!=''">{{$t('center.MachineBarCode')}} 2</th>
                                <td v-if="item.outCode!=null&&item.outCode!=''">
                                  {{ item.outCode }}
                                </td>

                                <th v-if="item.barCode3!=null&&item.barCode3!=''">{{$t('center.MachineBarCode')}} 3</th>
                                <td v-if="item.barCode3!=null&&item.barCode3!=''">
                                  {{ item.barCode3 }}
                                </td>

                                <th >{{$t('center.ProductionDate')}}</th>
                                <td>
                                  {{ item.productDate }}
                                </td>

                                <th>
                                  {{$t('center.InstallationTime')}}
                                </th>
                                <td>
                                  {{ item.installDate }}
                                </td>

                                <th>
                                  {{$t('center.WarrantyType')}}
                                </th>
                                <td v-if="item.guaranteeType == 1">保内</td>
                                <td v-else-if="item.guaranteeType == 2">保外</td>
                                <td v-else-if="item.guaranteeType == 3">类型不详</td>
                                <td v-else></td>
                              </div>
                            </tr>
                          </div>


                          <tr>
                            <div style="" class="pic_main">
                              <div class="pic_item">
                                <span v-if="item.finishPic1Name">
                                  {{item.finishPic1Name}}
                                </span>
                                <span v-else>{{$t('center.picture')}} 1：</span>
                                <el-image v-if="item.finishPic1" :src="item.finishPic1" :fit="fit"
                                  :preview-src-list="srcList" :initial-index="0"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </div>

                              <div class="pic_item">
                                <span v-if="item.finishPic2Name">
                                  {{item.finishPic2Name}}
                                </span>
                                <span v-else>{{$t('center.picture')}} 2：</span>
                                <el-image v-if="item.finishPic2" :src="item.finishPic2" :fit="fit"
                                  :preview-src-list="srcList" :initial-index="1"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </div>
                              <div class="pic_item">
                                <span v-if="item.finishPic3Name">
                                  {{item.finishPic3Name}}
                                </span>
                                <span v-else>{{$t('center.picture')}} 3：</span>
                                <el-image v-if="item.finishPic3" :src="item.finishPic3" :fit="fit"
                                  :preview-src-list="srcList" :initial-index="2"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </div>
                              <div class="pic_item">
                                <span v-if="item.finishPic4Name">
                                  {{item.finishPic4Name}}
                                </span>
                                <span v-else>{{$t('center.picture')}} 4：</span>
                                <el-image v-if="item.finishPic4" :src="item.finishPic4" :fit="fit"
                                  :preview-src-list="srcList" :initial-index="3"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </div>
                              <div class="pic_item">
                                <span v-if="item.finishPic5Name">
                                  {{item.finishPic5Name}}
                                </span>
                                <span v-else>{{$t('center.picture')}} 5：</span>
                                <el-image v-if="item.finishPic5" :src="item.finishPic5" :fit="fit"
                                  :preview-src-list="srcList" :initial-index="4"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </div>
                              <div class="pic_item">
                                <span v-if="item.finishPic6Name">
                                  {{item.finishPic6Name}}
                                </span>
                                <span v-else>{{$t('center.picture')}} 6：</span>
                                <el-image v-if="item.finishPic6" :src="item.finishPic6" :fit="fit"
                                  :preview-src-list="srcList" :initial-index="5"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </div>
                              <div class="pic_item">
                                <span v-if="item.finishPic7Name">
                                  {{item.finishPic7Name}}
                                </span>
                                <span v-else>{{$t('center.picture')}} 7：</span>
                                <el-image v-if="item.finishPic7" :src="item.finishPic7" :fit="fit"
                                  :preview-src-list="srcList" :initial-index="6"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </div>
                              <div class="pic_item">
                                <span>购机凭证</span>
                                <el-image v-if="formData.soOrderResultDTO.buyPic" :src="formData.soOrderResultDTO.buyPic" :fit="fit"
                                          :preview-src-list="srcList" :initial-index="7"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                       style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </div>
                            </div>
                          </tr>
                          <tr>
                            <div style="" class="pic_main">
                              <div class="pic_item">
                                <span>购机图片:</span>
                                <el-image v-if="item.buyPic" :src="item.buyPic" :fit="fit"
                                          :preview-src-list="srcList" :initial-index="6"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                       style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </div>
                            </div>

                            <div style="width:10vw!important;">
                              <td style="padding-left: 0!important;">
                                <div style="display: flex;">

                                  <div class="videoP" v-if="formData.soOrderProcessDTO.custComfirmVedioUrl">

                                    <div style="width:40%;    position: relative;" class="videoImg">
                                      <el-image style="width: 30px; height: 35px"
                                                :src="require('@/views/dialogCommon/video.jpg')" fit="fit"></el-image>
                                      <div @click="openVideo(formData.soOrderProcessDTO.custComfirmVedioUrl)" class="imgY"><i class="el-icon-video-play"></i></div>
                                    </div>

                                    <div style="width:50%;display:flex;    flex-direction: column;justify-content: space-between;align-items: flex-end;">
                                      <span>{{formData.vedioName}}</span>
                                      <div @click="handleDownload( '用户无法确认视频',formData.soOrderProcessDTO.custComfirmVedioUrl)">
                                        <el-tooltip class="item" effect="dark" content="下载" placement="top">
                                          <i class="el-icon-download"></i>
                                        </el-tooltip>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </td>
                            </div>
                          </tr>
                          <template v-if="index !== formData.soOrderLineResultDTOList.length - 1">
                            <hr>
                          </template>
                        </div>

                      </tbody>
                      </tbody>
                    </table>

                  </div>
                  <div style="height:160px"></div>
                </div>
              </el-tab-pane>
              <el-tab-pane :label="$t('center.FollowUpRecord')" name="four">
                <div class="d-cont edit-mce-box"
                  style=" overflow: unset!important;overflow-y: scroll!important;height: 100vh!important; ">

                  <div class="d-item">
                    <div>
                      <div style="height: calc(calc(100vh + -180px ));">
                        <vxe-table ref="filterTable" :data="formData.operationDTOS" class="table_item"
                          style="margin: 1px auto; width: 94%;" :stripe="true"
                          :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                          :row-config="{ maxHeight: '100px', isHover: true, padding: 0,lineHeight: '20px', }" :row-style="{ fontSize: '12px',maxHeight: '300px!important',overflow: 'auto' }"
                          show-overflow height="100%" :column-config="{ resizable: true }">
                          <vxe-column field="createTime" :title="$t('center.time')"  width="180" />

                          <vxe-column field="createBy" :title="$t('center.operator')"  width="150" />
                          <vxe-column field="title" :title="$t('center.title')"  width="200" />
                          <vxe-column field="siteShow" title="是否网点处理" width="200">
                            <template #default="{row}">
                              <span v-if="row.siteShow==1">是</span>
                              <span v-else>否</span>
                            </template>
                          </vxe-column>
                          <vxe-column field="content" :title="$t('center.content')"  width="350" >
                            <template #default="{ row }">
                              <div  style="overflow: scroll;color: #268AEA; white-space:pre-wrap!important;max-height:160px" v-html="row.content"></div>
                              <div  style="overflow: scroll;color: #268AEA; white-space:pre-wrap!important;max-height:160px" v-if="row.replyContent!=null" v-html="'回复:'+row.replyContent">
                              </div>
                              <span class="fuJian" v-if="row.replyAttachment1"><span @click="openVideo(row.replyAttachment1)">附件1</span> <span style="margin-left: 5px" @click="handleDownload('附件1',row.replyAttachment1)"><i class="el-icon-download"></i></span></span>
                              <span style="margin-left: 5px" class="fuJian" v-if="row.replyAttachment2"><span @click="openVideo(row.replyAttachment2)">附件2</span> <span style="margin-left: 5px" @click="handleDownload('附件2',row.replyAttachment2)"><i class="el-icon-download"></i></span></span>
                              <span style="margin-left: 5px" class="fuJian" v-if="row.replyAttachment3"><span @click="openVideo(row.replyAttachment3)">附件3</span> <span style="margin-left: 5px" @click="handleDownload('附件3',row.replyAttachment3)"><i class="el-icon-download"></i></span></span>
                            </template>
                          </vxe-column>
                          <!-- 附件 -->
                          <vxe-column field="file1Name" title="附件1" width="100">
                            <template #default="{row}">
                              <span class="fuJian" v-if="row.file1Url"><span @click="openVideo(row.file1Url)">{{row.file1Name}}</span> <span @click="handleDownload(row.file1Name,row.file1Url)"><i class="el-icon-download"></i></span></span>
                              <span v-else></span>
                            </template>
                          </vxe-column>
                          <vxe-column field="file2Name" title="附件2" width="100">
                            <template #default="{row}">
                              <span class="fuJian" v-if="row.file2Url"><span @click="openVideo(row.file2Url)">{{row.file2Name}}</span> <span @click="handleDownload(row.file2Name,row.file2Url)"><i class="el-icon-download"></i></span></span>
                              <span v-else></span>
                            </template>
                          </vxe-column>
                          <vxe-column field="file3Name" title="附件3" width="100">
                            <template #default="{row}">
                              <span class="fuJian" v-if="row.file3Url"><span @click="openVideo(row.file3Url)">{{row.file3Name}}</span> <span @click="handleDownload(row.file3Name,row.file3Url)"><i class="el-icon-download"></i></span></span>
                              <span v-else></span>
                            </template>
                          </vxe-column>
                          <vxe-column field="replyStatus" title="操作" width="100" show-overflow>
                            <template #default="{row}">
                              <span class="fuJian" v-if="isSite"><span @click="doReply(row)" style="color: #0a84ff">回复</span> </span>
                              <span v-else></span>
                            </template>
                          </vxe-column>

                        </vxe-table>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>


              <el-tab-pane :label="$t('center.SLARecord')" name="five">
                <div class="d-cont edit-mce-box"
                  style=" overflow: unset!important;overflow-y: scroll!important;height: 100vh!important; ">

                  <div class="d-item">
                    <div>
                      <div>
                        <vxe-table ref="filterTable" :data="formData.soOrderSlaList" class="table_item"
                          style="margin: 1px auto; width: 94%;" :stripe="true"
                          :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                          :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                          show-overflow height="300" :column-config="{ resizable: true }">
                          <!--                        <vxe-column type="selection" width="55">-->
                          <!--                        </vxe-column>-->
                          <vxe-column field="slaName" :title="$t('center.SLAName')" width="180" />
                          <vxe-column field="checkBillNo" :title="$t('center.CheckNumber')" width="180" />
                          <vxe-column field="beginDate" :title="$t('center.StartTime')" />
                          <vxe-column field="endDate" :title="$t('center.ResponseEndTime')" />
                          <vxe-column field="realEndDate" :title="$t('center.ActualEndTime')" />
                          <vxe-column field="overHours" :title="$t('center.ExcessHours')" />
                          <vxe-column field="createBy" :title="$t('common.founder')" />
                          <vxe-column field="createTime" :title="$t('common.CreationTime')" width="180" />
                        </vxe-table>
                      </div>
                    </div>
                  </div>

                  <div style="height:160px"></div>


                </div>
              </el-tab-pane>

              <el-tab-pane :label="'上门设计详情'" name="six">
                <div class="d-cont edit-mce-box"
                     style=" overflow: unset!important;overflow-y: scroll!important;height: 100vh!important; ">
                  <div class="d-item">
                    <div class="title first"><b>安装与改造建议</b>
                    </div>
                    <div>
                      <div>
                        <table class="table-detail" style="display: block;">
                          <tbody style="display: block;">

                          <tr>
                            <th>宽</th>
                            <td><span class="btn_f">{{formData.soOrderResultDTO.installWidth}}mm</span></td>
                            <th>高</th>
                            <td><span class="btn_f">{{formData.soOrderResultDTO.installHign}}mm</span></td>
                            <th>深</th>
                            <td><span class="btn_f">{{formData.soOrderResultDTO.installDepth}}mm</span></td>
                          </tr>
                          <tr>
                            <th>安装建议</th>
                            <td v-if="formData.soOrderResultDTO.installSuggest == 1">无需改造即可安装</td>
                            <td v-else-if="formData.soOrderResultDTO.installSuggest == 2">改造后可安装</td>
                            <td v-else-if="formData.soOrderResultDTO.installSuggest == 3">无法改造无法安装</td>
                            <td v-else></td>
                            <th>用户改造意愿</th>
                            <td v-if="formData.soOrderResultDTO.transforIntention == 1">是</td>
                            <td v-else-if="formData.soOrderResultDTO.transforIntention == 2">否</td>
                            <td v-else-if="formData.soOrderResultDTO.transforIntention == 3">考虑中</td>
                            <td v-else></td>
                            <th>需要改造原因</th>
                            <td>{{formData.soOrderResultDTO.transforReasonNames}}</td>
                          </tr>
                          <tr>
                            <th>改造项目</th>
                            <td>{{formData.soOrderResultDTO.transforProjectNames}}</td>
                            <th>预计改造工期</th>
                            <td>{{formData.soOrderResultDTO.transforDays}}天</td>
                            <th>是否需要额外辅材</th>
                            <td v-if="formData.soOrderResultDTO.isNeedMaterial == 0">否</td>
                            <td v-else-if="formData.soOrderResultDTO.isNeedMaterial == 1">是</td>
                            <td v-else></td>
                          </tr>
                          <tr>
                            <th>
                              改造方案
                            </th>
                            <td colspan="7">
                                {{ formData.soOrderResultDTO.transforPlan }}
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="d-item">
                    <div class="title first"><b>设计明细</b>
                    </div>
                    <div>
                      <div>
                        <vxe-table ref="filterTable" :data="formData.soOrderDesignResultDTOList" class="table_item"
                                   style="margin: 1px auto; width: 94%;" :stripe="true"
                                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                   show-overflow height="200" :column-config="{ resizable: true }">
                          <vxe-column type="seq"  :title="$t('common.SerialNumber')" width="60">
                          </vxe-column>
                          <vxe-column field="designName"  :title="'设计项目名称'" width="120"/>
                          <vxe-column field="fieldName"  :title="'设计项目明细名称'" width="120"/>
                          <vxe-column field="fieldValue"  :title="'设计项目明细值'" width="120"/>
                          <vxe-column field="fieldUnit"  :title="'单位'" width="120"/>
                        </vxe-table>
                      </div>
                    </div>
                  </div>
                  <div class="d-item">
                    <div class="title first"><b>勘探明细</b>
                    </div>
                    <div>
                      <div>
                        <vxe-table ref="filterTable" :data="formData.soOrderDesignSurveyResultList" class="table_item"
                                   style="margin: 1px auto; width: 94%;" :stripe="true"
                                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                   show-overflow height="200" :column-config="{ resizable: true }">
                          <vxe-column type="seq"  :title="$t('common.SerialNumber')" width="60">
                          </vxe-column>
                          <vxe-column field="surveyName"  :title="'勘测项目名称'" width="120"/>

                          <vxe-column field="surveyResult"  :title="'勘测结果'" width="230">
                            <template #default="{ row }">
                              <span v-if="row.surveyResult == 1">符合</span>
                              <span v-if="row.surveyResult == 2">不符合</span>
                            </template>
                          </vxe-column>
                        </vxe-table>
                      </div>
                    </div>
                  </div>
                  <div class="d-item">
                    <div class="title first"><b>费用明细</b>
                    </div>
                    <div>
                      <div>
                        <vxe-table ref="filterTable" :data="formData.soOrderDesignFeeResultList" class="table_item"
                                   style="margin: 1px auto; width: 94%;" :stripe="true"
                                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                   show-overflow height="200" :column-config="{ resizable: true }">
                          <vxe-column type="seq"  :title="$t('common.SerialNumber')" width="60">
                          </vxe-column>
                          <vxe-column field="feeName"  :title="'费用名称'" width="120"/>

                          <vxe-column field="manualFee"  :title="'人工费用'" width="150"/>
                          <vxe-column field="materialFee"  :title="'材料费用'" width="150"/>
                          <vxe-column field="remark"  :title="'备注'" width="250"/>
                        </vxe-table>
                      </div>
                    </div>
                  </div>
                  <div style="height:160px"></div>
                </div>
              </el-tab-pane>

              <el-tab-pane :label="'用户权益'" name="seven">
                <div class="d-cont edit-mce-box"
                     style=" overflow: unset!important;overflow-y: scroll!important;height: 100vh!important; ">
                  <div class="d-item">
                    <div class="title first"><b>本单用户权益</b>
                    </div>
                    <div>
                      <div>
                        <vxe-table ref="filterTable" :data="formData.basCustRightsDTOList" class="table_item"
                                   style="margin: 1px auto; width: 94%;" :stripe="true"
                                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                   show-overflow height="200" :column-config="{ resizable: true }">
                          <vxe-column type="seq"  title="序号" width="60"></vxe-column>
                          <vxe-column field="rightsName" title="权益名称" width="120"/>
                          <vxe-column field="rightsRemark" title="权益说明" width="160"/>
                          <vxe-column field="rightsType"  title="权益类型" width="120">
                            <template #default="{ row }">
                              <span v-if="row.rightsType == 1">保修卡</span>
                              <span v-if="row.rightsType == 2">延保卡</span>
                              <span v-if="row.rightsType == 3">保养卡</span>
                              <span v-if="row.rightsType == 4">清洗卡</span>
                              <span v-if="row.rightsType == 9">其他</span>
                            </template>
                          </vxe-column>
                          <vxe-column field="rightsValue" title="权益值" width="120"/>
  <!--                        <vxe-column field="storeTimes" title="占用值" width="120"/>-->
                          <vxe-column field="residueQty" title="剩余值" width="120"/>
                          <vxe-column field="unit" title="单位" width="120"/>
                          <vxe-column field="endDate" title="有效截至时间" width="120"/>
                          <vxe-column field="rightsNo" title="权益卡号" width="120"/>
                          <vxe-column field="offStat"  title="核销状态" width="120">
                            <template #default="{ row }">
                              <span v-if="row.offStat == 0">未核销</span>
                              <span v-if="row.offStat == 2">已核销</span>
                            </template>
                          </vxe-column>
                          <vxe-column field="sourceNo" title="销售订单号" width="120"/>
                        </vxe-table>
                      </div>
                    </div>
                  </div>
  <!--                <div class="d-item">-->
  <!--                  <div class="title first"><b>本单已核销权益</b>-->
  <!--                  </div>-->
  <!--                  <div>-->
  <!--                    <div>-->
  <!--                      <vxe-table ref="filterTable" :data="formData.basCustRightsOffDTOList" class="table_item"-->
  <!--                                 style="margin: 1px auto; width: 94%;" :stripe="true"-->
  <!--                                 :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"-->
  <!--                                 :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"-->
  <!--                                 show-overflow height="200" :column-config="{ resizable: true }">-->
  <!--                        <vxe-column type="seq"  title="序号" width="60"></vxe-column>-->
  <!--                        <vxe-column field="rightsName" title="权益名称" width="120"/>-->
  <!--                        <vxe-column field="rightsType"  title="权益类型" width="120">-->
  <!--                          <template #default="{ row }">-->
  <!--                            <span v-if="row.rightsType == 1">保修卡</span>-->
  <!--                            <span v-if="row.rightsType == 2">延保卡</span>-->
  <!--                            <span v-if="row.rightsType == 3">保养卡</span>-->
  <!--                            <span v-if="row.rightsType == 4">清洗卡</span>-->
  <!--                            <span v-if="row.rightsType == 9">其他</span>-->
  <!--                          </template>-->
  <!--                        </vxe-column>-->
  <!--                        <vxe-column field="rightsValue" title="权益值" width="120"/>-->
  <!--&lt;!&ndash;                        <vxe-column field="storeTimes" title="占用值" width="120"/>&ndash;&gt;-->
  <!--                        <vxe-column field="residueQty" title="剩余值" width="120"/>-->
  <!--                        <vxe-column field="unit" title="单位" width="120"/>-->
  <!--                        <vxe-column field="endDate" title="有效截至时间" width="120"/>-->
  <!--                        <vxe-column field="rightsNo" title="权益卡号" width="120"/>-->
  <!--                        <vxe-column field="offStat"  title="核销状态" width="120">-->
  <!--                          <template #default="{ row }">-->
  <!--                            <span v-if="row.offStat == 0">未核销</span>-->
  <!--                            <span v-if="row.offStat == 2">已核销</span>-->
  <!--                          </template>-->
  <!--                        </vxe-column>-->
  <!--                        <vxe-column field="sourceNo" title="来源订单号" width="120"/>-->
  <!--                      </vxe-table>-->
  <!--                    </div>-->
  <!--                  </div>-->
  <!--                </div>-->
                  <div style="height:160px"></div>
                </div>
              </el-tab-pane>


            </el-tabs>
          </div>


        </el-form>
        <!-- 服务区域弹窗表 -->
      </div>

    </div>
  </template>

  <script>

  //查看家庭电话

  import request from "@/router/axios";
  // import preconditionDialog from './dialog';
  // import areaDialog from './areadialog.vue';
  import store from "@/store";
  import {companyMixins, editPageMixins, siteMixins} from "@/mixins/tabChang";

  // 城市三级联动
  import { regionData } from "element-china-area-data";
  import api from "@/api/projectApi";
  import { mapGetters } from "vuex";
  // 文件预览
  import Preview from "@/views/dialogCommon/PreviewDialog.vue";
  import {companyConfig} from "@/config/companyShotName";


  const cityOptions = ['挂壁式（5100W＜Q）变频', '挂壁式（3600W＜Q≤5100W）变频', '挂壁式（Q＜3200W）', '挂壁式 3200W≤Q≤3600W 变频'];
  const cityOptions2 = ['挂壁式1变频', '挂壁式222变频', '挂壁式3', '挂壁式 4'];
  export default {
    mixins: [editPageMixins, siteMixins, companyMixins],
    name: 'edit',
    props: {
      _dataId: [String, Number],


      dealType: {
        type: Boolean,
        default: false
      },
      pageType: {},
      isAppeal: false,
      siteDeal: false,
      subordSiteDeal:false,
      exceptionOrderDeal:false
    },
    components: {
      Preview,
    },
    data() {
      return {
        fit: ['fill'],
        isType:'',
        processId: '',
        orderDuration: {days:'',hours:''},

        showReplyDialog:false,
        replyParams:{},

        showFamilyMobileDialog: false,
        imgVisbleURL: '',

  showPreview: false,
        // 工单履历显示
        orderBlock:true,
        areaObj3: '',
        changeObj: '',
        stepNumber: '', //步骤条
        evaluate: '',
        evaluateLable: '',
        workNumber: '',

        showDetailsDialog: false,

        row11: '',// 旧件核销
        typeName: '',//点击单子的类型名字
        timeSeq: '',
        showOrderDetailDialog: false,  // 工单弹窗显示标识符
        associateDocumentId: null,  // 关联单据id

        showOrderJudgingDialog: false,
        showOrderComplaintHandlingDialog: false,
        showSiteOrderComplaintHandlingDialog: false,
        showOrderConsultHandlingDialog:false,
        showSiteOrderConsultHandlingDialog:false,
        showSelectOrderDialog:false,
        showEndDialog: false,
        showCheckBillDialog: false,
        showSupervisingDialog: false,

        recordDialog2: false,
        more: false,
        getBuyChannelListUrl: '/basic/basBuyChannel/getList',
        dispatchEngineerDialog: false,
        completionDialog: false,
        designCompletionDialog:false,
        completComfirmDialog: false,
        bookDialog: false,
        subcontractorDialog: false,
        showAssignDialog: false,
        showAssignByMapDialog: false,
        showCloseOrderDialog: false,
        showPhoneUnrealDialog: false,
        showOrderFinishOrRejectDialog: false,
        showNiuEnTaiOrderFinishOrRejectDialog: false,
        showOrgDialog: false,
        showOrderRemaekDialog: false,
        showExceptionDealDialog:false,
        showItemDialog: false,
        showCancelCheckDialog: false,
        showHangupDialog:false,
        showOrderEditDialog: false,
        showEngineerAmount:false,
        lineIndex: 0,
        assginType: 0,
        orderRemarkParam: {},
        assignSiteParam: {},
        isFinishOrReject: 1,
        //权限管理
        showPrice:true,
        simpleFinishOrder:false,
        suspendOrder:false,
        replaceBarcode:false,
        generateOrder:false,
        orderSaleRegister:false,
        orderQuestion:false,
        orderSearchAndShow: false,
        siteAcceptDialogShow: false,
        showSuspendDialog:false,
        showReplaceBarcodeDialog:false,
        showSiteCloseOrderDialog: false,
        backOrderDialogShow: false,
        showSiteRejectOrder:false,
        assignOrg: false,
        orderEdit: false,
        assignSite: false,
        orderClose: false,
        assignSiteByMap: false,
        siteCloseOrder:false,
        acceptOrder: false,
        backOrder: false,
        reAssignEngineer: false,
        applyRealMobile: false,
        assignEngineer: false,
        bookOrder: false,
        assignSecondSite: false,
        finishComfirmSite: false,
        finishOrder: false,
        rollbackOrderStat: false,
        orderFollowUp: false,
        orderFinish: false,
        recordDialog: false,
        changeDialog: false,
        cancelCheck: false,
        assignAgain: false,
        orderJudging: false,
        orderComplaintHandling: false,
        siteOrderComplaintHandling: false,
        endOrder: false,
        orderSupervising: false,
        toAddCheckBill: false,
        //销售登记
        showOrderSaleRegisterDialog:false,
        changeBookReasonList: [],
        buyChannelOptions: [],

        // complaintPropertyList: [],
        // dutyJudgeList: [],
        // dutyJudgeSubList: [],
        // handleModelList: [],
        // consultTypeList: [],
        // consultTypeSubList: [],
        // praiseTypeList: [],

        show3: false,
        node: true,
        initiateAppeal: false,
        initiateAppealOrg: false,
        initiateAppealCompany: false,
        addOrderFile:false,
        deleteOrderFile:false,
        downloadOrderFile:false,
        form2: {
          appealRemark: '',
        },
        loading: false,
        fileList: [],
        formLabelWidth: '80px',
        formData: {
          orderNo: '', // 工单号,前缀"SO"+年月日+6位流水号
          createType: 0, // 生成方式：0默认;1客服;2excel;3接口;4公众号;5PC自建单;6APP自建单;7服务中心;9其它;94苏宁帮客;95京东服务市场;97天猫服务市场;98京东测量服务;99京东ue平台;100京东3C
          orderTypeId: 0, // 工单来源ID,关联bas_order_type.id
          serverTypeId: 0, // 服务类型ID,关联bas_service_type.id
          userType: 0, // 用户类型:0普通用户、1售前机、2工程机、3VIP用户、4经销商
          businessName:'',
          businessMobile:'',
          businessTypeName:'',
          businessNo:'',
          userName: '', // 用户姓名
          userMobile: '', // 来电号码
          userPhone1: '', // 其他号码1
          userPhone2: '', // 其他号码2
          userProvice: '', // 省
          userCity: '', // 市
          userCounty: '', // 县
          userTown: '', // 镇街
          areaId: 0, // 地区ID,关联bas_area.id
          userAddress: '', // 详细地址
          userAddressOriginal: '',//建单原地址
          longitude: 0, // 经度
          latitude: 0, // 纬度
          guaranteeType: 0, // 保修类型：1保内、2保外、3未知
          brandId: 0, // 品牌ID,关联sn_company_brand.id
          buyDate: '', // 购买时间
          buyShop: '', // 购买商场
          invoiceNo: '', // 发票号
          brarcode: '', // 报单条码
          outOrderNo: '', // 外部订单号
          complaintTypeId: 0, // 客诉类型ID,关联bas_customer_complaint_type.id
          issueFaultId: 0, // 客服录单故障现象id,关联bas_fault_symptom.id
          appeals: '', // 述求
          stat: 0, // 状态：1登记;2发布;5已派网点;9已派师傅;13已出发;17已上门;20完工暂存;21已完工;22网点确认完工;23中心确认完工;24总部确认完工;91待结算;92结算驳回;93结算中止;94已结算;98挂起;99取消
          dispatchStat: '', // 工单标签
          partsStat: 0, // 配件状态：0无配件;1申请；2审核；3出库；4网点收货；8驳回；9取消；11更换；12网点返厂；13返厂确认
          recallStat: 0, // 回访状态：0未回访、1已抽样、2已回访;5用户已评价
          siteComplainStat: 0, // 申诉状态：0无申诉；3待申诉；5已申诉；7中心已审核；8中心驳回；9总部已处理；99取消
          qualityStat: 0, // 质检状态：0未质检；1质检通过；2质检不通过；
          orgId: 0, // 业务机构，关联脚手架机构表sys_dept.dept_id
          orgName: '', // 机构名称,冗余字段
          orgIdPath: '', // 机构ID路径,冗余字段.重要
          siteId: 0, // 网点ID,关联sn_user.id;
          siteName: '', // 网点名称,冗余字段
          bigSiteId: null,
          bigSiteName: '',
          engineerId: 0, // 工程师Id,关联sn_site_engineer.id
          engineerName: '', // 工程师名称,冗余字段
          takeTime: null, // 派单时间
          takeEngineerTime: null, // 派工程师时间
          openId: '', // 消费者报修时关联的微信号id
          sysmtomId: 0, // 故障现象id,关联bas_fault_symptom.id
          reasonId: 0, // 故障原因id,关联bas_fault_reason.id
          methodId: 0, // 维修措施id,关联bas_fix_method.id
          isMustRecall: 0, // 是否必访:0否1是
          isCallRecall: 0, // 是否可抽样:0否1是
          isUrgent: 0, // 是否急单:0否1是
          isReplaceFinish: 0, // 是否重新完工：0否1是
          urgeTimes: 0, // 催单次数
          complainTimes: 0, // 投诉次数
          managerId: 0, // 督办人,关联sys_user.id
          outTransIn: 0, // 申请保外转保内:0否1是
          settleId: 0, // 结算单ID,关联sf_batch_settle.id字段
          sendPay: '', // sendPay:打标标识，未定义
          serverTypeName: null,
          orderTypeName: null,
          symptomName: null,
          reasonName: null,
          methodName: null,
          categoryNames: null,
          urger: null,
          soOrderAreaHistoryDTOList:[],
          soOrderScoresDTOList:[],

          associateDocuments: [],  // 关联单据
          soOrderCallOperateList: [],//拨号记录

          waitReply:null, //待回复：1否2是
          waitReplyTime:null, //待回复时间

          soOrderExtendDTO: {
            wishBookDate: '', // 期望上门/安装时间
            deliverTime: '', // 到货签收时间
            finishMode: 0, // 完工模式：1结算密码；2上传图片；3图片+条码；9无验证完工
            finishType: 0, // 完工方式:1总部代完工;2网点PC端完工;3网点APP完工;4师傅APP完工;5接口完工;9其他
            commentLevel: 0, // 短信满意度：1非常满意;2满意;3一般;4不满意;5非常不满意
            isSendCommentMessage: 0, // 是否已发送评价短信：0否1是
            qualityMan: '', // 质检人
            qualityDate: '', // 质检时间
            qualityRemark: '', // 质检备注
            secondSiteComplain: 0, // 是否二次申诉：0否1是
            isInstallSynchro: 0, // 是否送装同步：0否1是
            hangupType: 0, // 挂起类型：0总部挂起；1网点挂起
            hangupReason: '', // 挂起原因
            sendFlag: 0, // 外部系统传单标识:0未传;1失败;2已传
            sendMessage: '', // 外部系统传单返回信息
            sendDate: '', // 外部系统传单时间
            thirdSendFlag: 0, // 传第三方网点接口状态:0未传;1失败;2已传
            thirdSendDate: '', // 传第三方网点接口时间
            thirdSendMessage: '', // 传第三方网点接口备注,如失败时用来保存失败的原因
            tmfworderid: '', // 天猫服务市场的工单ID
            tbcustomerid: '', // 天猫服务市场的用户ID
            commercePraise: 0, // 是否电商好评：0否1是

            complaintObjectName: '', // 投诉对象
            complaintProperty: null, // 投诉性质ID,关联脚手架数据字典项目表sys_dict_item.id
            dealSatisfaction: 0,
            dutyJudge: null, // 责任判定ID,关联脚手架数据字典项目表sys_dict_item.id
            dutyJudgeSub: null, // 责任细分ID,关联脚手架数据字典项目表sys_dict_item.id
            handleModel: null, // 处理方式ID,关联脚手架数据字典项目表sys_dict_item.id
            handlePlan: '', // 处理方案
            consultType: null, // 咨询类型ID,关联脚手架数据字典项目表sys_dict_item.id
            consultTypeSub: null, //  咨询细分ID,关联脚手架数据字典项目表sys_dict_item.id
            consultTypeSub2: null, //  咨询细分ID,关联脚手架数据字典项目表sys_dict_item.id
            praiseObjectName: '', //  表扬对象
            praiseType: null, //  表扬类型ID,关联脚手架数据字典项目表sys_dict_item.id
            praiseJudge: 0, //   表扬是否成立:0否1是
            rewardJudge: 0, //  奖励是否成立:0否1是
            complaintObjectType:'', //投诉对象类型：1服务商；2店铺；3员工


            complaintPropertyName: null,
            isIntransfer: null,
            dealSatisfactionName: null,
            dutyJudgeName: null,
            dutyJudgeSubName: null,
            handleModelName: null,
            consultTypeName: null,
            consultTypeSubName: null,
            praiseTypeName: null,
            proServiceSubject: null,
            timeCheckText: null,
            urgeRecordText: null,
            traceRecordText: null,
          },
          soOrderProcessDTO: {
            orderId: 0, // 工单id，关联so_order.id
            takeOrgTime: '', // 派中心时间
            // takeTime: '', // 派单时间
            acceptOperateTime: '', // 网点确认接单时间
            // takeEngineerTime: '', // 派工程师时间
            engineerAcceptOperateTime: '', // 工程师确认接单时间
            firstBookOperateTime: '', // 首次预约操作时间
            firstBookDate: '', // 首次预约时间
            bookOperateTime: '', // 预约操作时间
            bookDate: '', // 预约时间
            startOffTime: '', // 出发时间
            onDoorTime: '', // 上门签到时间
            onDoorLocation: '', // 上门签到地址
            firstCompleteTime: '', // 首次完工时间
            completeTime: '', // 完工时间
            onTimeLocation: '', // 完工地址
            siteComfirmTime: '', // 网点确认完工时间
            orgComfirmTime: '', // 中心确认完工时间
            officeComfirmTime: '', // 总部确认完工时间
            recallTime: '', // 回访时间
            complaintProcessTimes: 0, // 客诉跟进次数
            complaintProcesser: '', // 客诉跟进人
            complaintProcessDate: '', // 客诉跟进时间
            siteComplaintProcessDate: '', // 网点客诉跟进时间
            applyPayDate: '', // 进入结算池时间
            payDate: '', // 提交结算时间
            cancleDate: '', // 取消/退单时间
            returnId: 0, // 取消/退单原因：关联bas_return_type.id.
            returnName: null, // 取消/退单原因：关联bas_return_type.id.
            finishNote: '', // 完工备注
            comfirmNote: '', // 完工审核备注
            fixStatus: 0,//维修状态
            bookTimes: 0,//预约次数
            changeBookReason: null,  // 改约原因
          },
          soOrderSettleDTO: {
            siteFinalAmount: null,
            siteAmount: null,
            rewardAmount: null,
            rewardReason:'',
            mapLongDistance: null,
            mapBeginAddress: "",
            mapEndAddress:"",
            mapBeginAddressLongitude:null,
            mapBeginAddressLatitude:null,
            mapEndAddressLongitude:null,
            mapEndAddressLatitude:null,
            longDistanceMonth:"",
            settleRemark:"",
            longDistance: null,
            longDistanceAmount: null,
            userPayType: null,
            userPayName: null,
            userPayAccount: null,
            userPayStat: null,
            userPayNo: null,
            userPayAmount:null,
            userPayTime: null,
            userPayStatMsg: null,
            productDate: null,
            installDate: null
          },
          soOrderResultDTO: {
            inCode: null,
            outCode: null,
            finishPic1: null,
            srcList1: [],
            finishPic2: null,
            finishPic3: null,
            finishPic4: null,
            finishPic5: null,
            finishPic6: null,
          },
          soOrderSpecialExtendDTO: {
            isPolicy:null,
            isSafeEnvironment:null
          },

          soOrderEnvironmentDTO: {
            orderId: '',
            createBy: '',
            createTime: '',
            daohuoShijian: null,
            environmentFile1: null,
            environmentFile2: null,
            environmentFile3: null,
            environmentType: null,
            shifouDaidixian: null,
            shifouDakuokong: null,
            shifouDaohuo: '',
            shifouJieshoushoufei: null,
            shifouTongdian: null,
            shifouTongqi: null,
            shifouTongshuilu: null,
            shifouYikaikong: null,
            shifouYoupaishuikou: null,
            shifouZuohaochugui: null,
            anzhuangWeizhi: null,
          },
          soOrderComplainDTOList: [],
          soOrderLineDTOList: [{}],
          soOrderCommentDTOList: [{}],
          soRecallHistoryDTOList: [{}],
          soOrderPartsDTOList: [],
          soOrderDesignResultDTOList:[],
          soOrderDesignSurveyResultList:[],
          soOrderDesignFeeResultList:[],
          soOrderPreconditionResultDTOList: [],
          soOrderOperationDTOList: [],
          soOrderSlaList: [],
          sfCheckBillDTOList: [],
          soOrderFaultDTOList: [],
          soOrderFeeAttributeList: [],
          operations: [],
          soOrderDesignSaleRegisterDto:{
            saleSuccess:null,
            saleNumber:null,
            installOrderNo:null,
            saleBigCategoryName:null,
            saleItemCode:null,
            saleItemName:null,
            factSaleAmount:null,
            failSucessObject:null,
            failSucessReasonName:null,
            saleRewardStat:null
          },
          registerStat:null,
          basCustRightsDTOList: [],
          basCustRightsOffDTOList: [],
          orderFileList:[],
        },
        dataList: [],
        srcList: [],
        showEnvironmentFile:[],

        soOrderSpecailFeeListToUser: [],
        soOrderSpecailFeeListToCompany: [],
        ////////////////////////////////////////////////////////////////////////////////////////////
        card: true,
        areaProps: {
          lazy: true,
          emitPath: false,
          checkStrictly: true,
          lazyLoad: this.cascaderLazyLoad
        },
        areaValues: [],
        areaOption: [],
        showCommonDetails: false,
        checkAll: false,
        checkAll2: false,
        checkedCities: ['挂壁式（5100W＜Q）变频', '挂壁式（3600W＜Q≤5100W）变频'],
        checkedCities2: ['挂壁式1变频',],
        cities: cityOptions,
        cities2: cityOptions2,
        isIndeterminate: true,
        isIndeterminate2: true,
        // 以上卡片数据
        //  第四个页面表---服务类型
        table_area: [{
          companyId: 1,
          areaName: '空调',
          areaCode: '333',
          areaLevel: '中国广东省佛山市顺德区北滘镇',
          settleLevel: '维修投诉',
          code1: 'aaa',
          code2: 'bbbb',
          usable: 0,
        }, {
          companyId: 2,
          areaName: '冰箱',
          areaCode: '2222',
          areaLevel: '中国广东省佛山市顺德乐从镇',
          settleLevel: 0,
          code1: 'aaa222',
          code2: 'bbbb222',
          usable: 1,
        }],
        //  第五个页面表---服务类型
        table_type: [{
          typeName: '维修投诉',
          usable: '启用',
        }, {
          typeName: '安装投诉',
          usable: '禁止',
        }, {
          typeName: '售前机维修外机',
          usable: '启用',
        }],
        img_b: "",
        //认证信息-- 资质照片-测试数据

        big_img: [
          'https://bkimg.cdn.bcebos.com/pic/80cb39dbb6fd5266d0168fdb9654802bd40734fa98e2?x-bce-process=image/resize,m_lfit,w_536,limit_1'
        ],
        // showParameterDialog: false,
        showSaleConfigDialog: false,
        upload_btn: false, // 是否隐藏上传图片按钮
        upload_btn4: false, // 是否隐藏上传图片按钮
        radio: 1,
        isSite: null,
        showEdit: false,
        valuetype: 'model',
        textarea: '',
        //  value1: true,
        value2: false,
        value3: true,
        activeName: 'first',
        activeName2: 'first',
        activeName3: '1',

        dialog: {
          one: false,
        },
        lan: 'zh_CN',
        isEdit: false,
        tabIndex: 'first',
        dataId: '',
        _dealType: '',
        tenant: {
          snCompanyOrderAttributeDTOS: [],
          url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',

          // 评分
          fen: 3.6,
          fen2: 4.5,
          fen3: 5.0,
          contractFile: [],
          longitude: '东经160度',
          latitude: "北纬60度",
          stat: 1,
          siteType: 2,
          siteFloorLevel: 1,
          siteOverAllArea: 0,
          isAutoIssue: 0,
          siteInvoiceRate: 0,
          siteAutoAccept: 0,
          checkBeyondBookdate: 0,
          autoComfirmOrder: 0,
          siteInvoiceType: 0,
          abilityPhoto: [{
            name: '用户照片',
            url: 'https://bkimg.cdn.bcebos.com/pic/7dd98d1001e93901213fb5162da043e736d12f2e38cd?x-bce-process=image/resize,m_lfit,w_536,limit_1'
          },],
          // 门头照片
          shopPhoto: [],
          //营业执照照片
          businessPhoto: [],
          // 基本信息-用户图片
          userPhoto: [{
            name: '用户照片',
            url: 'https://bkimg.cdn.bcebos.com/pic/80cb39dbb6fd5266d0168fdb9654802bd40734fa98e2?x-bce-process=image/resize,m_lfit,w_536,limit_1'
          },],
          status: 1,
          tenantAttachmentDTOs: []
        },
        showProductCategoryDialog: false,
        languageDTOs: [],
        dialogImageUrl: '',
        dialogVisible: false,
        uploadDisabled: false,
        upload_img: [

          // imageList: [], //图片数据列表,用于之后上传到后端
          // imageName: []  //图片名称
        ],

        //地址选择
        selectemp: {},
        selectedOptions: [],
        options: regionData,
        // 费用配置表

        tableData3: [{
          brandName: '预审项目1',
          tag: '家',
          usable: '必访',
        }, {
          brandName: '预审项目22',
          tag: '公司',
          usable: '申诉',
        }, {
          brandName: '预审项目333',
          tag: '公司',
          usable: '挂起',
        }, {
          brandName: '预审项目44',
          tag: '公司',
          usable: '重新完工',
        }],
      };
    },
    computed: {
      companyConfig() {
        return companyConfig
      },
      api() {
        return api
      },
      headers: function () {
        const tenantId = store.getters.userInfo.tenantId
        return {
          'Authorization': "Bearer " + store.getters.access_token,
          'TENANT-ID': tenantId ? tenantId : '1'
        };
      },
      ...mapGetters(["permissions"])
    },
    created() {


      if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;

      // if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
      this._dealType = this.dealType
      console.log(this._dealType, "dealType的值");

      this.assignOrg = this.permissions["assignOrg"];
      this.orderEdit = this.permissions["orderEdit"];
      this.suspendOrder = this.permissions["suspendOrder"];
      this.replaceBarcode = this.permissions["replaceBarcode"];
      this.generateOrder = this.permissions["generateOrder"];
      this.assignSite = this.permissions["assignSite"];
      this.assignSites = this.permissions["assignSites"];
      this.orderClose = this.permissions["orderClose"];
      this.assignSiteByMap = this.permissions["assignSiteByMap"];
      this.acceptOrder = this.permissions["acceptOrder"];
      this.siteCloseOrder = this.permissions["siteCloseOrder"];
      this.backOrder = this.permissions["backOrder"];
      this.reAssignEngineer = this.permissions["reAssignEngineer"];
      this.applyRealMobile = this.permissions["applyRealMobile"];
      this.assignEngineer = this.permissions["assignEngineer"];
      this.bookOrder = this.permissions["bookOrder"];
      this.assignSecondSite = this.permissions["assignSecondSite"];
      this.finishComfirmSite = this.permissions["finishComfirmSite"];
      this.finishOrder = this.permissions["finishOrder"];
      this.rollbackOrderStat = this.permissions["rollbackOrderStat"];
      this.orderFollowUp = this.permissions["orderFollowUp"];
      this.orderFinish = this.permissions["orderFinish"];
      this.centerReview = this.permissions["centerReview"];
      this.initiateAppealA = this.permissions["initiateAppeal"];
      this.headquartersReview = this.permissions["headquartersReview"];
      this.abandonAppeal = this.permissions["abandonAppeal"];
      this.cancelCheck = this.permissions["cancelCheck"]
      this.assignAgain = this.permissions["assignAgain"]
      this.orderJudging = this.permissions["orderJudging"]
      this.orderComplaintHandling = this.permissions["orderComplaintHandling"]
      this.siteOrderComplaintHandling = this.permissions["siteOrderComplaintHandling"]
      this.endOrder = this.permissions["endOrder"]
      this.orderSupervising = this.permissions["orderSupervising"]
      this.toAddCheckBill = this.permissions["toAddCheckBill"]
      this.orderSaleRegister = this.permissions["orderSaleRegister"]
      this.orderQuestion = this.permissions["orderQuestion"]
      this.addOrderFile = this.permissions["addOrderFile"]
      this.deleteOrderFile = this.permissions["deleteOrderFile"]
      this.downloadOrderFile = this.permissions["downloadOrderFile"]
      // console.log(this.tenant,"tenant的值");
      const userInfo = store.getters.userInfo;
      if (userInfo.snUserId) {
        console.log("userInfo58585858585555555555555"+userInfo.snUserId)
        this.isSite = true;
      }
      if(this.currentSiteData.snSiteInfoDTO.simpleFinishOrder == 1){
        this.simpleFinishOrder = true;
      }else {
        this.simpleFinishOrder = false;
      }
      if(this.currentSiteData.snSiteInfoDTO.parentSiteId){
        this.showPrice = false;
      }
      console.log("是否为服务商" + this.isSite)
    },
    mounted() {
      // this.initTableList();
      this.loadBuyChannelOption();
      this.loadDictData();
      this.getData();
      const isAppeal = this.isAppeal;
      const siteDeal = this.siteDeal;
      const subordSiteDeal = this.subordSiteDeal;
      const exceptionOrderDeal = this.exceptionOrderDeal;
      this.orderRemarkParam.orderId = this.dataId
      // 步骤条
      const stepNum = this.formData.siteComplainStat
      console.log(stepNum, "步骤stepNum");
      if (stepNum == 0) {
        this.stepNumber = 1
      } else if (stepNum == 3) {
        this.stepNumber = 2
      } else if (stepNum == 5) {
        this.stepNumber = 3
      } else if (stepNum == 7) {
        this.stepNumber = 4
      } else if (stepNum == 8) {
        this.stepNumber = 5
      } else if (stepNum == 8) {
        this.stepNumber = 6
      } else if (stepNum == 99) {
        this.stepNumber = 7
      }


      window.openVideo=this.openVideo;
      window.handleDownload=this.handleDownload;

    },
    methods: {
      doReply(row){
        this.replyParams = {id:row.replyId,orderNo:this.formData.orderNo}
        this.showReplyDialog = true
      },
      commitReply(type){
        this.showReplyDialog = false
        if (type == 1){
          this.getData();
        }
      },
      deleteFile(row) {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          console.log(row, 'delete')
          this.$http({
            url: api.soOrder.deleteFile,
            method: 'post',
            data: {
              id: row.id,
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            if (response.data.code ===0){
              this.formData.orderFileList = this.formData.orderFileList.filter(item =>
                item.id !== row.id
              )
            }
          })

        })
      },
      upVideo() {
        this.$mask.open()

      },
      handleFileSuccess(res, file, fileList) {
        let url = res.data.url
        let fileName = file.name
        console.log(url, "url")
        console.log(fileName, "name")

        this.$http({
          url: api.soOrder.addFile,
          method: 'post',
          data: {
            orderId: this.dataId,
            fileName: fileName,
            fileUrl: url
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
          if (response.data.code ===0){
            this.formData.orderFileList.push({
              fileName: fileName,
              fileUrl: url,
              id:response.data.data
            })
          }
        })
        this.$mask.close()

      },
      // 获取真实号码
      handleApplyRealMobile() {
        this.$http({
          url: api.soOrder.applyRealMobile,
          method: 'post',
          data: {
            id: this.dataId,
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.code == 0) {
            this.$message.warning(response.data.data['tips']);
            if (response.data.data['realMobile']) {
              this.formData.userPhoneUnreal = ''
              this.formData.userMobile = response.data.data['realMobile']
            }
          } else {
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
          }

        })
      },
  //销售登记
      orderSaleRegisterCommit(type){
        this.showOrderSaleRegisterDialog = false;
        if (type == 1) {
          this.flushed()// 需要刷新页面
          this.$mask.close()

        }
      },
      doOrderSaleRegister(){
        this.showOrderSaleRegisterDialog = true;
      },

      getTYJShortUrl() {
        this.$baseConfirm('您确定要前往问卷页面吗？').then(() => {

          this.$mask.open()
          this.$http({
            url: api.soOrder.getTYJShortUrl,
            method: 'post',
            data: {id:this.formData.id,effect:1,recommendValue:1,requestIn:1}
          }).then(res => {
            if(res.data.type == "success"){
              this.$mask.close()
              window.open(res.data.data, '_blank')
              return;
            }else {
              this.$message({
                type: "error",
                message: "跳转失败"
              });
            }
          }).catch(error => {
            this.$mask.close()
          })
        })

      },

      doAddOrder(type) {
        var serviceTypeName = '';
        var titleTip = ''
        if (type == 1) {
          serviceTypeName = '安装工单'
          titleTip = '生成安装单'
          // this.$router.push({
          //   path: '/workorder/orderaccess/access/index', query: {designOrderId: this.formData.id, serviceTypeName: '安装工单'}
          // })
        }else if(type == 2){
          serviceTypeName = '橱柜改造'
          titleTip = '生成厨改单'
                // this.$router.push({
                //   path: '/workorder/orderaccess/access/index',query: { designOrderId: this.formData.id,serviceTypeName:'橱柜改造' }
                // })
        }
        this.$baseConfirm('您确定要'+titleTip+'吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.soOrder.saveOrderByDesignUrl,
            method: 'post',
            data: {orderId:this.formData.id,serviceTypeName:serviceTypeName}
          }).then(res => {
            if(res.data.type == "success"){
              //网点完工
              this.$mask.close()
              this.$message({
                type: res.data.type,
                message: res.data.content
              });
              this.flushed()
            }
          }).catch(error => {
            // this.$message.error(error)
            this.$mask.close()
          })
        })

      },
      closeDFamily(v) {
        // this.reload()
        console.log(v, "v的值");
        this.showFamilyMobileDialog = v

      },

      showFamilyMobile(){
        this.showFamilyMobileDialog = true;
      },

      closeD3() {
        this.showPreview = false

      },
      // 文件下载
      handleDownload(Vname, Vurl) {
        console.log(Vname, Vurl, "文件下载");
        // let url=file.type
        let url = Vurl
        let name = Vname

        const x = new XMLHttpRequest()
        x.open('GET', url, true)
        x.responseType = 'blob'
        x.onload = function () {
          const url = window.URL.createObjectURL(x.response)
          const a = document.createElement('a')
          a.href = url
          a.download = name
          a.click()
        }
        x.send()


        // window.open(url,'_blank');
      },
      // 文件预览
      openVideo(value) {
        this.imgVisbleURL = value
        this.showPreview = true
      },
      // 文件预览


      //重新派工
      //直接调用派工程师方法2023-12-20
      handleReAssignEngineer() {
        this.$baseConfirm('是否重新派工？').then(() => {
          this.dispatchEngineerDialog = true;
          /*this.$http({
            url: api.soOrder.reAssignEngineerUrl,
            method: 'post',
            data: {
              id: this.dataId,
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.flushed()// 需要刷新页面
          })*/
        });
      },

      showDetails(id, row) {
        console.log(id, row, "点击的数据")
        this.row2 = row
        this.workNumber = id
        this.showDetailsDialog = true

      },
      closeD2(v) {
        // this.reload()
        console.log(v, "v的值");
        this.showDetailsDialog = v

      },
      closeD(v) {
        this.showCommonDetails = v
      },
      // 关联单据弹窗
      openDocumentNumber(type, id,row) {
        console.log(type, id,row, "type, id的值");
        this.associateDocumentId = id
        if ('上游工单' === type) {
          this.showOrderDetailDialog = true
        } else if ('配件返厂' === type) {
          console.log('配件返厂222', type);
          this.row11 = id
          this.typeName = type
          this.processId=row.processId

          this.showCommonDetails = true

        } else if ('质量报告' === type) {
          console.log('质量报告222', type);
          this.row11 = id
          this.typeName = type
          this.processId=row.processId

          this.showCommonDetails = true

        } else if ('事故报告' === type) {
          console.log('事故报告222', type);
          this.row11 = id
          this.typeName = type
          this.processId=row.processId

          this.showCommonDetails = true

        }
        else if ('配件申请' === type) {
          console.log('配件申请222', type);
          this.row11 = id
          this.typeName = type
          this.processId=row.processId

          this.showCommonDetails = true

        } else if ('退换货单' === type) {
          console.log('退换货单222', type);
          this.row11 = id
          this.typeName = type
          this.processId=row.processId


          this.showCommonDetails = true

        } else if ('拆装回工单' === type){
          this.showOrderDetailDialog = true
        }
      },

      openRecordDialog2(e) {
        this.evaluate = e
        this.recordDialog2 = true
      },
      //指派中心
      doAssignOrg() {
        this.showOrgDialog = true;
      },
      commitOrgSelect(data) {
        this.$http({
          url: api.soOrder.assignOrgUrl,
          method: 'post',
          data: {
            orgId: data.id,
            id: data.orderId,
            orgName: data.name,
            orgIdPath: data.orgIdPath
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
          // this.reload()// 需要刷新页面
          this.getData();

        })
      },
      //列表指派
      doAssignSite() {
        this.assginType = 0
        this.showAssignDialog = true;
      },
      commitSiteRow(row) {
        this.$http({
          url: api.soOrder.assignSiteUrl,
          method: 'post',
          data: {
            orderId: this.dataId,
            orderIds: this.orderIds,
            siteId: row.id,
            type: row.callBackAssignType,
            isSendSite: row.isSendSite,
            isSendUser: row.isSendUser
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
          // this.$emit('editViewDataUpdate')// 需要刷新页面
        this.getData();

        })
      },
      //地图指派
      doAssignSiteByMap() {
        this.assginType = 2
        this.assignSiteParam.wishBookDate = this.formData.wishBookDate
        this.showAssignByMapDialog = true;
      },
      //重新派单
      doAssignAgain() {
        this.assginType = 3
        this.showAssignDialog = true;
      },
      //工单跟进
      doOrderFollowUp() {
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = this.dataId
        this.showOrderRemaekDialog = true;
      },
      //异常处理
      exceptionOrderDealMed(){
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = this.dataId
        this.showExceptionDealDialog = true;
      },
      //确认接单
      doAccept() {
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = this.dataId
        this.siteAcceptDialogShow = true;
      },
      //确认关闭
      doClose() {
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = this.dataId
        this.showSiteCloseOrderDialog = true;
      },
      //退回工单
      doBackOrder() {
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = this.dataId
        this.backOrderDialogShow = true;
      },

      followUpOrderRemark(type) {
        this.showOrderRemaekDialog = false;
        this.getData();
      },
      closeExceptionOrderDeal(type) {
        this.showExceptionDealDialog = false;
        this.getData();
      },

      closeBook(type) {
        this.bookDialog = false;
        this.getData();


          // this.$emit('editViewDataUpdate')// 需要刷新页面

      },
      doEditOrder() {
        this.showOrderEditDialog = true
      },
      closeEdit(type) {
        this.showOrderEditDialog = false;
        console.log("closeEdit===", type)
        if (type == 1) {
        this.getData();

          // this.$emit('editViewDataUpdate')// 需要刷新页面
        }
      },

      //修改虚拟号
      userPhoneUnreal() {
        this.orderId = this.dataId;
        this.showPhoneUnrealDialog = true;
      },
      updatePhoneUnreal(type) {
        this.showPhoneUnrealDialog = false;
        if (type == 1) {
          // this.$emit('editViewDataUpdate')// 需要刷新页面
          this.getData();

        }
      },

      //关闭工单
      doOrderClose() {
        this.orderId = this.dataId;
        this.showCloseOrderDialog = true;
      },
      closeOrderRemark(type) {
        this.showCloseOrderDialog = false;
        if (type == 1) {
          // this.$emit('editViewDataUpdate')// 需要刷新页面
        this.getData();

        }
      },
      //取消审核
      toCancelCheck() {
        this.orderRemarkParam.orderId = this.dataId
        this.showCancelCheckDialog = true;
      },
      //挂起审核
      toHangUpCheck(){
        this.orderRemarkParam.orderId = this.dataId
        this.showHangupDialog = true;
      },
      //取消审核回调方法
      doCancelCheck(type) {
        this.showCancelCheckDialog = false;
        if (type == 1) {
          // this.$emit('editViewDataUpdate')// 需要刷新页面
        this.getData();

        }
      },
      //取消挂起回调方法
      doHangupCheck(type){
        this.showHangupDialog = false
        if(type == 1){
          this.getData()
        }
      },
      doReplaceBarcodeCheck(type){
        this.showReplaceBarcodeDialog = false
        if(type == 1){
          this.getData()
        }
      },
      //确认完工
      doOrderFinish() {
        this.orderId = this.dataId;
        this.isFinishOrReject = 1;
        // if (this.currentCompanyShotName === companyConfig.NIU_EN_TAI) {
        //   this.showNiuEnTaiOrderFinishOrRejectDialog = true
        // } else {
          this.showOrderFinishOrRejectDialog = true;
        // }
      },
      // //驳回完工
      // doOrderReject() {
      //   this.orderId = this.dataId;
      //   this.isFinishOrReject = 2;
      //   this.showOrderFinishOrRejectDialog = true;
      // },
      closeDialog(type) {
        this.showOrderFinishOrRejectDialog = false;
        // this.showNiuEnTaiOrderFinishOrRejectDialog = false
        if (type == 1) {
          // this.$emit('editViewDataUpdate')// 需要刷新页面
        this.getData();

        }
      },

      //删除产品明细
      orderLineDetele(index) {
        if (this.formData.soOrderLineDTOList.length > 1) {
          this.formData.soOrderLineDTOList.splice(index, 1);
        } else {
          this.$message.warning('至少存在一条产品信息！');
        }
      },
      addListRow() {
        this.formData.soOrderLineDTOList.push({});
      },
      //选择产品
      selectItem(index) {
        console.log(this.formData.soOrderLineDTOList, " this.formData.soOrderLineDTOList")
        this.showItemDialog = true;
        this.lineIndex = index;
      },
      commitItemRow(row) {
        this.formData.soOrderLineDTOList[this.lineIndex].itemId = row.id
        this.formData.soOrderLineDTOList[this.lineIndex].itemCode = row.itemCode
        this.formData.soOrderLineDTOList[this.lineIndex].itemName = row.itemName
        this.formData.soOrderLineDTOList[this.lineIndex].qty = 1
        this.formData.soOrderLineDTOList[this.lineIndex].bigCategoryId = row.bigCategoryId
        this.formData.soOrderLineDTOList[this.lineIndex].bigCategoryName = row.bigCategoryName
        this.formData.soOrderLineDTOList[this.lineIndex].smallCategoryId = row.smallCategoryId
        this.formData.soOrderLineDTOList[this.lineIndex].smallCategoryName = row.smallCategoryName
        his.formData.soOrderLineDTOList[this.lineIndex].brandId = row.brandId
      },
      doEdit() {
        if (!this.formData.userName) {
          this.$message({ message: '用户名不能为空!', type: 'warning' });
          return;
        }
        if (!this.formData.areaId) {
          this.$message({ message: '用户地址不能为空!', type: 'warning' });
          return;
        }
        if (!this.formData.userAddress) {
          this.$message({ message: '用户详细地址不能为空!', type: 'warning' });
          return;
        }
        if (!this.formData.userMobile) {
          this.$message({ message: '用户号码不能为空!', type: 'warning' });
          return;
        }
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$http({
            url: api.soOrder.doEditUrl,
            method: 'post',
            data: this.formData,
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            if (response.data.type == "success") {
              this.$message({ message: response.data.content, type: 'success' });
              // this.$emit('editViewDataUpdate')
        this.getData();

            } else {
              this.$message({ message: response.data.data, type: 'warning' });
            }
          })
        })
      },


      openRecordDialog(e) {

        console.log(e, "点击的权益id");
        this.areaObj3 = e
        this.recordDialog = true

      },

      openChangeDialog(e) {

        console.log(e, "点击的配件更换");
        this.changeObj = e
        this.changeDialog = true

      },
      handleClick(tab, event) {
        console.log(tab, event);
        console.log(tab.name, "name得值");
        if (tab.index == 0) {
          this.card = true
        } else {
          this.card = false
        }


      },
      // 其他操作按钮
      btnClick(e){
        console.log(e,'其他操作选项');
        if(e==1){
          this.doClose()
        }else if (e==2) {
          this.handleReAssignEngineer()
        }else if (e==3) {
          this.subcontractorDialog = true

        }else if (e==4) {
          this.backOrderDialogShow = true

        }
      },

      // 加载购买渠道
      loadBuyChannelOption() {
        this.$http({
          url: this.getBuyChannelListUrl,
          method: 'post',
          data: {
            buyChannelName: null
          }
        }).then(res => {
          this.buyChannelOptions = []
          res.data.data.forEach(item => {
            this.buyChannelOptions.push({
              label: item.buyChannelName,
              value: item.id
            })
          })
        })
      },

      cascaderLazyLoad(node, resolve) {
        if (!node) {
          return false
        }
        this.formData.areaId = node.value;
        this.$http({
          url: api.basArea.getList,
          method: 'post',
          data: {
            parentId: node.value
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (node.root) {
            const childrens = response.data.data || {};
            const childNodes = childrens.map(item => ({
              value: item.id,
              label: item.areaName,
              leaf: Number(item.hasChild) !== 0
            }))
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(childNodes);
          } else {
            const childrens = response.data.data || {};
            let childNodes = []
            let temp = ''
            if (node.children.length !== 0) {
              temp = node.children
              childrens.forEach(item => {
                let flag = false
                temp.forEach(item1 => {
                  if (item1.value == item.id) {
                    flag = true  // 当前节点已存在此数据，不追加
                  }
                })
                if (!flag) {
                  childNodes.push({
                    value: item.id,
                    label: item.areaName,
                    leaf: Number(item.hasChild) !== 0
                  })
                }
              })
              resolve(childNodes);
            } else {
              childrens.forEach(item => {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              })
              resolve(childNodes);
            }
          }
        })
      },
      loadDictData() {
        // // 改约原因
        // loadDictData("change_book_reason").then(res => {
        //   this.changeBookReasonList = []
        //   res.data.data.forEach(item => {
        //     this.changeBookReasonList.push({
        //       label: item.label,
        //       value: item.id
        //     })
        //   })
        // })


        // @ApiModelProperty(value = "投诉性质ID,关联脚手架数据字典项目表sys_dict_item.id")
        // private Long complaintProperty;

        // @ApiModelProperty(value = "责任判定ID,关联脚手架数据字典项目表sys_dict_item.id")
        // private Long dutyJudge;

        // @ApiModelProperty(value = "责任细分ID,关联脚手架数据字典项目表sys_dict_item.id")
        // private Long dutyJudgeSub;

        // @ApiModelProperty(value = "处理方式ID,关联脚手架数据字典项目表sys_dict_item.id")
        // private Long handleModel;

        // @ApiModelProperty(value = "咨询类型ID,关联脚手架数据字典项目表sys_dict_item.id")
        // private Long consultType;

        // @ApiModelProperty(value = "咨询细分ID,关联脚手架数据字典项目表sys_dict_item.id")
        // private Long consultTypeSub;

        // @ApiModelProperty(value = "表扬类型ID,关联脚手架数据字典项目表sys_dict_item.id")
        // private Long praiseType;
        // loadDictData("complaint_property").then(res => {
        //   this.complaintPropertyList = []
        //   res.data.data.forEach(item => {
        //     this.complaintPropertyList.push({
        //       label: item.label,
        //       value: item.id
        //     })
        //   })
        // })
        // loadDictData("duty_judge").then(res => {
        //   this.dutyJudgeList = []
        //   res.data.data.forEach(item => {
        //     this.dutyJudgeList.push({
        //       label: item.label,
        //       value: item.id
        //     })
        //   })
        // })
        // loadDictData("duty_judge_sub").then(res => {
        //   this.dutyJudgeSubList = []
        //   res.data.data.forEach(item => {
        //     this.dutyJudgeSubList.push({
        //       label: item.label,
        //       value: item.id
        //     })
        //   })
        // })
        // loadDictData("handle_model").then(res => {
        //   this.handleModelList = []
        //   res.data.data.forEach(item => {
        //     this.handleModelList.push({
        //       label: item.label,
        //       value: item.id
        //     })
        //   })
        // })
        // loadDictData("consult_type").then(res => {
        //   this.consultTypeList = []
        //   res.data.data.forEach(item => {
        //     this.consultTypeList.push({
        //       label: item.label,
        //       value: item.id
        //     })
        //   })
        // })
        // loadDictData("consult_type_sub").then(res => {
        //   this.consultTypeSubList = []
        //   res.data.data.forEach(item => {
        //     this.consultTypeSubList.push({
        //       label: item.label,
        //       value: item.id
        //     })
        //   })
        // })
        // loadDictData("praise_type").then(res => {
        //   this.praiseTypeList = []
        //   res.data.data.forEach(item => {
        //     this.praiseTypeList.push({
        //       label: item.label,
        //       value: item.id
        //     })
        //   })
        // })
      },

      saveData() {
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.$baseConfirm('您确定要保存吗？').then(() => {
              this.$mask.open()

              var url = (this.isEdit ? `/admin/fwpttenant/update` : `/admin/fwpttenant/save`);
              request({
                url: url,
                method: 'post',
                data: this.tenant,
                isLoading: true,
              }).then(response => {
                this.$message({
                  message: response.data.content,
                  type: 'success',
                  duration: 500,
                  onClose: t => {
                    if (this.isEdit) {
                      this.$baseReload();
                      this.$mask.close()

                    } else {
                      this.$baseReload({
                        updateParam: {
                          _dataId: response.data.objx
                        }
                      });
                      this.$mask.close()

                    }
                  }
                });
              });
            });
          }
        });
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      handleCheckAllChange(val) {
        this.checkedCities = val ? cityOptions : [];
        this.isIndeterminate = false;
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.cities.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
      },
      radioHandleChange(val) {
        if (val == 1) {
          this.radio = 1
        } else if (val == 2) {
          this.radio = 2
        }
      },
      // 地址三级联动
      handleChange() {
        const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
        if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
          this.formData.areaId = areaNode.value;
          if (areaNode[0].level == 1) {
            this.formData.userProvice = null;
            this.formData.userCity = null;
            this.formData.userCounty = null;
            this.formData.userTown = null;
          } else if (areaNode[0].level == 2) {
            this.formData.userProvice = areaNode[0].label;
            this.formData.userCity = null;
            this.formData.userCounty = null;
            this.formData.userTown = null;
          } else if (areaNode[0].level == 3) {
            this.formData.userCity = areaNode[0].label;
            this.formData.userCounty = null;
            this.formData.userTown = null;
          } else if (areaNode[0].level == 4) {
            this.formData.userCounty = areaNode[0].label;
            this.formData.userTown = null;
          } else if (areaNode[0].level == 5) {
            this.formData.userTown = areaNode[0].label;
          }
        } else {
          this.formData.areaId = null;
          this.formData.userProvice = null;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        }
        const panelRefs = this.$refs.cascaderAddr.$refs.panel
        if (panelRefs.activePath.length !== 0) {
          panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
        }

      },
      cancelForm() {
        this.loading = false;
        this.initiateAppeal = false;
        this.initiateAppealOrg = false;
        this.initiateAppealCompany = false;
        clearTimeout(this.timer);
      },
      abandonAppeal() {
        this.$confirm('是否放弃申诉,该工单将挂起并取消结算？')
          .then(_ => {
            this.$http({
              url: api.soOrder.abandonAppeal,
              method: 'post',
              data: {
                id: this._dataId,
              }
            }).then(res => {
              this.$message.success('操作成功')
              this.flushed()
            })
          })
          .catch(_ => {
            this.cancelForm();
          });
      },
      getData() {
        // this.$mask.open()

        if (this.dataId && !isNaN(this.dataId)) {
          this.$mask.open()
          this.isEdit = true;
          this.$http({
            url: api.soOrder.getDataUrl,
            method: 'post',
            data: {
              id: this.dataId
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.$mask.close()
            this.formData = response.data.data
            //计算工单时长
            if(this.formData.stat<60){
              // 计算绝对时间差
              const diff = Math.abs(new Date(this.formData.createTime).getTime() - new Date().getTime());
              // 计算天数并取整
              const days = Math.floor(diff / (1000 * 60 * 60 * 24));
              // 计算剩余小时并取整
              const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              this.orderDuration.days = days
              this.orderDuration.hours = hours
            }
            if (!response.data.data.soOrderDesignSaleRegisterDto){
              this.formData.soOrderDesignSaleRegisterDto = {}
            }
            if (this.lowerSiteDeal){
              this.orderRemarkParam.orderSiteId = this.formData.siteId
            }
            let soOrderSpecailFeeList = response.data.data.soOrderSpecailFeeDTOList
            this.srcList.push(this.formData.soOrderResultDTO.finishPic1)
            // this.srcList1=this.formData.soOrderResultDTO.finishPic1
            this.srcList.push(this.formData.soOrderResultDTO.finishPic2)
            this.srcList.push(this.formData.soOrderResultDTO.finishPic3)
            this.srcList.push(this.formData.soOrderResultDTO.finishPic4)
            this.srcList.push(this.formData.soOrderResultDTO.finishPic5)
            this.srcList.push(this.formData.soOrderResultDTO.finishPic6)
            this.srcList.push(this.formData.soOrderResultDTO.finishPic7)
            this.srcList.push(this.formData.soOrderResultDTO.buyPic)
            console.log(this.srcList,"111111图片的值");
            console.log("此处费用列表数量--" , soOrderSpecailFeeList.length)
            soOrderSpecailFeeList.forEach(item => {
              if (item.feeType === 1) {
                this.soOrderSpecailFeeListToCompany.push(
                  {
                    subjectName: item.subjectName,
                    qty: item.qty,
                    price: item.price,
                    amount: item.amount,
                    unit: item.unit
                  }
                )
              } else if (item.feeType === 2) {
                this.soOrderSpecailFeeListToUser.push(
                  {
                    subjectName: item.subjectName,
                    qty: item.qty,
                    price: item.price,
                    amount: item.amount,
                    unit: item.unit
                  }
                )
              }
            })
            console.log(response.data.data,"response.data.data8888的值")
            if(this.formData.soOrderPartsDTOList && this.formData.soOrderPartsDTOList.length>0){
            this.isType=this.formData.soOrderPartsDTOList[0].isCheck
            console.log(this.isType,"是否属实的值")
          }
            if (this.formData.companyName && this.formData.companyName!='华帝股份有限公司'){
              this.showEngineerAmount = true;
            }
            console.log(this.formData.soOrderCommentDTOList, "formData.soRecallHistoryDTOList评价数据");

            var timeSeqs = this.formData.timeSequences;
            var a = 0;
            for (var i = 0; i < timeSeqs.length; i++) {
              if (timeSeqs[i].processDate != null) {
                a = i;
              }
            }
            this.timeSeq = a + 1;
            // this.$mask.close()
            // let soOrderSpecailFeeList = response.data.data.soOrderSpecailFeeDTOList
            console.log("此处费用列表数量--" , soOrderSpecailFeeList.length)


            console.log("计数器一")


            console.log(this.formData.soOrderComplainDTOList, "this..formData.soOrderComplainDTOList步骤");
            this.orderRemarkParam.orderId = this._dataId;
            this.orderRemarkParam.showInRemark = 1
            if (this.formData.soOrderComplainDTOList != null && this.formData.soOrderComplainDTOList.length != 0) {
              this.formData.soOrderComplainDTOList.forEach(item => {
                let list = []
                if (item.fileUrl1 != null) {
                  list.push(item.fileUrl1)
                }
                if (item.fileUrl2 != null) {
                  list.push(item.fileUrl)
                }
                if (item.fileUrl3 != null) {
                  list.push(item.fileUrl3)
                }
                item.srcList = list
              })
            }
            if (this.formData.sfCheckBillDTOList != null && this.formData.sfCheckBillDTOList.length != 0) {
              this.formData.sfCheckBillDTOList.forEach(item => {
                if (item.stat == 1) {
                  item.stat = '制单';
                } else if (item.stat == 2) {
                  item.stat = '待确认';
                } else if (item.stat == 3) {
                  item.stat = '待申诉';
                } else if (item.stat == 5) {
                  item.stat = '已申诉';
                } else if (item.stat == 7) {
                  item.stat = '执行考核';
                } else if (item.stat == 9) {
                  item.stat = '已结算';
                } else if (item.stat == 19) {
                  item.stat = '取消执行';
                } else if (item.stat == 99) {
                  item.stat = '关闭';
                }

                if (item.isAbandon == 0) {
                  item.isAbandon = '否';
                } else if (item.isAbandon == 1) {
                  item.isAbandon = '是';
                }
              })
            }

            if (this.formData.soOrderProcessDTO != null) {
              if (this.formData.soOrderProcessDTO.firstBookDate.includes("00:00:00")) {
                var firstBookDates = this.formData.soOrderProcessDTO.firstBookDate.split(" ");
                this.formData.soOrderProcessDTO.firstBookDate = firstBookDates[0];
              }
            }
            // if (this.formData.buyChannelId) {
            //   console.log('278365782346578234785')
            //   this.buyChannelOptions.forEach(item => {
            //     if (item.id === this.formData.buyChannelId) {
            //       this.formData.buyChannelName = item.buyChannelName
            //     }
            //   })
            // }
            // if (!!this.formData.soOrderProcessDTO) {
            //   if (!!this.formData.soOrderProcessDTO.changeBookReason) {
            //     this.changeBookReasonList.forEach(item => {
            //       if (item.id === this.formData.soOrderProcessDTO.changeBookReason) {
            //         this.formData.soOrderProcessDTO.changeBookReasonName = item.label
            //       }
            //     })
            //   }
            // }


            // if (!!this.formData.soOrderExtendDTO) {
            //   if (!!this.formData.soOrderExtendDTO.complaintProperty) {
            //     this.complaintPropertyList.forEach(item => {
            //       if (item.id === this.formData.soOrderExtendDTO.complaintProperty) {
            //         this.formData.soOrderExtendDTO.complaintPropertyName = item.label
            //       }
            //     })
            //   }
            //   if (!!this.formData.soOrderExtendDTO.dutyJudge) {
            //     this.dutyJudgeList.forEach(item => {
            //       if (item.id === this.formData.soOrderExtendDTO.dutyJudge) {
            //         this.formData.soOrderExtendDTO.dutyJudgeName = item.label
            //       }
            //     })
            //   }
            //   if (!!this.formData.soOrderExtendDTO.dutyJudgeSub) {
            //     this.dutyJudgeSubList.forEach(item => {
            //       if (item.id === this.formData.soOrderExtendDTO.dutyJudgeSub) {
            //         this.formData.soOrderExtendDTO.dutyJudgeSubName = item.label
            //       }
            //     })
            //   }
            //   if (!!this.formData.soOrderExtendDTO.handleModel) {
            //     this.handleModelList.forEach(item => {
            //       if (item.id === this.formData.soOrderExtendDTO.handleModel) {
            //         this.formData.soOrderExtendDTO.handleModelName = item.label
            //       }
            //     })
            //   }
            //   if (!!this.formData.soOrderExtendDTO.consultType) {
            //     this.consultTypeList.forEach(item => {
            //       if (item.id === this.formData.soOrderExtendDTO.consultType) {
            //         this.formData.soOrderExtendDTO.consultTypeName = item.label
            //       }
            //     })
            //   }
            //   if (!!this.formData.soOrderExtendDTO.consultTypeSub) {
            //     this.consultTypeSubList.forEach(item => {
            //       if (item.id === this.formData.soOrderExtendDTO.consultTypeSub) {
            //         this.formData.soOrderExtendDTO.consultTypeSubName = item.label
            //       }
            //     })
            //   }
            //   if (!!this.formData.soOrderExtendDTO.praiseType) {
            //     this.praiseTypeList.forEach(item => {
            //       if (item.id === this.formData.soOrderExtendDTO.praiseType) {
            //         this.formData.soOrderExtendDTO.praiseTypeName = item.label
            //       }
            //     })
            //   }
            // }

            if (this.formData.soOrderFeeAttributeList) {
              this.dataList = []
              let flag = 0
              let temp = []
              this.formData.soOrderFeeAttributeList.forEach(item => {
                if (flag < 4) {
                  flag += 1
                } else {
                  this.dataList.push(temp)
                  flag = 0
                  temp = []
                }
                temp.push({ key: item.feeAttributeName, value: item.amount })
              })
              if (temp.length > 0) {
                this.dataList.push(temp)
              }
            }
            if(this.formData.soOrderEnvironmentDTO){
              if (this.formData.soOrderEnvironmentDTO.environmentFile1){
                this.showEnvironmentFile.push(this.formData.soOrderEnvironmentDTO.environmentFile1)
              }
              if (this.formData.soOrderEnvironmentDTO.environmentFile2){
                this.showEnvironmentFile.push(this.formData.soOrderEnvironmentDTO.environmentFile2)
              }
              if (this.formData.soOrderEnvironmentDTO.environmentFile3){
                this.showEnvironmentFile.push(this.formData.soOrderEnvironmentDTO.environmentFile3)
              }

            }
            if (this.dealType == 'orderEdit' && this.formData.areaId != null && this.formData.areaId != '') {
              this.$http({
                url: api.basArea.echoAddressUrl,
                method: 'post',
                data: { id: this.formData.areaId }
              }).then(res => {
                this.areaOption = res.data.data.options
                this.areaValues = res.data.data.values
              })
            }
          }).catch(() => {
            this.$mask.close()
          })
        } else {
          this.enabled = true;
        }
      },

      async toInitiateAppeal(userType) {
        try {
          this.loading = true;
          // 发送请求
          if (userType == 'site') {
            const res = await axios.post(api.soOrder.toInitiateAppeal, {
              appealType: 1,
              orderId: this._dataId,
              appealRemark: this.form2.appealRemark,
              piclist: this.fileList
            });
            if (res.data) {
              // 确保 el-drawer 组件已经初始化完成再关闭该窗口
              // this.$nextTick(() => {
              //   this.$refs.drawer.closeDrawer();
              // });
              this.$message.success('操作成功！');
              this.fileList = [];
              this.form2.appealRemark = '';
              this.cancelForm()
              this.getData();
            } else {
              this.$message.error('操作失败，请稍后重试');
            }
          } else if (userType == 'org') {
            const res = await axios.post(api.soOrder.toInitiateAppeal, {
              appealType: 2,
              radio: this.radio,
              orderId: this._dataId,
              appealRemark: this.form2.appealRemark,
              piclist: this.fileList
            });
            if (res.data) {
              // 确保 el-drawer 组件已经初始化完成再关闭该窗口
              // this.$nextTick(() => {
              //   this.$refs.drawer.closeDrawer();
              // });
              this.$message.success('操作成功！');
              this.fileList = [];
              this.form2.appealRemark = '';
              this.cancelForm()
              this.getData();
            } else {
              this.$message.error('操作失败，请稍后重试');
            }
          } else if (userType == 'company') {
            const res = await axios.post(api.soOrder.toInitiateAppeal, {
              appealType: 3,
              radio: this.radio,
              orderId: this._dataId,
              appealRemark: this.form2.appealRemark,
              piclist: this.fileList
            });
            if (res.data) {
              // 确保 el-drawer 组件已经初始化完成再关闭该窗口
              // this.$nextTick(() => {
              //   this.$refs.drawer.closeDrawer();
              // });
              this.$message.success('操作成功！');
              this.fileList = [];
              this.form2.appealRemark = '';
              this.cancelForm()
              this.getData();
            } else {
              this.$message.error('操作失败，请稍后重试');
            }
          }
        } catch (error) {
          // console.error(error);
          // this.$message.error('系统错误，请稍后重试');
        } finally {
          this.loading = false;
        }
      },
      handleClose(done) {
        if (this.loading) {
          return;
        }
        this.$confirm('是否关闭操作窗？')
          .then(_ => {
            // this.loading = true;
            done();
            this.cancelForm()
            // this.timer = setTimeout(() => {
            //   done();
            //   // 动画关闭需要一定的时间
            //   setTimeout(() => {
            //     // this.loading = false;
            //     this.cancelForm()
            //   }, 400);
            // }, 1000);
          })
          .catch(_ => {
            this.cancelForm()
          });
      },
      preconditionconfirm(rows) {
        if (rows.length > 0) {

          const tableData = this.table_type;
          const map = {};
          tableData.forEach(function (item) {
            map[item.preconditionId] = 1;
          });
          var items = [];
          rows.forEach((row, index) => {
            const item = {
              preconditionId: row.id,
              typeName: row.precondition
            };
            if (!map[item.preconditionId]) {
              items.push(item);
            }
          });
          this.table_type = this.table_type.concat(items);
        }
      },
      // 删除所选的数据  2表
      handleDelete1_2(index) {
        this.tenant.snCompanyOrderAttributeDTOS.splice(index, 1);
      },
      AddListRow1_2() {

        this.tenant.snCompanyOrderAttributeDTOS.push({})
      },

      //申诉上传图片操作
      handleSuccessAppeal(res, file, fileList) {
        this.fileList.push(res.data.url)
      },
      handleRemoveAppeal(file, fileList) {
        console.log(file, fileList);
      },
      handlePreviewAppeal(file) {
        console.log(file);
      },
      handleExceedAppeal(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemoveAppeal(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },


      // 上传成功
      handleSuccess(response, file) {
        // 上传成功后，隐藏上传按钮
        this.upload_btn = true;
        // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
        // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)

      },
      handleRemove(response, file) {
        // 上传成功后，显示上传按钮
        this.upload_btn = false;
      },

      // 上传成功
      handleSuccess4(res, file, picIndex) {
        // 上传成功后，隐藏上传按钮
        this.upload_btn4 = true;
        // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
        Vue.set(this.tenant.businessPhoto,)

      },
      handleRemove4(response, file) {
        // 上传成功后，显示上传按钮
        this.upload_btn4 = false;
      },
      handleDelete2(index) {
        this.table_area.splice(index, 1);
      },
      handleDelete(index) {
        this.table_type.splice(index, 1);
      },

      //网点接单
      siteAccept(row) {
        this.$baseConfirm('是否确认接单？').then(() => {
          this.$http({
            url: api.soOrder.siteAcceptUrl,
            method: 'post',
            data: {
              id: this._dataId,
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            if (this.currentIsSite) {
              // 网点端不跳转
              this.getData()
              this.$emit('flushPage')
            } else {
              // this.$emit('editViewDataUpdate')// 需要刷新页面
        this.getData();

            }
          })
        });
      },


      //简易完工
      simpleFinishOrderMed(row) {
        this.$baseConfirm('是否确认简易完工？').then(() => {
          this.$http({
            url: api.soOrder.simpleFinishOrderUrl,
            method: 'post',
            data: {
              id: this._dataId,
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            if (this.currentIsSite) {
              // 网点端不跳转
              this.getData()
              this.$emit('flushPage')
            } else {
              // this.$emit('editViewDataUpdate')// 需要刷新页面
              this.getData();
            }
          })
        });
      },

      // 派工程师
      closeDispatchEngineer(type) {
        console.log("派工程师右浮框关闭了111");

        this.dispatchEngineerDialog = false;

          // this.reload()// 需要刷新页面
          this.getData();


      },

      //关闭挂起
      closeOrderDialogChonce(type){
        this.showSuspendDialog = false;
        if (type == 1) {
          this.getData();
        }
        this.$mask.close()
      },

      closeReplaceBarcodeDialog(type){
        this.showReplaceBarcodeDialog = false;
        if (type == 1) {
          this.getData();
        }
        this.$mask.close()
      },

      // 网点接单
      closedispatchedAccept(type) {
        this.siteAcceptDialogShow = false;
        if (type == 1) {
          // this.$emit('editViewDataUpdate')// 需要刷新页面
        this.getData();
        }
      },
      //重新处理
      reDeal() {
        this.$baseConfirm('是否确认重新处理？').then(() => {
          this.$http({
            url: api.soOrder.reDealUrl,
            method: 'post',
            data: {
              id: this._dataId,
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            if (this.currentIsSite) {
              // 网点端不跳转
              this.getData()
              this.$emit('flushPage')
            } else {
              // this.$emit('editViewDataUpdate')// 需要刷新页面
              this.getData();
            }
          })
        });
      },
  //上门设计单完工后一键生成安装单
      generateOrderMed(row) {
        this.$baseConfirm('是否确认一键生成安装工单？').then(() => {
          this.$http({
            url: api.soOrder.generateOrderUrl,
            method: 'post',
            data: {
              id: this._dataId,
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.flushed()// 需要刷新页面
          })
        });
      },
      //生成异常工单
      createOrderAbnormal(){
        this.$baseConfirm('您确定要生成异常工单吗？').then(() => {
            this.$mask.open()
            this.$http({
              url: api.soOrderAbnormal.createOrderAbnormalUrl,
              method: 'post',
              data: {
                orderId: this._dataId,
              }
            }).then(res => {
              this.$message({
                type: res.data.type,
                message: res.data.content
              });
              this.$mask.close()
              this.flushed()// 需要刷新页面
            })
        })
      },
      //服务商驳回完工
      doSiteRejectOrder(){
        this.orderRemarkParam.orderId = this.formData.id
        this.showSiteRejectOrder = true
      },
      doSiteRejectFinish(type){
        this.showSiteRejectOrder = false
        if(type == 1){
          this.getData();
        }
      },
      //挂起
      closeSuspendOrderDialog(type){
        this.showSuspendDialog = false;
        this.flushed()// 需要刷新页面
        this.$mask.close()
      },
      // 网点退单
      closedispatchedBack(type) {
        this.backOrderDialogShow = false;
        if (type == 1) {
          // this.$emit('editViewDataUpdate')// 需要刷新页面
        this.getData();

        }
      },
      // 网点关单
      closeOrderDialog(type) {
        this.showSiteCloseOrderDialog = false;
        if (type == 1) {
          // this.$emit('editViewDataUpdate')// 需要刷新页面
        this.getData();

        }
      },

      //派下级商
      closeSubcontractor(type) {
        this.subcontractorDialog = false;
        if (type == 1) {
          // this.reload()// 需要刷新页面
          this.getData();

        }
      },
      //取消挂起
      cancelOrder(row) {
        this.$baseConfirm('您确定要取消挂起工单吗？').then(() => {
          this.$http({
            url: api.soOrder.cancelOrderUrl,
            method: 'post',
            data: {
              id: this._dataId,
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            // this.reload()// 需要刷新页面
          this.getData();

          })
        });
      },
      //完工
      closeCompletionDialog(type) {
        this.completionDialog = false;
        // this.$emit('editViewDataUpdate')// 需要刷新页面
        this.getData();


        if (type == 1) {
          // this.reload()// 需要刷新页面
          this.getData();

        }
      },
      //上门设计完工
      closeDesignCompletionDialog(type) {
        this.designCompletionDialog = false;
        // this.$emit('editViewDataUpdate')// 需要刷新页面
        this.getData();


        if (type == 1) {
          // this.reload()// 需要刷新页面
          this.getData();

        }
      },
      //确认完工
      closeCompletComfirmDialog(type) {
        this.completComfirmDialog = false;
        if (type == 1) {
          // this.reload()// 需要刷新页面
          this.getData();

        }
      },
      completionDialogCheck(){
        this.$mask.open()
        if(this.formData.soOrderProcessDTO.bookDatePeriod === null || this.formData.soOrderProcessDTO.bookDatePeriod === '') {
          this.$mask.close()
          this.$message.error('完工前请先完成终约！')
          return false;
        }
        if((this.formData.engineerId==null||this.formData.engineerId==0)){
          this.$mask.close()
          this.$message.error('完工前必须指派师傅！')
          return false;
        }
        if((this.formData.userMobile==null||this.formData.userMobile.length>12)){
          this.$mask.close()
          this.$message.error('请先将虚拟号码修改为真实号码！')
          return false;
        }
        this.$http({
          url: api.soOrder.JDOrderFinishCheck,
          method: 'post',
          data: {
            id: this._dataId,
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$mask.close()
            if (this.formData.stat == 61){
              this.orderRemarkParam.rejectFinishTimes = this.formData.rejectFinishTimes
            }
            if(this.formData.serverTypeName=='上门设计'){
              this.designCompletionDialog = true;
            }else {
              this.completionDialog = true;
            }
          }
        }).catch(error => {
          this.$mask.close()
        })
      },
      checkBillCommit(type) {
        this.showCheckBillDialog = false;
        if (type == 1) {
          // this.reload()// 需要刷新页面
          this.getData();

        }
      },

      // 第一个  表格
      formatter(row, column) {
        return row.isNeedReturn == 1 ? '是' : '否'
      },
      formatter1(row, column) {
        return row.isCheck == 1 ? '是' : '否'
      },
      formatter2(row, column) {
        return row.isPast == 1 ? '是' : '否'
      },
      formatter3(row, column) {
        if (row.afterFlow == 1) {
          return "必访"
        } else if (row.afterFlow == 2) {
          return '申诉'
        } else if (row.afterFlow == 3) {
          return '挂起'
        } else if (row.afterFlow == 4) {
          return '重新完工'
        } else if (row.afterFlow == 9) {
          return '关闭'
        }

      },
      formatter4(row, column) {
        return row.offAccounting == 1 ? "是" : "否"
      },
      // 卡片事件
      //点击查看图片
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
        // console.log(fileList, "已上传文件")
      },
      // 上传发生变化钩子
      // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
      handleimageChange(file, fileList) {
        this.upload_img = fileList;
        // this.upload_img.imageName=fileList.name;
        console.log(fileList, "文件状态改变时")
        console.log(file, "文件状态改变时file")
      },
      createOrderMethod(row) {
        this.$router.push({
          path: '/workorder/orderaccess/access/index', // 更新为动态路由格式
          query: { orderId:this._dataId,showEdit:true,oldServiceTypeName:this.formData.serverTypeName },
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  #containt .detail-wrap .d-header {
    margin: -6px 0px 0 -12px !important;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-cascader-panel {
    .el-radio__inner {
      border: 0px;
      background: transparent;
    }

    .el-radio__input.is-checked .el-radio__inner {
      background: none;
    }

    .el-radio {
      height: 100%;
      width: 150px;
      position: absolute;
      z-index: 10;
    }
  }

  .header_dialog {
    border-radius: 8px !important;
    height: 800px !important;
  }

  el-dialog {
    border-radius: 8px !important;
    box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
  }

  v::deep .el-upload .el-upload--picture-card {
    position: relative;
    left: -200px;
  }

  // 单选框
  .radio_item {
    width: 24%;
    margin-top: 10px;
    margin-bottom: 10px !important;

    >span {
      display: inline-block;
      width: 120px;
      margin-right: 13px;
      text-align: right;
      font-weight: 400;
      color: rgba(86, 86, 86, 0.96);
      font-size: 12px;
    }
  }

  .firm {
    .el-input {
      width: 150px;
    }
  }

  .type_title {
    font-weight: 400;
    text-align: right;
    width: 112px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }

  .type_select {
    width: 120px;
    text-align: center;
  }

  .type_brand {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    >div {
      margin: 16px 0;
      width: 25%;
    }
  }

  // 备注的样式
  .annotate {
    padding: 0px !important;
    height: 28px !important;
    min-height: 28px !important;
  }

  .el-textarea__inner {
    padding: 0px !important;
    height: 28px !important;
    min-height: 28px !important;
  }

  // 装图片的  大框
  ::v-deep.table-detail .el-upload--picture-card {
    // margin-top: 10px;
    width: 40px;
    height: 40px;
    line-height: 50px !important;
  }

  ::v-deep .el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 40px;
    height: 40px;
    margin-right: 14px;
    border-radius: 2px;
    padding: 0 !important;
    border-color: #e8e8e8;
    margin-top: 0;
    margin-bottom: 10px;
  }

  ::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
    width: 40px;
    height: 40px;
    padding: 0 !important;
    position: inherit;
    cursor: pointer;
  }

  ::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
    display: none !important;
  }

  // witch 开关  标题的宽度
  .el-switch__label * {
    line-height: 1;
    width: 160px !important;
    display: inline-block;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }

  // 清楚表格 默认padding
  .el-table--medium .el-table__cell {
    padding: 0px 0 !important;
  }

  .table_item {
    .el-table__row:hover>td {
      background-color: #D4E7FF !important;
    }
  }

  .pic_item {

    .el-upload--picture-card {
      margin-top: 1px;
      width: 36px !important;
      height: 36px !important;
      line-height: 46px !important;
    }
  }

  // 卡片样式
  .card_item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;


    .el-card__header {
      padding: 10px 20px 5px;
      border-bottom: 1px dashed #7a7e7c;
      font-weight: 600;
      font-size: 13px;
    }

    .el-card__body,
    .el-main {
      padding: 10px 20px;
    }

    .text {
      font-size: 12px;
    }

    .item {
      margin-bottom: 12px;
      display: block;
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }

    .clearfix:after {
      clear: both
    }

    .box-card {
      width: 30%;
      margin-right: 30px;
      margin-bottom: 30px;
      border: 1px solid #ccc !important;
    }
  }

  .papers {
    margin-left: 30px;
    position: absolute;

    ::v-deep.el-upload-list .el-upload-list__item {
      display: inline-block;
      width: 147px !important;
      margin-right: 14px;
      border-radius: 2px;
      border-color: #e8e8e8;
      margin-top: 7px;
      margin-left: 15px;
      padding: 0px !important;
      background-color: #e1e1e1;
      height: 20px;
    }

  }

  .btn_zdy {
    margin: 10px 0;
    border: 1px solid #dcdfe6 !important;
    border-color: #dcdfe6 !important;
    color: #606266 !important;
    font-weight: 400;
    text-align: center;
    background-color: #FBFBFB !important;
  }

  .btn_zdy:hover {
    color: #2A6494 !important;
    border: 1px solid #2A6494 !important;
  }

  .btn_zdy2 {
    // 选取文件合同按钮
    // margin: 10px 60px;
    margin-top: 6px;
    border: 1px solid #dcdfe6 !important;
    border-color: #dcdfe6 !important;
    color: #606266 !important;
    font-weight: 400;
    text-align: center;
    background-color: #FBFBFB !important;
  }

  .btn_zdy2:hover {
    color: #2A6494 !important;
    border: 1px solid #2A6494 !important;
  }

  ::v-deep .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 0 0 0px !important;
  }

  // 步骤条
  ::v-deep .el-card__body,
  .el-main {
    padding: 0px !important;
    font-size: 12px;
  }

  .task {
    color: #62f382;
  }

  .card {
    padding: 0px 5px;
    background-color: #efefef;
  }

  .title_icon1 {
    display: inline-block;
    background: rgba(42, 100, 148, 0.16);
    width: 19px;
    background-color: #409EFF;
    color: #fff;
    text-align: center;
    margin-bottom: 15px;
  }

  .title_icon {
    display: inline-block;
    background: rgba(42, 100, 148, 0.16);
    width: 19px;
    background-color: #2a6494;
    color: #fff;
    text-align: center;
    margin-bottom: 15px;
  }

  ::v-deep .el-timeline-item__node {
    background-color: #ffffff !important;
    border: 1px solid #0550ef;
  }

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  .bread {
    span {
      color: rgba(86, 86, 86, 0.96) !important;
    }

    ::v-deep .el-collapse-item__content {
      padding-bottom: 0px;
      background-color: #efefef;

    }
  }

  .el-timeline {
    margin-top: 40px;
    margin: 0;
    list-style: none;
    margin-left: 6px;
    border: 1px solid #fbfbfb;
    padding-top: 12px;
    height: 72.5vh;
    overflow-y: scroll;
    background-color: #f2f2f2;
    padding-left: 10px !important;
  }

  .card_bread {

    position: relative !important;
  }

  ::v-deep .el-tabs__content {
    overflow: visible !important;

  }

  #containt .detail-wrap .d-cont {
    overflow: unset !important;
  }

  // .el-timeline-item {
  //   position: relative;
  //   padding-bottom: 0px !important;
  //   margin-left: 47px;
  // }
  .el-timeline-item[data-v-2cf56cc1] {
    position: relative;
    margin-left: 5px;
    padding-bottom: 0px !important;
  }

  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }

  .el-timeline[data-v-2cf56cc1] {
    position: relative !important;
  }

  #containt .detail-wrap .d-cont .d-item {
    border: solid 1px #e9e9e9;
    padding: 0 12px 6px;
    position: relative !important;
  }

  ::v-deep .el-collapse-item__arrow {
    position: absolute !important;
    top: 12px !important;
    right: 0 !important;
    font-size: 18px;
    color: #2a6494 !important;
  }

  .btn_zdy {
    border: 1px solid #dcdfe6 !important;
    border-color: #dcdfe6 !important;
    color: #606266 !important;
    font-weight: 400;
    text-align: center;
    background-color: #FBFBFB !important;
  }

  .btn_zdy:hover {
    color: #2A6494 !important;
    border: 1px solid #2A6494 !important;
  }


  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px !important;
  }


  // 本单费用位置
  .expense {
    position: absolute;
    // right: 20%;
    margin-top: 5px;
    color: #2a6494;
    font-size: 13px;
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 75px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 步骤条
  .el-steps--simple {
    margin: -5px 0 -5px;
  }

  .el-step.is-simple {
    width: 11vw;
  }

  .audit {
    span {
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;
    }
  }

  // 卡片样式
  .card_item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;


    .el-card__header {
      padding: 10px 20px 5px;
      border-bottom: 1px dashed #7a7e7c;
      font-weight: 600;
      font-size: 13px;
    }

    .el-card__body,
    .el-main {
      padding: 10px 20px;
    }

    .text {
      font-size: 12px;
    }

    .item {
      margin-bottom: 12px;
      display: block;
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }

    .clearfix:after {
      clear: both
    }

    .box-card {
      width: 30%;
      margin-right: 30px;
      margin-bottom: 30px;
      border: 1px solid #ccc !important;
    }
  }

  // 折叠样式对其
  // .table-detail {
  //   tr{
  //     display:block;
  //   }
  // }
  #containt .table-detail tbody tr th {
    display: table-cell;
    vertical-align: middle;
  }

  #containt .table-detail tbody tr td {

    display: table-cell;
    vertical-align: middle;
  }

  .title_time {
    margin-top: -13px;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .span1 {
      color: #2a6494 !important;
      width: 35%;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .span2 {
      margin-right: 5px;
      // white-space: nowrap;
      // overflow: hidden;
      // text-overflow: ellipsis;
    }

  }


  // 字段之间的距离
  #containt .table-detail tbody tr td {
    padding: 5px 12px;
    width: 172.2px;
    height: 27.2px !important;
    word-break: break-word;
  }

  .information {
    padding: 4px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
  }

  #containt .table-detail tbody tr th {
    width: 7vw !important;
  }

  #containt .table-detail tbody tr td {
    width: 10vw !important;
    padding: 0 0 0 7px !important;
    ;
  }

  ::v-deep .el-step__title {
    font-size: 11px;
    line-height: 25px;
  }

  #containt .detail-wrap .d-cont .d-item {
    padding: 5px 0 !important;
  }

  .gather .el-tab-pane {
    margin-top: 10px;
    // padding: 20px 0;

    >>>.el-tabs__active-bar {
      left: 20px !important;
    }

    .el-tabs__nav {
      margin-left: 20px !important;
    }
  }

  #containt .title b {
    margin-left: 0px !important;
  }

  ::v-deep .product th:after {
    display: none !important;
  }

  ::v-deep .product td {
    padding: 5px 0 !important;

  }

  ::v-deep .vxe-table--render-default .vxe-cell {
    text-align: left !important;
  }

  .el-image {
    border: dashed 1px #e2e2e2;
    margin-right: 20px;
  }

  .undergo {
    ::v-deep .el-card.is-always-shadow {
      background-color: #f2f2f2;
      position: relative;
    }

    .el-timeline {
      background-color: #fff;
      padding-left: 10px !important;
      height: 100% !important;
    }



  }

  .title_p {
    margin-top: 0;
    line-height: 28px;
    font-size: 16px;
    // width: 90px;
    white-space: nowrap;
    font-weight: 600;
    /* margin-right: 84px; */
    vertical-align: middle;
    color: #2a6494;
    position: relative;
    z-index: 2;
    background: rgba(42, 100, 148, 0.16);
    /* margin-left: -12px; */
    padding-left: 12px;
    padding-right: 14px;
    border-radius: 0 28px 28px 0;
  }

  .Instructions {
    text-decoration: underline;
    color: #2a6494;
    margin-left: 5px;
  }

  ::v-deep .el-image {
    width: 60px !important;
    height: 60px !important;
  }

  .more {
    position: absolute;
    margin-top: 5px;
    right: 10%;
    color: #2a6494;
    font-size: 13px;
  }

  .Null_data {
    text-align: center;
    margin: 10px 0;
  }
  ::v-deep .vxe-table--render-default .vxe-body--column.col--ellipsis>.vxe-cell, .vxe-table--render-default .vxe-footer--column.col--ellipsis>.vxe-cell, .vxe-table--render-default .vxe-header--column.col--ellipsis>.vxe-cell {
      max-height: 150px!important;
  }
  ::v-deep .down{
    color: #009688;
  }
  ::v-deep .detail-wrap .d-header {
    padding: 0px 0px 0 14px !important;

  }


  .el-dropdown {
      vertical-align: top;
    }
    .el-dropdown + .el-dropdown {
      margin-left: 15px;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
    .fuJian{
      color: #268AEA;
    }
  .row-max-height {
    max-height: 100px; /* 设置你想要的行最大高度 */
    overflow: auto; /* 如果内容超过最大高度，显示滚动条 */
  }
  </style>
